import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import { notaCxPPorId } from "../../CXP/NotasCxP/notaCxPPDF";
import { entradaSinTallasPorEntrada } from "../../CXP/NotasCxP/entradaSinTallasPDF";
import Baja from "../../Baja";
// (2026-07) autocomplete para buscar la habilitación al entregar
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Status from "../../Status";
import moment from "moment";

function ListadoCortes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_CORTES = process.env.REACT_APP_URL_CORTES;
  // L111-fix — catálogo completo de colores para el alta de talla/color
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  // L7 (2026-06) — editar corte
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_ARTICULOS_CORTES = process.env.REACT_APP_URL_ARTICULOS_CORTES;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  // L111 (2026-06) — agregar talla/color del mismo artículo en el modal Editar Cantidades
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_ARTICULOS_PROCESOS_SALIDA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const URL_PROCESOS_ENTRADA = process.env.REACT_APP_URL_PROCESOS_ENTRADA;
  const URL_ARTICULOS_PROCESOS_ENTRADA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_ENTRADA;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_HABILITACION_CORTES = process.env.REACT_APP_URL_HABILITACION_CORTES;
  const URL_DETALLE_HABILITACION_CORTES = process.env.REACT_APP_URL_DETALLE_HABILITACION_CORTES;
  const URL_FALTANTES_PROVEEDORES = process.env.REACT_APP_URL_FALTANTES_PROVEEDORES;
  const URL_ENTRADAS_ALMACEN = process.env.REACT_APP_URL_ENTRADAS_ALMACEN;
  const URL_ENTRADAS_ALMACEN_ACUMULADOS = process.env.REACT_APP_URL_ENTRADAS_ALMACEN_ACUMULADOS;
  const ALMACEN = process.env.REACT_APP_ALMACEN;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_CATALOGO_PROCESOS = process.env.REACT_APP_URL_CATALOGO_PROCESOS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];
  const [cortes, setCortes] = useState([]);

  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [areasEntrada, setAreasEntrada] = useState("632cde6807fae9155c1740e8");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  // TG2 — filtro Liberado ("" = Todos)
  const [selectedLiberado, setSelectedLiberado] = useState("");

  const [selectedCorte, setSelectedCorte] = useState("");
  const [selectedCorteNumero, setSelectedCorteNumero] = useState("");

  // (2026-07) editar salida de proceso (encabezado + cantidades)
  const [modalEditSalida, setModalEditSalida] = useState(false);
  const toggleEditSalida = () => setModalEditSalida(!modalEditSalida);
  const [editSalidaId, setEditSalidaId] = useState("");
  const [editSalidaProveedor, setEditSalidaProveedor] = useState("");
  const [editSalidaFechaComp, setEditSalidaFechaComp] = useState("");
  const [editSalidaPrecio, setEditSalidaPrecio] = useState(0);
  const [editSalidaItems, setEditSalidaItems] = useState([]);
  // (2026-10) agregar a la salida tallas del corte que no se mandaron
  const [editSalidaCorte, setEditSalidaCorte] = useState("");
  const [editSalidaPedido, setEditSalidaPedido] = useState("");
  const [editSalidaDisponibles, setEditSalidaDisponibles] = useState([]);
  const [editSalidaAgregar, setEditSalidaAgregar] = useState("");
  // (2026-07) Editar Entrada de Proceso (financiero: NotaCxP + saldos proveedor)
  const [modalEditEntrada, setModalEditEntrada] = useState(false);
  const toggleEditEntrada = () => setModalEditEntrada(!modalEditEntrada);
  const [editEntradaId, setEditEntradaId] = useState("");
  const [editEntradaProveedor, setEditEntradaProveedor] = useState("");
  const [editEntradaProveedorOrig, setEditEntradaProveedorOrig] = useState("");
  const [editEntradaFecha, setEditEntradaFecha] = useState("");
  const [editEntradaPrecio, setEditEntradaPrecio] = useState(0);
  const [editEntradaItems, setEditEntradaItems] = useState([]);
  // nota ligada { _id, total_costo, saldo, impuestos }
  const [editEntradaNota, setEditEntradaNota] = useState(null);
  const [modalProcesosSalida, setModalProcesosSalida] = useState(false);
  const toggleProcesosSalida = () =>setModalProcesosSalida(!modalProcesosSalida);
  const [articulosCortes, setArticulosCortes] = useState([]);
  const [articulosProcesosSalida, setArticulosProcesosSalida] = useState([]);
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [idCatalogoProcesos, setIdCatalogoProcesos] = useState("");
  const [nombreProcesosSalida, setNombreProcesosSalida] = useState("");
  const [idArticulo, setIdArticulo] = useState("");
  const [nombreArticulo, setNombreArticulo] = useState("");
  const [idPedido, setIdPedido] = useState("");
  const [numeroPedido, setNumeroPedido] = useState("");
  const [modalFuncionProcesosSalida, setModalFuncionProcesosSalida] = useState(false);
  const toggleFuncionProcesosSalida = () => setModalFuncionProcesosSalida(!modalFuncionProcesosSalida);
  const [fechaProceso, setFechaProceso] = useState(endDate);
  const [fechaCompromisoProceso, setFechaCompromisoProceso] = useState(endDate);
  const [maquileroProceso, setMaquileroProceso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [precioProceso, setPrecioProceso] = useState(0);
  const [proveedores, setProveedores] = useState([]);
  const [totalPiezas, setTotalPiezas] = useState(0);
  const [totalPiezasFaltantes, setTotalPiezasFaltantes] = useState(0);
  const [totalPiezasSegundas, setTotalPiezasSegundas] = useState(0);
  const [totalGeneral, setTotalGeneral] = useState(0);
  const [fechaCancelacion, setFechaCancelacion] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);

  const [fecha, setFecha] = useState(endDate);
  const [plazo, setPlazo] = useState("");

  const [numero_corte, setNumeroCorte] = useState("");

  const [idEdit, setIdEdit] = useState("");

  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [articulosEntrada, setArticulosEntrada] = useState([]);
  const [articulosUnicosEntrada, setArticulosUnicosEntrada] = useState([]);
  const [nombreProcesosEntrada, setNombreProcesosEntrada] = useState("");
  const [articulosProcesosEntrada, setArticulosProcesosEntrada] = useState([]);
  const [selectedProcesoSalida, setSelectedProcesoSalida] = useState("");

  const [modalProcesosEntrada, setModalProcesosEntrada] = useState(false);
  const toggleProcesosEntrada = () =>
    setModalProcesosEntrada(!modalProcesosEntrada);
  const [modalFuncionProcesosEntrada, setModalFuncionProcesosEntrada] =
    useState(false);
  const toggleFuncionProcesosEntrada = () =>
    setModalFuncionProcesosEntrada(!modalFuncionProcesosEntrada);
      const [factura, setFactura] = useState("NA");
      const [impuestos, setImpuestos] = useState(0);
      const [composturas, setComposturas] = useState(0);

  const [entregaHabilitacion, setEntregaHabilitacion] = useState(false);
  const [habilitacion, setHabilitacion] = useState([]);

  const [modalFaltante, setModalFaltante] = useState(false);
  const toggleFaltante = () => setModalFaltante(!modalFaltante);
  const [precioFaltante, setPrecioFaltante] = useState(0);
  const [precioFaltanteHab, setPrecioFaltanteHab] = useState(0);
  const [cantidadFaltante, setCantidadFaltante] = useState(0);
  const [cantidadFaltanteHab, setCantidadFaltanteHab] = useState(0);
  const [totalFaltante, setTotalFaltante] = useState(0);
  const [totalTotalFaltante, setTotalTotalFaltante] = useState(0);
  const [totalFaltanteHab, setTotalFaltanteHab] = useState(0);
  const [procesoSalidaFaltante, setProcesoSalidaFaltante] = useState("");
  const [idMaquileroFaltante, setIdMaquileroFaltante] = useState("");
  const [fechaFaltante, setFechaFaltante] = useState(endDate);

  const [articuloProceso, setArticuloProceso] = useState("");

  const [modalEntradaAlmacen, setModalEntradaAlmacen] = useState(false);
  const toggleEntradaAlmacen = () =>
    setModalEntradaAlmacen(!modalEntradaAlmacen);
  const [articulosCortesEntrada, setArticulosCortesEntrada] = useState([]);
  const [articulosUnicosEntradaAlma, setArticulosUnicosEntradaAlma] = useState(
    []
  );
  const [codigoSAT, setCodigoSAT] = useState("");
  const [codigoUnidad, setCodigoUnidad] = useState("PZ");
  const [totalPiezasEntradaAlma, setTotalPiezasEntradaAlma] = useState(0);
  const [totalPiezasEntradaSegundasAlma, setTotalPiezasEntradaSegundasAlma] =
    useState(0);
  const [fechaEntradaAlma, setFechaEntradaAlma] = useState(endDate);

  const [PDFPS, setPDFPS] = useState([]);
  const [modalPDFPS, setModalPDFPS] = useState(false);
  const togglePDFPS = () => setModalPDFPS(!modalPDFPS);

  const [PDFPE, setPDFPE] = useState([]);
  const [modalPDFPE, setModalPDFPE] = useState(false);
  const togglePDFPE = () => setModalPDFPE(!modalPDFPE);
  // (2026-10) corte de los modales de detalle de salidas / entradas, para
  // refrescarlos en su lugar después de editar o cancelar
  const [corteDetallePS, setCorteDetallePS] = useState("");
  const [corteDetallePE, setCorteDetallePE] = useState("");

  const [editHab, setEditHab] = useState([]);
  const [modalEditHab, setModalEditHab] = useState(false);
  const toggleEditHab = () => setModalEditHab(!modalEditHab);

  const [modalHabilitacion, setModalHabilitacion] = useState(false);
  const toggleHabilitacion = () => setModalHabilitacion(!modalHabilitacion);
  const [idProcesosSalidaHab, setIdProcesosSalidaHab] = useState("");
  const [idCorteHab, setIdCorteHab] = useState("");
  const [idPedidoHab, setIdPedidoHab] = useState("");
  const [idProveedorHab, setIdProveedorHab] = useState("");
  const [fechaHab, setFechaHab] = useState(hoy);

  const [foto, setFoto] = useState("");

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      // idSucursal: "",
      // sucursal: "",
      idAreaCliente: "",
      areaCliente: "",
      colores: "",
      idColor: "",
      tallas: "",
      idTalla: "",
      cantidad: 0,
      faltantes: 0,
      segundas: 0,
      total: 0,
      idArticulo: "",
      articulosPedido: "",
    },
  ]);

  const [inputFieldsHabilitacion, setInputFieldsHabilitacion] = useState([
    {
      id: uuidv4(),
      idHabilitacion: "",
      cantidad: 0,
    },
  ]);

  const [statusHabilitacionEdit, setStatusHabilitacionEdit] = useState("");
  const [modalStatusEdit, setModalStatusEdit] = useState(false);
  const toggleStatusEdit = () => setModalStatusEdit(!modalStatusEdit);

  //--- Pagination
  const [comments, setComments] = useState([]);
  // (2026-08) { idPedido: "AREA 1, AREA 2" } para buscar por área en el search
  const [areasPorPedido, setAreasPorPedido] = useState({});

  // L7 (2026-06) — editar Cantidades del Corte (por línea: talla / color / área)
  const [modalEditCorte, setModalEditCorte] = useState(false);
  const toggleEditCorte = () => setModalEditCorte(!modalEditCorte);
  const [editIdCorte, setEditIdCorte] = useState("");
  const [editNumeroCorte, setEditNumeroCorte] = useState("");
  const [editLineItems, setEditLineItems] = useState([]);
  // (2026-09) observaciones del corte (las que se capturan en CortesCreate),
  // editables desde este mismo modal
  const [editObsCorte, setEditObsCorte] = useState("");
  const [editObsCorteOriginal, setEditObsCorteOriginal] = useState("");
  // L111 (2026-06) — agregar talla/color al corte. En cortes el combo DEBE existir
  // en ArticulosOrdenesCorte (la orden): se elige de ahí, solo los que aún no están
  // en el corte. No se crea un AOC nuevo.
  const [aocDisponiblesCorte, setAocDisponiblesCorte] = useState([]); // combos de la orden no presentes en el corte
  const [aocSeleccionadoCorte, setAocSeleccionadoCorte] = useState(""); // _id del AOC elegido
  const [agregarCorteCantidad, setAgregarCorteCantidad] = useState("");
  const [editCorteOrden, setEditCorteOrden] = useState(""); // L111-fix4 — orden canónica del corte (Cortes.ordenesCorte)
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  // (2026-10) Carga del listado con las fechas del filtro. Se llama al montar /
  // cambiar fechas y después de cada acción, en lugar de recargar la página.
  function cargarCortes() {
    return axios
      .get(`${URL_CORTES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCortes = response.data;
        // Array para pagination
        let arrayTabla = allCortes
          .sort((a, b) => (a.idCorte > b.idCorte ? 1 : -1))
          .map((a) => {
            try {
              const oc = a.ordenesCorte?.[0];
              const ped = oc?.pedidos?.[0];
              const cli = ped?.clientes?.[0];
              const art = oc?.articulos?.[0];

              return {
                _id: a._id,
                numero: a.idCorte,
                fecha: a.fecha,
                total_cantidad: a.total_cantidad,
                ordenCorte: oc?.numero ?? "",
                // fix — la columna/celda/buscador leen numeroInternoOC (= nº interno de la OC)
                numeroInternoOC: oc?.numero ?? "",
                ordenCorteConsecutivo: oc?.idOrdenesCorte ?? "",
                idOrdenCorte: oc?._id ?? "",
                // L19 (2026-06) — Orden de Producción es el autoincrement de OC, no el numero interno
                idOrdenesCorteAuto: oc?.idOrdenesCorte ?? "",
                fechaCancelacionPedido: ped?.fecha_cancelacion ?? "",
                cliente: (() => {
                  // (2026-09) subcliente entre paréntesis, como en ListadoPedidos
                  // (2026-10) y la subárea de la orden, también entre paréntesis
                  const conDato = (v) => {
                    const t = String(v ?? "").trim();
                    return t && t.toUpperCase() !== "NA" ? t : "";
                  };
                  const sub = conDato(ped?.subCliente);
                  const subArea = conDato(oc?.subArea);
                  return [String(cli?.nombre_comercial ?? "").trim(), sub && `(${sub})`, subArea && `(${subArea})`]
                    .filter(Boolean)
                    .join(" ");
                })(),
                // L108 (2026-06) — empresa del pedido (para el logo del PDFOC)
                empresa:
                  ped?.empresas?.[0]?.razonSocial ||
                  ped?.empresas?.[0]?.name ||
                  "",
                // LFISC (2026-07) — objeto empresa completo (razón social + datos fiscales)
                // findOneFechas popula pedidos.empresas → trae rfc/regimenFiscal/direccionFiscal/cp
                empresaObj: ped?.empresas?.[0] || null,
                pedidoCliente: ped?.pedidoCliente ?? "",
                pedido: ped?.idPedido ?? "",
                // L18 (2026-06) — id mongo del pedido para poder fetchear observacionesArticulo
                idPedidoMongo: ped?._id ?? "",
                marca:
                  ped?.marcas?.[0]?.name ||
                  ped?.marcas?.[0]?.nombre ||
                  "",
                monarch: ped?.observacionesMarca ?? "",
                articulo: [
                  art?.codigo,
                  art?.subDepartamentos?.[0]?.name ||
                    art?.subDepartamentos?.[0]?.nombre,
                ]
                  .filter((x) => x && String(x).trim())
                  .join(" - "),
                // cantidad de ESE artículo (de su orden de corte), no el total del pedido
                cantidadPedido: oc?.cantidad ?? 0,
                mesa: a.mesa,
                lienzos: a.lienzos,
                empalmes: a.empalmes,
                retaceria: a.retaceria,
                largoTrazo: a.largoTrazo,
                tiempoInicio: a.tiempoInicio,
                tiempoFin: a.tiempoFin,
                piezas: a.piezas,
                status: a.status,
                is_active: a.is_active,
                observaciones: a.observaciones,
                idArticulo: art?._id ?? "",
                statusHabilitacion: a.statusHabilitacion,
                // TG2 — liberados (usuarios que liberaron) + bandera liberado
                liberados: Array.isArray(a.liberados)
                  ? a.liberados
                      .map((r) => {
                        const u = r?.user || {};
                        const uid = typeof u === "string" ? u : u?._id || "";
                        const nombre =
                          typeof u === "string"
                            ? ""
                            : `${u.nombre || ""} ${u.apellido || ""}`.trim() ||
                              u.email ||
                              "";
                        return {
                          userId: String(uid || ""),
                          nombre,
                          fecha: r?.fecha || "",
                          // (2026-07) observaciones al liberar
                          observaciones: r?.observaciones || "",
                        };
                      })
                      .filter((r) => r.userId)
                  : [],
                // (2026-07) observaciones del último liberado (para la tabla)
                observacionesLiberado:
                  (Array.isArray(a.liberados) &&
                    a.liberados
                      .map((r) => r?.observaciones)
                      .filter(Boolean)
                      .slice(-1)[0]) ||
                  "",
                liberado:
                  Array.isArray(a.liberados) && a.liberados.length > 0 ? "Si" : "No",
                // L7 (2026-06) — campos para editar el corte
                idResponsable1: a.responsable1?.[0]?._id || "",
                idResponsable2: a.responsable2?.[0]?._id || "",
                responsable1Nombre:
                  a.responsable1?.[0]?.nombre
                    ? `${a.responsable1[0].nombre} ${a.responsable1[0].apellido || ""}`.trim()
                    : "",
                responsable2Nombre:
                  a.responsable2?.[0]?.nombre
                    ? `${a.responsable2[0].nombre} ${a.responsable2[0].apellido || ""}`.trim()
                    : "",
              };
            } catch (err) {
              console.warn("Corte con datos incompletos, se omite:", a?._id, err);
              return null;
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setCortes(allCortes);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useMemo(() => {
    cargarCortes();

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_CATALOGO_PROCESOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCatalogoProcesos = response.data;
        setCatalogoProcesos(allCatalogoProcesos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allHabilitacion = response.data;
        // Array para pagination
        let arrayTabla = allHabilitacion
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              nombre: a.nombre,
              unidad: a.unidad,
              observaciones: a.observaciones,
              descripcion: a.descripcion,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setHabilitacion(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const ListaCortes = comments.sort((a, b) => (a.idCorte < b.idCorte ? 1 : -1));

  function PDFTabla() {
    const data = ListaCortes.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha)
      ) {
        return [
          a.ordenCorteConsecutivo,
          a.numero,
          a.fecha,
          a.cliente,
          a.pedidoCliente,
          a.articulo,
          a.total_cantidad,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Cortes`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["orden Corte", "Numero", "Fecha", "Cliente", "Pedido", "Articulo", "Cantidad"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Cortes.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = ListaCortes.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          OrdenCorte: a.ordenCorteConsecutivo,
          Mesa: a.mesa,
          TotalCantidad: a.total_cantidad,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoCortes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoCortes",
        sheetFilter: ["Numero", "Fecha", "OrdenCorte", "Mesa", "TotalCantidad"],
        sheetHeader: ["Numero", "Fecha", "OrdenCorte", "Mesa", "TotalCantidad"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaCortes.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha)
      ) {
        return [a.numero, a.fecha, a.ordenCorteConsecutivo, a.mesa, a.total_cantidad];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Cortes`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Orden de Produccion", "Mesa", "Cantidad"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Cortes",
          email: mailTo,
          fileName: "ListadoCortes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Cortes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        // (2026-10) el correo no cambia datos: solo se cierra el modal
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Articulo", field: "ordenCorteConsecutivo", sortable: true },
    { name: "# Corte", field: "numero", sortable: true },
    { name: "OP", field: "numeroInternoOC", sortable: true },
    { name: "Fecha Corte", field: "fecha", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    // { name: "Pedido Cliente", field: "pedidoCliente", sortable: true },
    { name: "Modelo", field: "articulo", sortable: true },
    // { name: "Marca", field: "marca", sortable: true },
    { name: "Observ. Marca", field: "monarch", sortable: true },
    { name: "Status Habilitacion", field: "statusHabilitacion", sortable: true },

    {
      name: "Fecha Entrega",
      field: "fechaCancelacionPedido",
      sortable: true,
    },
    { name: "Cantidad Cortada", field: "total_cantidad", sortable: true },

    { name: "Cantidad Pedido", field: "cantidadPedido", sortable: true },


    { name: "PDF Corte", field: "PDF", sortable: false },
    { name: "Salida Procesos", field: "Salida Procesos", sortable: false },
    { name: "Entrada Procesos", field: "Entrada Procesos", sortable: false },
    { name: "Liberado", field: "liberado", sortable: true },
    { name: "Entrada Almacen", field: "Entrada Almacen", sortable: false },
    { name: "Status", field: "status", sortable: false },
  ];

  // (2026-08) Áreas dadas de alta en cada pedido, para poder buscarlas en el
  // search del listado. Se pide en bloques para no armar URLs enormes.
  useEffect(() => {
    const ids = [
      ...new Set(comments.map((c) => c.idPedidoMongo).filter(Boolean)),
    ].map(String);

    if (!ids.length) {
      setAreasPorPedido({});
      return;
    }

    let cancelado = false;
    const bloques = [];
    for (let i = 0; i < ids.length; i += 60) bloques.push(ids.slice(i, i + 60));

    Promise.all(
      bloques.map((b) =>
        axios
          .get(`${URL_ARTICULOS_PEDIDO}/areasPedidos/${b.join(",")}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((r) => r.data || {})
          .catch((err) => {
            console.log("areasPedidos err:", err);
            return {};
          })
      )
    ).then((partes) => {
      if (cancelado) return;
      const mapa = {};
      partes.forEach((p) =>
        Object.keys(p).forEach((k) => {
          mapa[k] = (p[k] || []).join(", ");
        })
      );
      setAreasPorPedido(mapa);
    });

    return () => {
      cancelado = true;
    };
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.statusHabilitacion.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidoCliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroInternoOC.toLowerCase().includes(search.toLowerCase()) ||
          (comment.marca || "").toLowerCase().includes(search.toLowerCase()) ||
          (comment.monarch || "").toLowerCase().includes(search.toLowerCase()) ||
          comment.numero.toString().includes(search) ||
          comment.total_cantidad.toString().includes(search) ||
          comment.ordenCorteConsecutivo.toString().includes(search) ||
          comment.cantidadPedido.toString().includes(search) ||
          // (2026-08) áreas dadas de alta en el pedido
          String(areasPorPedido[comment.idPedidoMongo] || "")
            .toLowerCase()
            .includes(search.toLowerCase())
          // ||
          // comment.mesa.toString().includes(search)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    // TG2 — filtro Liberado ("" = Todos)
    if (selectedLiberado) {
      computedComments = computedComments.filter(
        (e) => e.liberado === selectedLiberado
      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "numero" &&
      sorting.field != "total_cantidad" &&
      sorting.field != "cantidadPedido" &&
      sorting.field != "ordenCorte"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "cantidadPedido" ||
        sorting.field == "ordenCorte" ||
        sorting.field == "numero" )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_cantidad" ||
        sorting.field == "cantidadPedido" ||
        sorting.field == "ordenCorte" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedLiberado,
    areasPorPedido,
  ]);

  // TG2 — marcar/quitar "Liberado" del corte (clonado de toggleRecibido de OrdenesCorte)
  async function toggleLiberado(id, liberadosActuales) {
    try {
      const lista = Array.isArray(liberadosActuales) ? liberadosActuales : [];
      const yaMarcado = lista.some(
        (r) => String(r.userId || "") === String(user.id)
      );
      const hoy = moment().format("YYYY-MM-DD HH:mm");

      // (2026-07) al liberar, pedir observaciones (opcional)
      let obsLiberar = "";
      if (!yaMarcado) {
        const resp = await Swal.fire({
          title: "Liberar corte",
          input: "textarea",
          inputLabel: "Observaciones (opcional)",
          inputPlaceholder: "Escribe las observaciones del liberado...",
          showCancelButton: true,
          confirmButtonText: "Liberar",
          cancelButtonText: "Cancelar",
        });
        if (resp.isDismissed) return;
        obsLiberar = resp.value || "";
      }

      let nuevos;
      if (yaMarcado) {
        nuevos = lista
          .filter((r) => String(r.userId || "") !== String(user.id))
          .map((r) => ({
            user: r.userId,
            fecha: r.fecha || "",
            observaciones: r.observaciones || "",
          }));
      } else {
        nuevos = [
          ...lista.map((r) => ({
            user: r.userId,
            fecha: r.fecha || "",
            observaciones: r.observaciones || "",
          })),
          { user: user.id, fecha: hoy, observaciones: obsLiberar },
        ];
      }
      await axios.patch(
        `${URL_CORTES}/${id}`,
        { liberados: nuevos },
        { headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` } }
      );
      await axios.post(
        URL_LOGS,
        {
          tipo: yaMarcado ? "Quitar Liberado Corte" : "Liberar Corte",
          detalle: `Corte ${id}`,
          user: user.id,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setComments((prev) =>
        prev.map((c) => {
          if (String(c._id) !== String(id)) return c;
          const updated = nuevos.map((r) => {
            const ex = (c.liberados || []).find(
              (x) => String(x.userId) === String(r.user)
            );
            if (ex)
              return {
                ...ex,
                fecha: r.fecha,
                observaciones: r.observaciones || "",
              };
            if (String(r.user) === String(user.id)) {
              return {
                userId: String(user.id),
                nombre: `${user.nombre || ""} ${user.apellido || ""}`.trim(),
                fecha: r.fecha,
                observaciones: r.observaciones || "",
              };
            }
            return {
              userId: String(r.user),
              nombre: "",
              fecha: r.fecha,
              observaciones: r.observaciones || "",
            };
          });
          return {
            ...c,
            liberados: updated,
            liberado: updated.length > 0 ? "Si" : "No",
            observacionesLiberado:
              updated
                .map((x) => x.observaciones)
                .filter(Boolean)
                .slice(-1)[0] || "",
          };
        })
      );
      Swal.fire({
        icon: "success",
        title: yaMarcado ? "Quitaste tu liberado" : "Corte liberado",
        timer: 1000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al liberar:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo actualizar el liberado." });
    }
  }

async function PDFOC(
  numero,
  fecha,
  ordenCorte,
  mesa,
  total_cantidad,
  idPDFOC,
  lienzos,
  empalmes,
  retaceria,
  largoTrazo,
  tiempoInicio,
  tiempoFin,
  observaciones,
  cantidadTotal,
  articulo,
  idOrdenCorte,
  // L18 (2026-06)
  cliente = "",
  idPedidoMongo = "",
  // L19 (2026-06) — Orden de Producción = idOrdenesCorte (autoincrement)
  idOrdenesCorteAuto = "",
  // ODP (2026-07) — número interno de la OC para "Orden Producción"
  numeroInterno = "",
  // L22 (2026-06) — resumido junta cantidades por talla+color de todas las áreas
  resumido = false,
  // L108 (2026-06) — empresa del pedido (para elegir el logo)
  empresa = "",
  // LFISC (2026-07) — objeto empresa completo (datos fiscales) para el encabezado
  empresaObj = null
) {
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  const collatorES = new Intl.Collator("es", {
    sensitivity: "base",
    numeric: true,
  });

  const isSinVar = (name) => {
    const t = s(name).trim().toLowerCase();
    return !t || t === "sin variante" || t === "na";
  };

  const getImageAsDataURL = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          reject(e);
        }
      };

      img.onerror = reject;
      img.src = url;
    });

  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const { data: allArticulosCorte } = await axios.get(
      `${URL_ARTICULOS_CORTES}/corte/${idPDFOC}`,
      { headers }
    );

    // L18 (2026-06) — fetch articulosPedido para obtener observacionesArticulo + tela
    let observacionesArticuloPedido = "";
    let telaConComposicion = "";
    const idPed = idPedidoMongo || allArticulosCorte?.[0]?.pedidos?.[0]?._id || "";
    // L67 (2026-06) — filtrar articulosPedido por el articulo del corte actual,
    // así solo sale la tela de este modelo, no todas las del pedido.
    const idArticuloCorte = String(
      allArticulosCorte?.[0]?.articulosOrdenesCorte?.[0]?.articulos?.[0]?._id ||
        allArticulosCorte?.[0]?.articulosOrdenesCorte?.[0]?.articulos?.[0] ||
        ""
    );
    if (idPed) {
      try {
        const { data: ap } = await axios.get(
          `${URL_ARTICULOS_PEDIDO}/pedidos/${idPed}`,
          { headers }
        );
        const listaRaw = Array.isArray(ap) ? ap : [];
        const lista = idArticuloCorte
          ? listaRaw.filter((x) => {
              const aid = String(
                x?.articulos?.[0]?._id || x?.articulos?.[0] || ""
              );
              return aid === idArticuloCorte;
            })
          : listaRaw;
        observacionesArticuloPedido = [
          ...new Set(
            lista
              .map((x) => {
                const v = (x?.observacionesArticulo || "").toString().trim();
                return v && v.toUpperCase() !== "NA" ? v : "";
              })
              .filter((x) => x)
          ),
        ].join(" / ");

        // L19 — tela + composicion unicas del articulo del corte
        const telas = [
          ...new Set(
            lista
              .map((x) => {
                const tela = (x?.tela || "").toString().trim();
                const comp = (x?.composicion || "").toString().trim();
                const telaOk = tela && tela.toUpperCase() !== "NA" ? tela : "";
                const compOk = comp && comp.toUpperCase() !== "NA" ? comp : "";
                if (telaOk && compOk) return `${telaOk} - ${compOk}`;
                return telaOk || compOk || "";
              })
              .filter((x) => x)
          ),
        ];
        telaConComposicion = telas.join(" / ");
      } catch (e) {
        console.log("obsArticulo pedido err:", e);
      }
    }

    const doc = new jsPDF({
      orientation: "landscape",
      compress: true,
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const marginLeft = 10;
    const marginRight = 10;
    const marginTop = 10;
    const marginBottom = 10;

    let currentY = 62;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // === L44 (2026-06) — Paleta y helpers de diseño ===
    // L114 (2026-06) — morado si la empresa es UNIFORMES INNOVACIÓN (logo Donnatela)
    const brandColor = /Donnatela/i.test(logoInstSrc(empresa))
      ? [205, 184, 245]
      : [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = s(value).trim();
      doc.text(txt || "—", valX, y);
    };

    // ============ LOGO IZQUIERDA + TÍTULO DERECHA + LÍNEA DIVISORIA ============
    const logo = new Image();
    logo.src = logoInstSrc(empresa); // L108
    await new Promise((resolve) => {
      logo.onload = () => {
        const maxH = /Donnatela/i.test(logo.src) ? 22 : 16; // L115 logo Donnatela más grande
        const scale = maxH / logo.height;
        const w = logo.width * scale;
        const h = logo.height * scale;
        doc.addImage(logo, "png", marginLeft, 6, w, h);
        resolve();
      };
      logo.onerror = () => resolve();
    });

    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`CORTE # ${s(numero)}`, pageWidth - marginRight, 16, { align: "right" });
    doc.setTextColor(0);

    // LFISC (2026-07) — Datos fiscales de la empresa propia, debajo del folio
    // (replica ListadoPedidos.jsx L32). empresaObj viene del pedido (findOneFechas
    // popula pedidos.empresas → rfc/regimenFiscal/direccionFiscal/cp).
    if (empresaObj) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(60, 60, 60);
      doc.text(
        s(empresaObj.razonSocial) || s(empresaObj.name) || "",
        pageWidth - marginRight,
        21,
        { align: "right" }
      );
      doc.setFont(undefined, "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...labelColor);
      const fiscalLine = [
        empresaObj.rfc ? `RFC: ${s(empresaObj.rfc)}` : "",
        empresaObj.regimenFiscal ? `Rég. Fiscal: ${s(empresaObj.regimenFiscal)}` : "",
      ]
        .filter((x) => x)
        .join("   ·   ");
      if (fiscalLine) {
        doc.text(fiscalLine, pageWidth - marginRight, 25, { align: "right" });
      }
      const direccionStr = [
        s(empresaObj.direccionFiscal),
        empresaObj.cp ? `C.P. ${s(empresaObj.cp)}` : "",
      ]
        .filter((x) => x)
        .join(", ");
      if (direccionStr) {
        const dirAvailW = pageWidth - marginRight - (marginLeft + 60); // deja hueco para logo
        const dirLines = doc.splitTextToSize(direccionStr, dirAvailW);
        dirLines.forEach((line, i) => {
          doc.text(line, pageWidth - marginRight, 29 + i * 3.8, { align: "right" });
        });
      }
      doc.setTextColor(0);
    }

    // Línea divisoria — corro abajo si hay empresa para no encimar
    const headerLineY = empresaObj ? 38 : 26;
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, headerLineY, pageWidth - marginRight, headerLineY);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // ============ CARD 2 COLUMNAS DATOS ============
    const cardY = headerLineY + 3;
    const cardW = pageWidth - marginLeft - marginRight;
    const cardH = 26;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    // Columna izquierda
    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 32;
    const baseY = cardY + 6;
    drawLabel("Cliente:", cliente, lblX_L, valX_L, baseY);
    // ODP (2026-07) — "Orden Producción" = número interno de la OC (no el autoincrement)
    drawLabel("Orden Producción:", s(numeroInterno), lblX_L, valX_L, baseY + 5);
    drawLabel("Modelo:", articulo, lblX_L, valX_L, baseY + 10);
    drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY + 15);

    // Columna derecha
    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 28;
    drawLabel("Inicio:", tiempoInicio, lblX_R, valX_R, baseY);
    drawLabel("Fin:", tiempoFin, lblX_R, valX_R, baseY + 5);
    drawLabel("Cantidad Total:", sn(cantidadTotal, 0), lblX_R, valX_R, baseY + 10);
    drawLabel("Mesa:", mesa, lblX_R, valX_R, baseY + 15);

    currentY = cardY + cardH + 5;

    // ============ TELA — L44 caja con label band si existe ============
    if (telaConComposicion) {
      ensureRoom(14);
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, cardW, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text("TELA", marginLeft + 3, currentY + 4.2);
      doc.setTextColor(0);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9.5);
      const telaLines = doc.splitTextToSize(telaConComposicion, cardW - 12);
      const blockH = telaLines.length * 4.5;
      ensureRoom(blockH + 6);
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, currentY, cardW, blockH + 5, "FD");
      doc.setDrawColor(0);
      doc.text(telaLines, marginLeft + 3, currentY + 4);
      currentY += blockH + 7;
    }

    // ============ OBSERVACIONES — L44 caja con label band si existen ============
    const obsCorte = String(observaciones ?? "").trim().replace(/\t/g, "  ").replace(/\r/g, "");
    if (obsCorte) {
      ensureRoom(14);
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, cardW, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text("OBSERVACIONES", marginLeft + 3, currentY + 4.2);
      doc.setTextColor(0);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      const obsLines = doc.splitTextToSize(obsCorte, cardW - 12);
      const blockH = obsLines.length * 4.2;
      ensureRoom(blockH + 6);
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, currentY, cardW, blockH + 5, "FD");
      doc.setDrawColor(0);
      doc.text(obsLines, marginLeft + 3, currentY + 4);
      currentY += blockH + 7;
    }

    // ============ Observaciones del artículo del pedido (italic gris) ============
    if (observacionesArticuloPedido) {
      doc.setFont(undefined, "italic");
      doc.setTextColor(...labelColor);
      doc.setFontSize(9);
      const oapLines = doc.splitTextToSize(
        `Observaciones del Artículo: ${observacionesArticuloPedido}`,
        pageWidth - marginLeft - marginRight
      );
      doc.text(oapLines, marginLeft, currentY);
      currentY += oapLines.length * 4.5 + 3;
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
    }

    const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

    const grupoPorAreaArticulo = {};

    allArticulosCorte.forEach((a) => {
      const orden = a.articulosOrdenesCorte?.[0];

      const area = orden?.areasClientes?.[0]?.name || "Sin Área";
      const articuloG =
        orden?.articulos?.[0]?.codigo + " " + orden?.articulos?.[0]?.subDepartamentos?.[0]?.name ||
        orden?.articulos?.[0]?.nombre ||
        "Sin Artículo";

      // L22 (2026-06) — resumido: agrupar solo por modelo (junta áreas)
      const clave = resumido
        ? `RESUMEN||${articuloG}`
        : `${area}||${articuloG}`;

      if (!grupoPorAreaArticulo[clave]) grupoPorAreaArticulo[clave] = [];
      grupoPorAreaArticulo[clave].push(a);
    });

    for (const clave in grupoPorAreaArticulo) {
      const grupo = grupoPorAreaArticulo[clave];
      const [area, articuloG] = clave.split("||");

      // === L44 (2026-06) — Banda azul como header del grupo ===
      ensureRoom(22);
      const bandH = 8;
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft - marginRight, bandH, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10.5);
      // ODP (2026-07) — título "# Artículo" con idOrdenesCorte (como en ListadoOrdenesCorte)
      const artTxt = s(idOrdenesCorteAuto)
        ? `# Artículo: ${s(idOrdenesCorteAuto)}   ·   `
        : "";
      const tituloGrupo = resumido
        ? `${artTxt}Modelo: ${s(articuloG)}   (Resumen de todas las áreas)`
        : `${artTxt}${s(area)}   ·   Modelo: ${s(articuloG)}`;
      doc.text(tituloGrupo, marginLeft + 3, currentY + bandH - 2.5);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += bandH + 3;

      const data = {};
      const totalVariante = {};
      const tallasMap = new Map();

      grupo.forEach((a) => {
        const orden = a.articulosOrdenesCorte?.[0];

        const color = orden?.colores?.[0]?.name || "Sin color";
        const tallaName = s(orden?.tallas?.[0]?.name?.trim()) || "Sin talla";

        const varianteRaw = s(
          orden?.tallas?.[0]?.variantesTallas?.[0]?.name?.trim()
        );

        const varianteName = varianteRaw || "Sin variante";
        const cantidad = sn(a.total_cantidad, 0);

        if (!data[color]) data[color] = {};
        if (!data[color][varianteName]) data[color][varianteName] = {};
        if (!data[color][varianteName][tallaName]) {
          data[color][varianteName][tallaName] = 0;
        }

        data[color][varianteName][tallaName] += cantidad;

        if (!totalVariante[color]) totalVariante[color] = {};
        if (!totalVariante[color][varianteName]) totalVariante[color][varianteName] = 0;

        totalVariante[color][varianteName] += cantidad;

        tallasMap.set(tallaName, true);
      });

      Object.keys(data).forEach((color) => {
        Object.keys(data[color] || {}).forEach((variante) => {
          const tot = sn(totalVariante?.[color]?.[variante], 0);

          if (tot <= 0) {
            delete data[color][variante];
            if (totalVariante[color]) delete totalVariante[color][variante];
          }
        });

        if (!Object.keys(data[color] || {}).length) {
          delete data[color];
          delete totalVariante[color];
        }
      });

      const tallasOrdenadas = Array.from(tallasMap.keys()).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);

        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      let totalPiezasGrupo = 0;

      Object.keys(totalVariante || {}).forEach((color) => {
        Object.keys(totalVariante[color] || {}).forEach((variante) => {
          totalPiezasGrupo += sn(totalVariante[color][variante], 0);
        });
      });

      const usableWidth = pageWidth - marginLeft - marginRight;
      const colorW = 30;
      const totalW = 12;
      const minTallaW = 5.8;

      const maxTallasPerRow = Math.max(
        1,
        Math.floor((usableWidth - colorW - totalW) / minTallaW)
      );

      const chunkSize = Math.max(
        1,
        Math.min(maxTallasPerRow, tallasOrdenadas.length)
      );

      const tallasChunks = chunk(tallasOrdenadas, chunkSize);
      const colores = Object.keys(data);

      for (let ci = 0; ci < tallasChunks.length; ci++) {
        const chunkTallas = tallasChunks[ci];
        const nTallas = chunkTallas.length;
        const tallaW = (usableWidth - colorW - totalW) / Math.max(1, nTallas);

        const colStyles = {
          0: { cellWidth: colorW },
          [1 + nTallas]: { cellWidth: totalW },
        };

        for (let i = 0; i < nTallas; i++) {
          colStyles[1 + i] = { cellWidth: tallaW };
        }

        const headChunk = [["Color", ...chunkTallas, "Total"]];
        const bodyChunk = [];

        for (const color of colores) {
          const variantesRaw = Object.keys(data[color] || {});

          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);

            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;

            const cleanA = s(a).trim();
            const cleanB = s(b).trim();

            const baseA = cleanA.split(/[+-]/)[0].trim();
            const baseB = cleanB.split(/[+-]/)[0].trim();

            const baseCompare = collatorES.compare(baseA, baseB);
            if (baseCompare !== 0) return baseCompare;

            const aHasPlus = cleanA.includes("+");
            const bHasPlus = cleanB.includes("+");
            const aHasMinus = cleanA.includes("-");
            const bHasMinus = cleanB.includes("-");

            if (aHasPlus && !bHasPlus) return -1;
            if (!aHasPlus && bHasPlus) return 1;

            if (aHasMinus && !bHasMinus) return -1;
            if (!aHasMinus && bHasMinus) return 1;

            const numA = parseInt(cleanA.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);
            const numB = parseInt(cleanB.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);

            return numA - numB;
          });

          let firstVar = true;

          for (const variante of variantes) {
            const totVar = sn(totalVariante?.[color]?.[variante], 0);
            if (totVar <= 0) continue;

            const row = new Array(1 + nTallas + 1).fill("");

            const tituloVar = isSinVar(variante) ? "" : s(variante);
            const colorTxt = firstVar ? s(color) : "";

            row[0] = tituloVar
              ? colorTxt
                ? `${colorTxt}\n${tituloVar}`
                : tituloVar
              : colorTxt
              ? colorTxt
              : "";

            chunkTallas.forEach((talla, idx) => {
              const val = sn(data?.[color]?.[variante]?.[talla], 0);
              row[1 + idx] = val > 0 ? String(val) : "";
            });

            row[row.length - 1] = String(totVar);

            const tieneAlgoEnChunk =
              row
                .slice(1, 1 + nTallas)
                .some((x) => String(x || "").trim() !== "") ||
              String(row[0] || "").trim() !== "";

            if (tieneAlgoEnChunk) bodyChunk.push(row);

            firstVar = false;
          }
        }

        ensureRoom(22);

        doc.autoTable({
          head: headChunk,
          body: bodyChunk,
          startY: currentY,
          margin: {
            left: marginLeft,
            right: marginRight,
          },
          tableWidth: usableWidth,
          // L44 (2026-06) — tabla profesional con zebra + color corporativo
          theme: "grid",
          styles: {
            fontSize: 9.5,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 10,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
          columnStyles: colStyles,
          didParseCell: (hookData) => {
            if (hookData.section === "body" && hookData.column.index === 0) {
              hookData.cell.styles.halign = "left";

              const raw = hookData.cell.raw;
              const txt = typeof raw === "string" ? raw : raw?.content || "";

              if (txt && String(txt).includes("\n")) {
                hookData.cell.styles.fontStyle = "bold";
              }
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 4;

        if (tallasChunks.length > 1) {
          doc.setFontSize(8);
          doc.setFont(undefined, "italic");

          doc.text(
            `Tallas ${ci + 1}/${tallasChunks.length}`,
            pageWidth - marginRight,
            currentY,
            { align: "right" }
          );

          doc.setFont(undefined, "normal");
          currentY += 5;
        }
      }

      ensureRoom(8);

      doc.setFont(undefined, "bold");
      doc.setFontSize(8.5);
      doc.text(`Total piezas de este modelo: ${totalPiezasGrupo}`, marginLeft, currentY);
      currentY += 6;

      const primer = grupo.find(
        (a) =>
          a.articulosOrdenesCorte?.[0]?.articulosPedido?.[0]?.bordados?.length >
          0
      );

      const bordados =
        primer?.articulosOrdenesCorte?.[0]?.articulosPedido?.[0]?.bordados || [];

      if (bordados.length) {
        ensureRoom(20);

        doc.setFont(undefined, "bold");
        doc.setFontSize(8.5);
        doc.text("Bordados:", marginLeft, currentY);
        currentY += 4;

        let currentX = marginLeft;
        let maxYInRow = 0;

        const imageMargin = 6;
        // x3: bordados 3 veces más grandes (2026-06)
        const maxImageHeight = 12 * 3;
        const maxImageWidth = 18 * 3;

        for (const b of bordados) {
          try {
            const imageUrl = `https://res.cloudinary.com/lynqro/image/upload/${b.public_id}`;
            const dataUrl = await getImageAsDataURL(imageUrl);

            await new Promise((resolve) => {
              const img = new Image();
              img.src = dataUrl;

              img.onload = () => {
                const ratio = Math.min(
                  maxImageWidth / img.width,
                  maxImageHeight / img.height
                );

                const imgW = img.width * ratio;
                const imgH = img.height * ratio;

                if (currentX + imgW > pageWidth - marginRight) {
                  currentX = marginLeft;
                  currentY += maxYInRow + 10;
                  maxYInRow = 0;
                }

                if (currentY + imgH + 12 > pageHeight - marginBottom) {
                  doc.addPage();
                  currentY = marginTop;
                  currentX = marginLeft;
                  maxYInRow = 0;
                }

                doc.addImage(dataUrl, "PNG", currentX, currentY, imgW, imgH);

                doc.setFont(undefined, "normal");
                doc.setFontSize(8.5);

                const obs = s(b.observacion);

                if (obs) {
                  const obsLines = doc.splitTextToSize(obs, imgW + 4);
                  doc.text(obsLines, currentX, currentY + imgH + 3);

                  const textHeight = obsLines.length * 3;
                  maxYInRow = Math.max(maxYInRow, imgH + textHeight + 5);
                } else {
                  maxYInRow = Math.max(maxYInRow, imgH + 5);
                }

                currentX += imgW + imageMargin;
                resolve();
              };

              img.onerror = () => resolve();
            });
          } catch (err) {
            console.warn("No se pudo mostrar bordado:", b.public_id);
          }
        }

        currentY += maxYInRow + 6;
      }

      ensureRoom(6);
      doc.setDrawColor(220);
      doc.line(marginLeft, currentY, pageWidth - marginRight, currentY);
      doc.setDrawColor(0);
      currentY += 6;
    }

    try {
      const { data: telasOrden } = await axios.get(
        `${URL_INVENTARIOS_TELAS}/ordenCorte/${idOrdenCorte}`,
        { headers }
      );

      const dataFinal = (telasOrden || [])
        .map((a) => ({
          proveedor: a.proveedor,
          articulo: a.articulo,
          colorNombre: a.colorNombre,
          precio: Number(a.precio || 0),
          factura: a.factura,
          cantidad: Number(a.cantidad || 0),
          unidad: a.unidad,
          cantidadSobrante: Number(a.cantidadSobrante || 0),
          cantidadString: a.cantidadString,
        }))
        .filter(Boolean);

      // ============ CONSUMOS — L44 (2026-06) banda azul + tabla profesional ============
      ensureRoom(40);

      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft - marginRight, 7, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text("CONSUMOS", marginLeft + 3, currentY + 5);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += 8;

      const body2 = dataFinal
        .sort((a, b) =>
          String(a.colorNombre || "") > String(b.colorNombre || "") ? 1 : -1
        )
        .map((x) => {
          const consumo =
            Number(cantidadTotal || 0) > 0
              ? x.cantidad / Number(cantidadTotal)
              : 0;

          // L19 (2026-06) — sin Precio/Factura, todo centrado
          return [
            x.proveedor || "NA",
            x.articulo || "NA",
            x.colorNombre || "NA",
            `${new Intl.NumberFormat("en-US").format(x.cantidad)} ${
              x.unidad || ""
            }`.trim(),
            new Intl.NumberFormat("en-US").format(consumo),
            new Intl.NumberFormat("en-US").format(x.cantidadSobrante),
            x.cantidadString || "NA",
          ];
        });

      doc.autoTable({
        head: [[
          "Proveedor",
          "Tela",
          "Color",
          "Cantidad",
          "Consumo",
          "Sobrante",
          "Rollos",
        ]],
        body: body2,
        startY: currentY,
        margin: {
          left: marginLeft,
          right: marginRight,
        },
        tableWidth: pageWidth - marginLeft - marginRight,
        // L44 (2026-06) — tabla profesional consistente con la de tallas
        theme: "grid",
        styles: {
          fontSize: 9,
          cellPadding: 1,
          valign: "middle",
          halign: "center",
          overflow: "linebreak",
          lineColor: borderColor,
          lineWidth: 0.15,
        },
        headStyles: {
          fillColor: brandColor,
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 9.5,
          halign: "center",
        },
        alternateRowStyles: {
          fillColor: stripeBg,
        },
      });

      currentY = doc.autoTable.previous.finalY + 8;
    } catch (e) {
      console.error("Error cargando telas por orden de corte:", e);
    }

    // ============ FOOTER L44 — pie con paginación en cada página ============
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Corte #${s(numero)}  ·  ${s(cliente)}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

  function procesosSalida(id, numero) {
    setEntregaHabilitacion(false);
    setInputFieldsHabilitacion([
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0,
      },
    ]);
    axios
      .get(`${URL_ARTICULOS_CORTES}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            return {
              id: a._id,
              articuloNombre: a.articulosOrdenesCorte[0].articulos[0].codigo + " " + a.articulosOrdenesCorte[0].articulos[0].subDepartamentos[0].name,
              idArticulo: a.articulosOrdenesCorte[0].articulos[0]._id,
              total_cantidad: a.total_cantidad,
              catalogoProcesos: a.articulosOrdenesCorte[0].articulos[0].catalogoProcesos,
              idPedido: a.pedidos[0]._id,
              numeroPedido: a.pedidos[0].idPedido,
              // articulosPedido: a.articulosOrdenesCorte[0].articulosPedido[0]._id,
              fechaCancelacion: a.pedidos[0].fecha_cancelacion
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosCortes(data);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            total_cantidad: 0,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].idPedido = item.idPedido;
          groups[val].numeroPedido = item.numeroPedido;
          groups[val].articuloNombre = item.articuloNombre;
          groups[val].total_cantidad += item.total_cantidad;
          groups[val].catalogoProcesos = item.catalogoProcesos;
          groups[val].fechaCancelacion = item.fechaCancelacion;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedCorte(id);
    setSelectedCorteNumero(numero);
    toggleProcesosSalida();
  }

  function funcionProcesosSalida(
    idCatalogoProcesos,
    nombreProcesosSalida,
    idArticulo,
    nombreArticulo,
    idPedido,
    numeroPedido,
    fechaCancelacion
  ) {
    setArticuloProceso(idArticulo);
    axios
      .get(`${URL_ARTICULOS_CORTES}/corte/${selectedCorte}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosProcesosSalida = response.data;
        setArticulosProcesosSalida(allArticulosProcesosSalida);

        let arrayInputFields = allArticulosProcesosSalida
          .map((a) => {
            if (
              idArticulo ==
              a.articulosOrdenesCorte[0].articulos[0]._id
            ) {
              return {
                id: uuidv4(),
                // idSucursal: a.articulosOrdenesCorte[0].sucursales[0]._id,
                // sucursal: a.articulosOrdenesCorte[0].sucursales[0].alias,
                idAreaCliente: a.articulosOrdenesCorte[0].areasClientes[0]._id,
                areaCliente: a.articulosOrdenesCorte[0].areasClientes[0].name,
                colores: a.articulosOrdenesCorte[0].colores[0].name,
                idColor: a.articulosOrdenesCorte[0].colores[0]._id,
                idTalla: a.articulosOrdenesCorte[0].tallas[0]._id,
                tallas: (() => {
                  const tallaObj = a.articulosOrdenesCorte?.[0]?.tallas?.[0];
                  const tallaBase = tallaObj?.name || "";
                  const variante = tallaObj?.variantesTallas?.[0]?.name || "";
                  return variante ? `${tallaBase} ${variante}` : tallaBase;
                })(),
                cantidad: a.total_cantidad - a.cantidad_procesos,
                faltantes: 0,
                segundas: 0,
                total: 0,
                idArticulo: a.articulosOrdenesCorte[0].articulos[0]._id,
                // articulosPedido: a.articulosOrdenesCorte[0].articulosPedido[0]._id,
              };
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataIF = Object.values(arrayInputFields);

        setInputFields(dataIF);

        let cantTotal = dataIF.map((c) => parseFloat(c.cantidad));
        let TC = cantTotal.reduce((t, total, index) => t + total, 0);
        setTotalPiezas(TC);
      })
      .catch((err) => {
        console.log(err);
      });

    setIdCatalogoProcesos(idCatalogoProcesos);
    setNombreProcesosSalida(nombreProcesosSalida);
    setIdArticulo(idArticulo);
    setNombreArticulo(nombreArticulo);
    setIdPedido(idPedido);
    setNumeroPedido(numeroPedido);
    setFechaCancelacion(fechaCancelacion);
    setModalProcesosSalida(false);
    toggleFuncionProcesosSalida();
  }

  const handleChangeInputPrecio = (event) => {
    const newInputFields = inputFields.map((i) => {
      // i[event.target.name] = event.target.value;
      i.total = i.cantidad * event.target.value;
      return i;
    });
    setPrecioProceso(event.target.value);
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.total = (parseFloat(event.target.value) * parseFloat(precioProceso)) + (parseFloat(i.segundas) * parseFloat(precioProceso));
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidadSegundas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.total = (parseFloat(event.target.value) * parseFloat(precioProceso)) + (parseFloat(i.cantidad) * parseFloat(precioProceso));
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidadFDS = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cantTotal = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cantTotal.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TC);

    let cantTotalFaltantes = inputFields.map((c) => parseFloat(c.faltantes));
    let TF = cantTotalFaltantes.reduce((t, total, index) => t + total, 0);
    setTotalPiezasFaltantes(TF);

    let cantTotalSegundas = inputFields.map((c) => parseFloat(c.segundas));
    let TS = cantTotalSegundas.reduce((t, total, index) => t + total, 0);
    setTotalPiezasSegundas(TS);

    let impTotal = inputFields.map((c) => parseFloat(c.total));
    let TG = impTotal.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  }

  // (2026-10) Fin de una salida / entrada de proceso sin recargar la página:
  // cierra el modal de captura y el de progreso, reactiva el botón, regresa
  // los campos a su valor inicial (antes lo hacía el reload; si no, la
  // siguiente captura arrastra taller, precio y totales) y refresca el listado.
  function terminaCapturaProceso() {
    setModalFuncionProcesosSalida(false);
    setModalFuncionProcesosEntrada(false);
    setModalProgreso(false);
    setValidaBoton(true);
    setFechaProceso(endDate);
    setFechaCompromisoProceso(endDate);
    setMaquileroProceso("");
    setObservaciones("NA");
    setPrecioProceso(0);
    setTotalPiezas(0);
    setTotalPiezasFaltantes(0);
    setTotalPiezasSegundas(0);
    setTotalGeneral(0);
    setFactura("NA");
    setImpuestos(0);
    setComposturas(0);
    cargarCortes();
  }

  const saveSalidaProceso = async (event) => {
    event.preventDefault();
    if (fechaProceso != "" && fechaCompromisoProceso != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = 0;
      if (entregaHabilitacion) {
        totalRollos = inputFields.length + inputFieldsHabilitacion.length;
      } else {
        totalRollos = inputFields.length;
      }
      try {
        await axios
          .post(
            URL_PROCESOS_SALIDA,
            {
              catalogoProcesos: idCatalogoProcesos,
              proveedores: maquileroProceso,
              pedidos: idPedido,
              fecha: fechaProceso,
              fechaCompromiso: fechaCompromisoProceso,
              observaciones,
              status: "Abierto",
              totalGeneral,
              totalPiezas,
              precio: precioProceso,
              cortes: selectedCorte,
              articulos: articuloProceso,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            // (2026-10) el PDF de la salida sale solo, ya con sus renglones
            const sacaPDFSalida = async () => {
              try {
                const { data: salidasCorte } = await axios.get(
                  `${URL_PROCESOS_SALIDA}/corte/${selectedCorte}`,
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                );
                const ps = (salidasCorte || []).find(
                  (x) => String(x._id) === String(data.data._id)
                );
                if (ps) await pdfDeSalida(filaSalidaPS(ps), true);
              } catch (errPDF) {
                console.log(errPDF);
              }
            };

            inputFields.map((a) => {
              if (a.cantidad != 0) {
                axios
                  .post(
                    URL_ARTICULOS_PROCESOS_SALIDA,
                    {
                      procesosSalida: data.data._id,
                      // articulosPedido: a.articulosPedido,
                      pedidos: idPedido,
                      cantidadSalida: a.cantidad,
                      cantidadEntrada: 0,
                      faltantes: a.cantidad,
                      cortes: selectedCorte,
                      articulos: a.idArticulo,
                      colores: a.idColor,
                      tallas: a.idTalla,
                      // sucursales: a.idSucursal,
                      areasClientes: a.idAreaCliente,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Salida de Proceso",
                            detalle: `Pedido ${numeroPedido} Articulo ${articulosCortes[0].articuloNombre}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(async () => {
                          await sacaPDFSalida();
                          Swal.fire("Good job!", "Creado con exito", "success");
                          // (2026-10) sin reload: cierra y refresca
                          terminaCapturaProceso();
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Salida de Proceso",
                        detalle: `Pedido ${numeroPedido} Articulo ${articulosCortes[0].articuloNombre}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(async () => {
                      await sacaPDFSalida();
                      Swal.fire("Good job!", "Creado con exito", "success");
                      // (2026-10) sin reload: cierra y refresca
                      terminaCapturaProceso();
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
            setValidaBoton(true);
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  //Procesos Entrada

  function procesosEntrada(id, numero) {
    cargarArticulosEntrada(id);
    setSelectedCorte(id);
    setSelectedCorteNumero(numero);
    toggleProcesosEntrada();
  }

  // (2026-10) renglones del modal Procesos Entrada; también lo refresca en su
  // lugar al cerrar un proceso
  function cargarArticulosEntrada(id) {
    return axios
      .get(`${URL_ARTICULOS_PROCESOS_SALIDA}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = (response.data || []).filter(
          (a) =>
            a?.is_active !== "No" &&
            a?.procesosSalida?.[0]?.status !== "Cancelado"
        );
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            return {
              id: a._id,
              articuloNombre: a.articulos[0].codigo + " " + a.articulos[0].subDepartamentos[0].name,
              idArticulo: a.articulos[0]._id,
              catalogoProcesos: a.procesosSalida[0].catalogoProcesos[0].name,
              idCatalogoProcesos: a.procesosSalida[0].catalogoProcesos[0]._id,
              idPedido: a.pedidos[0]._id,
              numeroPedido: a.pedidos[0].idPedido,
              // articulosPedido: a.articulosPedido[0]._id,
              cantidadEntrada: a.cantidadEntrada,
              cantidadSalida: a.cantidadSalida,
              status: a.procesosSalida[0].status,
              fecha: a.procesosSalida[0].fecha,
              fechaCompromiso: a.procesosSalida[0].fechaCompromiso,
              precio: a.procesosSalida[0].precio,
              maquilero: a.procesosSalida[0].proveedores[0].nombre_comercial,
              idMaquilero: a.procesosSalida[0].proveedores[0]._id,
              procesosSalida: a.procesosSalida[0]._id,
              faltantes: a.faltantes,
              faltantesHab: a.faltantesHab,
              segundas: a.segundas,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosEntrada(data);
        setIdArticulo(data[0].idArticulo);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"] + item["procesosSalida"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            procesosSalida: item.procesosSalida,
            cantidadSalida: 0,
            cantidadEntrada: 0,
            faltantes: 0,
            faltantesHab: 0,
            segundas: 0,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].idPedido = item.idPedido;
          groups[val].numeroPedido = item.numeroPedido;
          groups[val].articuloNombre = item.articuloNombre;
          groups[val].cantidadSalida += item.cantidadSalida;
          groups[val].cantidadEntrada += item.cantidadEntrada;
          groups[val].catalogoProcesos = item.catalogoProcesos;
          groups[val].idCatalogoProcesos = item.idCatalogoProcesos;
          groups[val].status = item.status;
          groups[val].fecha = item.fecha;
          groups[val].fechaCompromiso = item.fechaCompromiso;
          groups[val].precio = item.precio;
          groups[val].maquilero = item.maquilero;
          groups[val].idMaquilero = item.idMaquilero;
          groups[val].procesosSalida = item.procesosSalida;
          groups[val].faltantes += item.faltantes;
          groups[val].faltantesHab += item.faltantesHab;
          groups[val].segundas += item.segundas;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicosEntrada(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function funcionProcesosEntrada(
    idCatalogoProcesos,
    nombreProcesosEntrada,
    idArticulo,
    nombreArticulo,
    idPedido,
    numeroPedido,
    procesosSalida
  ) {
    axios
      .get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${procesosSalida}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosProcesosEntrada = response.data;
        setArticulosProcesosEntrada(allArticulosProcesosEntrada);
        setMaquileroProceso(
          allArticulosProcesosEntrada[0].procesosSalida[0].proveedores[0]._id
        );
        setPrecioProceso(
          allArticulosProcesosEntrada[0].procesosSalida[0].precio
        );

        let arrayInputFields = allArticulosProcesosEntrada.map((a) => {
          return {
            id: uuidv4(),
            // idSucursal: a.sucursales[0]._id,
            // sucursal: a.sucursales[0].alias,
            idAreaCliente: a.areasClientes[0]._id,
            areaCliente: a.areasClientes[0].name,
            colores: a.colores[0].name,
            idColor: a.colores[0]._id,
            idTalla: a.tallas[0]._id,
            tallas: (() => {
                  const tallaObj = a.tallas?.[0];
                  const tallaBase = tallaObj?.name || "";
                  const variante = tallaObj?.variantesTallas?.[0]?.name || "";
                  return variante ? `${tallaBase} ${variante}` : tallaBase;
                })(),
            cantidad: a.faltantes,
            faltantes: 0,
            segundas: 0,
            total: parseFloat(a.faltantes) * parseFloat(a.procesosSalida[0].precio),
            // articulosPedido: a.articulosPedido[0]._id,
            articulosProcesosSalida: a._id,
            idArticulo: a.articulos[0]._id,
          };
        });

        let dataIF = Object.values(arrayInputFields);

        setInputFields(dataIF);

        let cantTotal = dataIF.map((c) => parseFloat(c.cantidad));
        let TC = cantTotal.reduce((t, total, index) => t + total, 0);
        setTotalPiezas(TC);

        let impTotal = dataIF.map((c) => parseFloat(c.total));
        let TG = impTotal.reduce((t, total, index) => t + total, 0);
        setTotalGeneral(TG);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedProcesoSalida(procesosSalida);
    setIdCatalogoProcesos(idCatalogoProcesos);
    setNombreProcesosEntrada(nombreProcesosEntrada);
    setIdArticulo(idArticulo);
    setNombreArticulo(nombreArticulo);
    setIdPedido(idPedido);
    setNumeroPedido(numeroPedido);
    setModalProcesosEntrada(false);
    toggleFuncionProcesosEntrada();
  }
// console.log("hola", inputFields)
  const saveEntradaProceso = async (event) => {
    event.preventDefault();
    if (fechaProceso != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = inputFields.length;

      let iva = 0;
    let TT = 0;

    let STotal = inputFields.map((c) => parseFloat(c.total));
    let ST = STotal.reduce((t, total, index) => t + total, 0);

    if (impuestos != 0) {
      iva = (impuestos * ST) / 100;
    } else {
      iva = 0;
    }
    TT = (impuestos * ST) / 100 + ST ;

      try {
        await axios
          .post(
            URL_PROCESOS_ENTRADA,
            {
              catalogoProcesos: idCatalogoProcesos,
              proveedores: maquileroProceso,
              pedidos: idPedido,
              fecha: fechaProceso,
              observaciones,
              totalGeneral: TT,
              totalPiezas,
              totalPiezasFaltantes,
              totalPiezasSegundas,
              precio: precioProceso,
              cortes: selectedCorte,
              procesosSalida: selectedProcesoSalida,
              factura,
              articulos: idArticulo,
              composturas
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            // (2026-10) se guarda la promesa para sacar el PDF de la nota al final
            const notaCxPPromesa = axios.post(
              URL_NOTAS_CXP,
              {
                procesosEntrada: data.data._id,
                proveedores: maquileroProceso,
                total_cantidad: totalPiezas + totalPiezasSegundas,
                // total_costo: totalGeneral,
                // saldo: totalGeneral,
                fecha: fechaProceso,
                total_costo: TT,
                saldo: TT,
                subtotal: ST,
                iva,
                impuestos,
                factura
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );

            // la nota de CxP sale sola, ya con todos los renglones guardados
            const sacaNotaCxP = async () => {
              try {
                const nota = await notaCxPPromesa;
                await notaCxPPorId(nota.data._id);
              } catch (errNota) {
                console.log(errNota);
              }
            };

            inputFields.map((a) => {
              if (a.cantidad != 0 || a.faltantes != 0 || a.segundas != 0) {
                axios
                  .post(
                    URL_ARTICULOS_PROCESOS_ENTRADA,
                    {
                      procesosEntrada: data.data._id,
                      // articulosPedido: a.articulosPedido,
                      articulosProcesosSalida: a.articulosProcesosSalida,
                      pedidos: idPedido,
                      cantidadEntrada: a.cantidad,
                      cantidadFaltantes: a.faltantes,
                      cantidadSegundas: a.segundas,
                      cortes: selectedCorte,

                      articulos: a.idArticulo,
                      colores: a.idColor,
                      tallas: a.idTalla,
                      // sucursales: a.idSucursal,
                      areasClientes: a.idAreaCliente,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Entrada de Proceso",
                            detalle: `Pedido ${numeroPedido}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(async () => {
                          await sacaNotaCxP();
                          Swal.fire("Good job!", "Creado con exito", "success");
                          // (2026-10) sin reload: cierra y refresca
                          terminaCapturaProceso();
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Entrada de Proceso",
                        detalle: `Pedido ${numeroPedido}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(async () => {
                      await sacaNotaCxP();
                      Swal.fire("Good job!", "Creado con exito", "success");
                      // (2026-10) sin reload: cierra y refresca
                      terminaCapturaProceso();
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  function jalaHabilitacion(
    id,
    idArticulo,
    numero,
    catalogosProcesosName,
    proveedoresName,
    idProveedor,
    pedido,
    idPedido,
    fechaCompromiso,
    totalPiezas,
    precio,
    totalGeneral,
    fecha,
    idCorte,
    numeroCorte
  ) {
    setIdProcesosSalidaHab(id);
    setIdCorteHab(idCorte);
    setIdPedidoHab(idPedido);
    setIdProveedorHab(idProveedor);

    axios
    .get(`${URL_EXPLOSION}Articulo/${idArticulo}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
  let allArticulosOrdenCorte = response.data;

  let arrayTabla = allArticulosOrdenCorte
    .filter((a) => Array.isArray(a.habilitacion) && a.habilitacion.length > 0)
    .map((a) => {
      return {
        id: uuidv4(),
        idHabilitacion: a.habilitacion[0]._id,
        cantidad: 0,
      };
    })
    .filter((el) => el != null);

  const data = Object.values(arrayTabla);

  setInputFieldsHabilitacion(
    data.length > 0
      ? data
      : [
          {
            id: uuidv4(),
            idHabilitacion: "",
            cantidad: 0,
          },
        ]
  );
})
    .catch((err) => {
      console.log(err);
    });





    toggleHabilitacion();
  }

  // (2026-10) fin de entregar / editar habilitación sin recargar la página:
  // cierra el modal, refresca el detalle de salidas (sigue abierto) y el listado
  function terminaHabilitacion() {
    setModalHabilitacion(false);
    setModalEditHab(false);
    setValidaBoton(true);
    setFechaHab(hoy);
    if (corteDetallePS) cargarSalidasPS(corteDetallePS);
    cargarCortes();
  }

  function saveHabilitacion(event) {
    event.preventDefault();
    let totalRollos = inputFieldsHabilitacion.length;
    axios
      .post(
        URL_HABILITACION_CORTES,
        {
          cortes: idCorteHab,
          pedidos: idPedidoHab,
          proveedores: idProveedorHab,
          procesosSalida: idProcesosSalidaHab,
          fecha: fechaHab,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data2) => {
        inputFieldsHabilitacion.map((a) => {
          if (a.cantidad != 0) {
            axios
              .post(
                URL_DETALLE_HABILITACION_CORTES,
                {
                  cantidad: a.cantidad,
                  habilitacionCortes: data2.data._id,
                  cortes: idCorteHab,
                  pedidos: idPedidoHab,
                  proveedores: idProveedorHab,
                  procesosSalida: idProcesosSalidaHab,
                  habilitacion: a.idHabilitacion,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Salida de Habilitacion",
                        detalle: `Pedido ${idPedidoHab}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      // (2026-10) sin reload: cierra y refresca
                      terminaHabilitacion();
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
          } else {
            totalRollos = totalRollos - 1;
            if (totalRollos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Salida de Habilitacion",
                    detalle: `Pedido ${idPedidoHab}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  // (2026-10) sin reload: cierra y refresca
                  terminaHabilitacion();
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  const handleChangeInputHabilitacion = (id, event) => {
    const newInputFieldsHabilitacion = inputFieldsHabilitacion.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsHabilitacion(newInputFieldsHabilitacion);
  };

  const handleRemoveFieldsHabilitaccion = (id) => {
    const values = [...inputFieldsHabilitacion];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsHabilitacion(values);
  };

  const handleAddFieldsHabilitacion = () => {
    setInputFieldsHabilitacion([
      ...inputFieldsHabilitacion,
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0,
      },
    ]);
  };
  function cerrarProcesosEntrada(
    procesosSalida,
    faltantes,
    faltantesHab,
    maquilero
  ) {
    if (faltantes > 0 || faltantesHab > 0) {
      setCantidadFaltante(faltantes);
      setCantidadFaltanteHab(faltantesHab);
      setProcesoSalidaFaltante(procesosSalida);
      setIdMaquileroFaltante(maquilero);
      setTotalFaltante(0);
      toggleFaltante();
    } else {
      Swal.fire({
        title: "Estas seguro?",
        text: "Se cerrara el proceso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, cerrar!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .patch(
              `${URL_PROCESOS_SALIDA}/${procesosSalida}`,
              {
                status: "Cerrado",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Cerrar Proceso",
                    detalle: `Proceso ${procesosSalida}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Se cerro",
                    showConfirmButton: false,
                    timer: 2000,
                  });
                  // (2026-10) sin reload: refresca el modal (sigue abierto) y el listado
                  cargarArticulosEntrada(selectedCorte);
                  cargarCortes();
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        }
      });
    }
  }

  function saveFaltantes(event) {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cerrara el proceso!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, cerrar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_PROCESOS_SALIDA}/${procesoSalidaFaltante}`,
            {
              status: "Cerrado",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios
              .post(
                URL_FALTANTES_PROVEEDORES,
                {
                  fecha: fechaFaltante,
                  procesosSalida: procesoSalidaFaltante,
                  cantidadFal: cantidadFaltante,
                  precioFal: precioFaltante,
                  totalFal: totalFaltante,
                  cantidadHab: cantidadFaltanteHab,
                  precioHab: precioFaltanteHab,
                  totalHab: totalFaltanteHab,
                  total: totalTotalFaltante,
                  proveedores: idMaquileroFaltante,
                  utilizado: 0,
                  saldo: totalTotalFaltante,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Cerrar Proceso",
                      detalle: `Proceso ${procesoSalidaFaltante}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire({
                      position: "center",
                      icon: "success",
                      title: "Se cerro",
                      showConfirmButton: false,
                      timer: 2000,
                    });
                    // (2026-10) sin reload: cierra el modal de faltantes, regresa
                    // sus campos a cero (si no, el siguiente arrastra precio y
                    // total por aplicar) y refresca Procesos Entrada y el listado
                    setModalFaltante(false);
                    setFechaFaltante(endDate);
                    setPrecioFaltante(0);
                    setPrecioFaltanteHab(0);
                    setTotalFaltante(0);
                    setTotalFaltanteHab(0);
                    setTotalTotalFaltante(0);
                    cargarArticulosEntrada(selectedCorte);
                    cargarCortes();
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  // L7 (2026-06) — abre el modal de edición de cantidades por línea (talla / color / área)
  // L111 — carga (o recarga) las líneas del corte para el modal Editar Cantidades
  async function cargarLineasCorte(corteId) {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    const res = await axios.get(`${URL_ARTICULOS_CORTES}/corte/${corteId}`, {
      headers,
    });
    const rows = (res.data || [])
      .filter((r) => r?.is_active !== "No")
      .map((r) => {
        const aoc = r?.articulosOrdenesCorte?.[0] || {};
        const art = aoc?.articulos?.[0] || {};
        const talla = aoc?.tallas?.[0]?.name || "";
        const variante = aoc?.tallas?.[0]?.variantesTallas?.[0]?.name || "";
        const tallaFinal = variante ? `${talla} ${variante}`.trim() : talla;
        return {
          _id: r._id,
          articulo: art?.codigo || "",
          talla: tallaFinal || "NA",
          color: aoc?.colores?.[0]?.name || "NA",
          area: aoc?.areasClientes?.[0]?.name || "NA",
          cantidad: Number(r.total_cantidad || 0),
          cantidadOriginal: Number(r.total_cantidad || 0),
          // L111 — ids para el alta de combinaciones desde la orden
          idAOC: aoc?._id || "",
          idArticulo: art?._id || "",
          idTalla: aoc?.tallas?.[0]?._id || "",
          idColor: aoc?.colores?.[0]?._id || "",
          idArea: aoc?.areasClientes?.[0]?._id || "",
          idPedido: r?.pedidos?.[0]?._id || aoc?.pedidos?.[0] || "",
          idOrden: aoc?.ordenesCorte?.[0]?._id || aoc?.ordenesCorte?.[0] || "",
        };
      })
      .sort((x, y) => {
        // ordena por talla → color → area
        if (x.talla !== y.talla) return x.talla.localeCompare(y.talla);
        if (x.color !== y.color) return x.color.localeCompare(y.color);
        return x.area.localeCompare(y.area);
      });
    setEditLineItems(rows);
    return rows;
  }

  async function jalaEditCorte(a) {
    setEditIdCorte(a._id);
    setEditNumeroCorte(a.numero || "");
    setEditLineItems([]);
    // (2026-09) Observaciones capturadas en CortesCreate. Se leen del corte
    // directo del API (el renglón de la tabla puede venir de una carga vieja),
    // con lo del renglón como respaldo. "NA" es el default de captura, no una
    // observación: se muestra vacío para que no la tengan que borrar.
    const limpiaObs = (v) => {
      const t = String(v == null ? "" : v).trim();
      return t.toUpperCase() === "NA" ? "" : t;
    };
    let obsCorte = limpiaObs(a.observaciones);
    try {
      const { data: corteDB } = await axios.get(`${URL_CORTES}/${a._id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      if (corteDB) obsCorte = limpiaObs(corteDB.observaciones);
    } catch (err) {
      console.warn("No se pudo leer las observaciones del corte:", err);
    }
    setEditObsCorte(obsCorte);
    setEditObsCorteOriginal(obsCorte);
    // L111 — limpiar formulario de "agregar"
    setAocDisponiblesCorte([]);
    setAocSeleccionadoCorte("");
    setAgregarCorteCantidad("");
    // L111-fix4 — orden canónica del corte (NO derivar del AOC, que puede estar sucio)
    const ordenCorteId = a.idOrdenCorte || "";
    setEditCorteOrden(ordenCorteId);
    try {
      const rows = await cargarLineasCorte(a._id);
      await cargarAocDisponiblesCorte(ordenCorteId, rows);
      toggleEditCorte();
    } catch (err) {
      console.log("jalaEditCorte err:", err);
      Swal.fire("Error", "No se pudo cargar las líneas del corte.", "error");
    }
  }

  // L111 — combos (artículo/talla/color) que existen en la ORDEN del corte
  // (ArticulosOrdenesCorte) pero que NO están en el corte → son los que se pueden agregar.
  async function cargarAocDisponiblesCorte(ordenCorteId, rows) {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    // L111-fix4 — usar la orden CANÓNICA del corte; si no viene, derivar de las líneas
    const ordenes = ordenCorteId
      ? [ordenCorteId]
      : [...new Set((rows || []).map((r) => r.idOrden).filter(Boolean))];
    if (ordenes.length === 0) {
      setAocDisponiblesCorte([]);
      return;
    }
    // AOC que ya están ligados en este corte (por su _id)
    const aocEnCorte = new Set(rows.map((r) => String(r.idAOC)).filter(Boolean));
    const disponibles = [];
    for (const ordenId of ordenes) {
      try {
        const { data } = await axios.get(
          `${URL_ARTICULOS_ORDENES_CORTE}/orden/${ordenId}`,
          { headers }
        );
        (data || [])
          .filter((aoc) => aoc?.is_active !== "No")
          .forEach((aoc) => {
            if (aocEnCorte.has(String(aoc._id))) return; // ya está en el corte
            const tallaName = aoc?.tallas?.[0]?.name || "";
            const variante = aoc?.tallas?.[0]?.variantesTallas?.[0]?.name || "";
            const tallaFinal = variante
              ? `${tallaName} ${variante}`.trim()
              : tallaName;
            disponibles.push({
              id: aoc._id,
              articulo: aoc?.articulos?.[0]?.codigo || "",
              color: aoc?.colores?.[0]?.name || "NA",
              talla: tallaFinal || "NA",
              area: aoc?.areasClientes?.[0]?.name || "",
              idPedido: aoc?.pedidos?.[0]?._id || aoc?.pedidos?.[0] || "",
            });
          });
      } catch (e) {
        console.log(e);
      }
    }
    disponibles.sort((a, b) => {
      if (a.articulo !== b.articulo)
        return a.articulo.localeCompare(b.articulo, "es", {
          sensitivity: "base",
        });
      if (a.color !== b.color)
        return a.color.localeCompare(b.color, "es", { sensitivity: "base" });
      return a.talla.localeCompare(b.talla, "es", { sensitivity: "base" });
    });
    setAocDisponiblesCorte(disponibles);
  }

  // L111 — agregar al corte una combinación que YA existe en la orden (NO crea AOC nuevo)
  async function agregarTallaColorCorte() {
    const cant = parseFloat(agregarCorteCantidad);
    if (!aocSeleccionadoCorte || !(cant > 0)) {
      Swal.fire(
        "Faltan datos",
        "Selecciona una combinación y una cantidad mayor a 0.",
        "warning"
      );
      return;
    }
    const aoc = aocDisponiblesCorte.find(
      (x) => String(x.id) === String(aocSeleccionadoCorte)
    );
    if (!aoc || !aoc.idPedido) {
      Swal.fire(
        "Error",
        "No se pudo identificar el pedido de la combinación.",
        "error"
      );
      return;
    }
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    const hoy = new Date().toISOString().slice(0, 10);
    const payloadAC = {
      cortes: editIdCorte,
      pedidos: aoc.idPedido,
      articulosOrdenesCorte: aoc.id, // _id del AOC seleccionado de la orden
      total_cantidad: cant,
      cantidad_procesos: cant,
      faltanteRecibir: cant,
      fecha: hoy,
    };
    try {
      // Crear la línea del CORTE ligada al AOC existente (auto-marca cortado en el AOC).
      // L111-fix3 — mismos campos que la creación normal (CortesCreate)
      await axios.post(URL_ARTICULOS_CORTES, payloadAC, { headers });
      // Recargar líneas + combos disponibles + actualizar total del corte
      const rows = await cargarLineasCorte(editIdCorte);
      await cargarAocDisponiblesCorte(editCorteOrden, rows);
      const nuevoTotal = rows.reduce((s, r) => s + Number(r.cantidad || 0), 0);
      await axios.patch(
        `${URL_CORTES}/${editIdCorte}`,
        { total_cantidad: nuevoTotal },
        { headers }
      );
      setAocSeleccionadoCorte("");
      setAgregarCorteCantidad("");
      Swal.fire("Agregado", "Combinación agregada al corte.", "success");
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo agregar la combinación.",
        footer: `${err?.response?.data?.error || ""}`,
      });
    }
  }

  function setEditLineCantidad(idx, val) {
    setEditLineItems((prev) =>
      prev.map((r, i) =>
        i === idx ? { ...r, cantidad: val === "" ? "" : Number(val) } : r
      )
    );
  }

  async function guardarEditCorte(event) {
    event.preventDefault();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    // Sólo PATCH las líneas que cambiaron
    const cambios = editLineItems.filter(
      (r) => Number(r.cantidad || 0) !== Number(r.cantidadOriginal || 0)
    );
    // (2026-09) las observaciones también se pueden editar aquí
    const obsCambio = editObsCorte.trim() !== editObsCorteOriginal.trim();

    if (cambios.length === 0 && !obsCambio) {
      Swal.fire({
        icon: "info",
        title: "Sin cambios",
        text: "No modificaste ninguna cantidad ni las observaciones.",
      });
      return;
    }

    try {
      await Promise.all(
        cambios.map((r) =>
          axios.patch(
            `${URL_ARTICULOS_CORTES}/${r._id}`,
            { total_cantidad: Number(r.cantidad || 0) },
            { headers }
          )
        )
      );
      // Actualiza total_cantidad del corte (header) con la suma nueva
      const nuevoTotal = editLineItems.reduce(
        (s, r) => s + Number(r.cantidad || 0),
        0
      );
      await axios.patch(
        `${URL_CORTES}/${editIdCorte}`,
        {
          total_cantidad: nuevoTotal,
          // el validador no acepta cadena vacía: sin observaciones va "NA"
          ...(obsCambio
            ? { observaciones: editObsCorte.trim() || "NA" }
            : {}),
        },
        { headers }
      );
      await axios.post(
        URL_LOGS,
        {
          tipo: "Editar Cantidades Corte",
          detalle: `Corte ${editNumeroCorte} (${cambios.length} línea(s)${
            obsCambio ? " + observaciones" : ""
          })`,
          user: user.id,
        },
        { headers }
      );
      toggleEditCorte();
      Swal.fire({
        icon: "success",
        title:
          cambios.length > 0 ? "Cantidades actualizadas" : "Observaciones actualizadas",
        text:
          cambios.length > 0
            ? `${cambios.length} línea(s) modificadas.${
                obsCambio ? " Observaciones actualizadas." : ""
              }`
            : "Se guardaron las observaciones del corte.",
        timer: 1500,
        showConfirmButton: false,
      });
      // (2026-10) sin reload: refresca el listado
      cargarCortes();
    } catch (err) {
      console.log("guardarEditCorte err:", err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo actualizar el corte.",
        footer: `${err?.response?.data?.message || ""}`,
      });
    }
  }

  function entradaAlmacen(id, numero) {
    axios
      .get(`${URL_ARTICULOS_CORTES}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            return {
              id: a._id,
              articuloNombre:
                a.articulosOrdenesCorte[0].articulos[0].codigo +
                " " +
                a.articulosOrdenesCorte[0].articulos[0].subDepartamentos[0].name,
              idArticulo: a.articulosOrdenesCorte[0].articulos[0]._id,
              cantidad: a.faltanteRecibir,
              segundas: 0,
              catalogoProcesos:
                a.articulosOrdenesCorte[0].articulos[0].catalogoProcesos,
              idTalla: a.articulosOrdenesCorte[0].tallas[0]._id,
              talla:
                a.articulosOrdenesCorte?.[0]?.tallas?.[0]?.name +
                (a.articulosOrdenesCorte?.[0]?.tallas?.[0]?.variantesTallas?.[0]
                  ?.name
                  ? " " +
                    a.articulosOrdenesCorte[0].tallas[0].variantesTallas[0].name
                  : ""),
              idColor: a.articulosOrdenesCorte[0].colores[0]._id,
              color: a.articulosOrdenesCorte[0].colores[0].name,
              // idSucursal: a.articulosOrdenesCorte[0].sucursales[0]._id,
              // sucursal: a.articulosOrdenesCorte[0].sucursales[0].alias,
              idArea: a.articulosOrdenesCorte[0].areasClientes[0]._id,
              area: a.articulosOrdenesCorte[0].areasClientes[0].name,
              // idArticulosPedido: a.articulosOrdenesCorte[0].articulosPedido[0]._id
            };
          })
          .filter((el) => el != null);
  
        // Obtener la última entrada del proceso para cada artículo
        let updatedDataPromises = arrayTabla.map((articulo) => {
          // console.log("hola", id, articulo.idTalla, articulo.idColor);
          return axios
            .post(`${URL_ARTICULOS_PROCESOS_ENTRADA}/last`, {
              // corte: id,
              // idArticulo: articulo.idArticulo,
              // idTalla: articulo.idTalla,
              // idColor: articulo.idColor,
              // idArticulosPedido: articulo.idArticulosPedido
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem(
                  "app_token"
                )}`,
              },
            }
          )
            .then((res) => {
              const lastEntry = res.data; // Suponiendo que devuelva los datos del último proceso
              return {
                ...articulo,
                cantidad: lastEntry.cantidadEntrada || articulo.cantidad,
                segundas: lastEntry.cantidadSegundas || articulo.segundas,
              };
            })
            .catch((err) => {
              console.error(err);
              return articulo; // Devolver el artículo original si hay un error
            });
        });
  
        // Esperar a que todas las promesas se resuelvan
        Promise.all(updatedDataPromises).then((updatedData) => {
          setArticulosCortesEntrada(updatedData);
          setIdArticulo(updatedData[0].idArticulo);
          
          let cantTotal = updatedData.map((c) => parseFloat(c.cantidad));
          let TC = cantTotal.reduce((t, total) => t + total, 0);
          setTotalPiezasEntradaAlma(TC);
  
          let cantTotalSeg = updatedData.map((c) => parseFloat(c.segundas));
          let TCSeg = cantTotalSeg.reduce((t, total) => t + total, 0);
          setTotalPiezasEntradaSegundasAlma(TCSeg);
  
          let agrupado = updatedData.reduce(function (groups, item) {
            const val = item["idArticulo"];
            groups[val] = groups[val] || {
              idArticulo: item.idArticulo,
            };
            groups[val].idArticulo = item.idArticulo;
            return groups;
          }, []);
          let dataFinalAgru = Object.values(agrupado);
          setArticulosUnicosEntradaAlma(dataFinalAgru);
        });
      })
      .catch((err) => {
        console.error(err);
      });
  
    setSelectedCorte(id);
    setSelectedCorteNumero(numero);
    toggleEntradaAlmacen();
  }

  const handleChangeInputCantidadEntradaAlma = (id, event) => {
    const newArticulosCortesEntrada = articulosCortesEntrada.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosCortesEntrada(newArticulosCortesEntrada);
    ActualizaTotalesEntradaAlma();
  };

  const handleChangeInputEntradaSegundasAlma = (id, event) => {
    const newArticulosCortesEntrada = articulosCortesEntrada.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosCortesEntrada(newArticulosCortesEntrada);
    ActualizaTotalesEntradaAlma();
  };

  function ActualizaTotalesEntradaAlma() {
    let cantTotal = articulosCortesEntrada.map((c) => parseFloat(c.cantidad));
    let TC = cantTotal.reduce((t, total, index) => t + total, 0);
    setTotalPiezasEntradaAlma(TC);

    let cantTotalSeg = articulosCortesEntrada.map((c) =>
      parseFloat(c.segundas)
    );
    let TCSeg = cantTotalSeg.reduce((t, total, index) => t + total, 0);
    setTotalPiezasEntradaSegundasAlma(TCSeg);
  }

  // (2026-10) fin de la entrada a almacén sin recargar la página: cierra los
  // modales, reactiva el botón, regresa los campos a su valor inicial y
  // refresca el listado
  function terminaEntradaAlma() {
    setModalEntradaAlmacen(false);
    setModalProgreso(false);
    setValidaBoton(true);
    setFechaEntradaAlma(endDate);
    setObservaciones("NA");
    setAreasEntrada("632cde6807fae9155c1740e8");
    cargarCortes();
  }

  const saveEntradaAlma = async (event) => {
    event.preventDefault();
    if (fechaEntradaAlma != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = articulosCortesEntrada.length;
      try {
        // await axios.patch(
        //   `${URL_ARTICULOS}/${idArticulo}`,
        //   {
        //     codigoSAT,
        //     codigoUnidad,
        //   },
        //   {
        //     headers: {
        //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        //     },
        //   }
        // )
        // .then(() => {
       await axios
          .post(
            URL_ENTRADAS_ALMACEN,
            {
              fecha: fechaEntradaAlma,
              cortes: selectedCorte,
              observaciones,
              total_cantidad: totalPiezasEntradaAlma,
              total_segundas: totalPiezasEntradaSegundasAlma,
              areas: areasEntrada,
              articulos: idArticulo,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            articulosCortesEntrada.map((a) => {
              if (a.cantidad != 0) {
                axios
                  .post(
                    URL_ENTRADAS_ALMACEN_ACUMULADOS,
                    {
                      fecha: fechaEntradaAlma,
                      cortes: selectedCorte,
                      cantidad: a.cantidad,
                      segundas: a.segundas,
                      entradasAlmacen: data.data._id,
                      articulosCortes: a.id,
                      articulos: a.idArticulo,
                      tallas: a.idTalla,
                      colores: a.idColor,
                      areas: areasEntrada,
                      areasClientes: a.idArea,
                      sucursales: a.idSucursal,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Entrada Almacen",
                            detalle: `Corte ${selectedCorte}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          // (2026-10) sin reload: cierra y refresca
                          terminaEntradaAlma();
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  })
                  .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Entrada Almacen",
                        detalle: `Corte ${selectedCorte}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      // (2026-10) sin reload: cierra y refresca
                      terminaEntradaAlma();
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
            setValidaBoton(true);
          })
        // })
        // .catch((error) => {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Oops...",
        //     text: "Something went wrong!",
        //     footer: `${error.response.data}`,
        //   });
        //   console.log(error);
        //   setValidaBoton(true);
        // })
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  function jalaHabilitacionEdit(id) {
    axios
      .get(`${URL_DETALLE_HABILITACION_CORTES}/proceso/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              idHabilitacion: a.habilitacion[0]._id,
              nombre: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
              cantidadAnterior: a.cantidad,
              cantidad: a.cantidad,
            }
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setEditHab(data);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditHab();
  }

  const handleChangeInputHabilitacionEdit = (id, event) => {
    const newInputFieldsHabilitacion = editHab.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setEditHab(newInputFieldsHabilitacion);
  };

  function saveHabilitacionEdit(event) {
    event.preventDefault();
    let totalRollos = editHab.length;
        editHab.map((a) => {
            axios
              .patch(
                `${URL_DETALLE_HABILITACION_CORTES}/${a.id}`,
                {
                  habilitacion: a.idHabilitacion,
                  cantidad: a.cantidad,
                  cantidadAnterior: a.cantidadAnterior,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Salida de Habilitacion",
                        detalle: `Pedido`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      // (2026-10) sin reload: cierra y refresca
                      terminaHabilitacion();
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
        });
  }

  // PDF Procesos

  // (2026-10) Renglón de una salida de proceso para el modal de salidas y
  // para el PDF que sale solo al guardar la salida.
  const filaSalidaPS = (a) => ({
    id: a._id,
    catalogosProcesosName: a.catalogoProcesos[0].name,
    proveedoresName: a.proveedores[0].nombre_comercial,
    idProveedor: a.proveedores[0]._id,
    pedido: a.pedidos[0].idPedido,
    idPedido: a.pedidos[0]._id,
    fechaCompromiso: a.fechaCompromiso,
    totalGeneral: a.totalGeneral,
    totalPiezas: a.totalPiezas,
    precio: a.precio,
    numero: a.idProcesosSalida,
    fecha: a.fecha,
    idCorte: a.cortes[0]._id,
    numeroCorte: a.cortes[0].idCorte,
    corteObservaciones: a.observaciones,
    ordenCorte: a.cortes[0].ordenesCorte[0].idOrdenesCorte,
    // L72 (2026-06) — número interno (texto manual) de la OC
    numeroInternoOC: a.cortes[0].ordenesCorte[0].numero || "",
    articulo:
      a.articulos[0].codigo + " " + a.articulos[0].subDepartamentos[0].name,
    idArticulo: a.articulos[0]._id,
    status: a.status,
    cliente: a.pedidos[0].clientes[0].nombre_comercial,
    // L107 (2026-06) — empresa del pedido (para el logo del PDFOCPS)
    empresa:
      a.pedidos[0]?.empresas?.[0]?.razonSocial ||
      a.pedidos[0]?.empresas?.[0]?.name ||
      "",
    // LFISC (2026-07) — objeto empresa completo (ProcesosSalida/corte popula
    // pedidos.empresas → rfc/regimenFiscal/direccionFiscal/cp)
    empresaObj: a.pedidos[0]?.empresas?.[0] || null,
  });

  // PDF completo de la salida, igual que el botón del modal de salidas
  const pdfDeSalida = (a, descargar = false) =>
    PDFOCPS(
      a.id,
      a.numero,
      a.catalogosProcesosName,
      a.proveedoresName,
      a.pedido,
      a.fechaCompromiso,
      a.totalPiezas,
      a.precio,
      a.totalGeneral,
      a.fecha,
      a.idArticulo,
      a.ordenCorte,
      a.cliente,
      a.corteObservaciones,
      !!user.crt_pdfPrecios,
      a.numeroInternoOC,
      a.empresa,
      a.empresaObj,
      false,
      descargar
    );

  function PDFProcesosSalida(id, numero) {
    setCorteDetallePS(id);
    cargarSalidasPS(id);
    togglePDFPS();
  }

  // (2026-10) renglones del modal Detalle Salida Procesos; también lo
  // refresca en su lugar al editar / cancelar una salida o su habilitación
  function cargarSalidasPS(id) {
    return axios
      .get(`${URL_PROCESOS_SALIDA}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
          .map(filaSalidaPS)
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setPDFPS(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // (2026-07) cargar una salida de proceso para editar (encabezado + cantidades)
  async function jalaEditSalida(a) {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    setEditSalidaId(a.id);
    setEditSalidaProveedor(a.idProveedor || "");
    setEditSalidaFechaComp(a.fechaCompromiso || "");
    setEditSalidaPrecio(Number(a.precio || 0));
    setEditSalidaCorte(a.idCorte || "");
    setEditSalidaPedido(a.idPedido || "");
    setEditSalidaAgregar("");
    const idDe = (v) => String(v?._id || v || "");
    // área + color + talla identifican un renglón de la salida
    const claveCombo = (area, color, talla) => `${area}|${color}|${talla}`;
    const nombreTalla = (t) => {
      const variante = t?.variantesTallas?.[0]?.name || "";
      return `${t?.name || ""}${variante ? ` ${variante}` : ""}`;
    };
    try {
      const [{ data }, { data: lineasCorte }, { data: salidasCorte }] =
        await Promise.all([
          axios.get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${a.id}`, {
            headers,
          }),
          axios.get(`${URL_ARTICULOS_CORTES}/corte/${a.idCorte}`, { headers }),
          axios.get(`${URL_ARTICULOS_PROCESOS_SALIDA}/corte/${a.idCorte}`, {
            headers,
          }),
        ]);

      // lo que ya se mandó a este mismo proceso en OTRAS salidas activas del
      // corte, para no mandar dos veces la misma talla
      const procesoDe = (ap) =>
        idDe(ap?.procesosSalida?.[0]?.catalogoProcesos?.[0]);
      const procesoEsta = procesoDe((Array.isArray(data) ? data : [])[0]);
      const enviadoOtras = {};
      (Array.isArray(salidasCorte) ? salidasCorte : []).forEach((ap) => {
        const ps = ap?.procesosSalida?.[0];
        if (!ps || idDe(ps) === String(a.id)) return;
        if (ps.is_active === "No" || ap.is_active === "No") return;
        if (procesoEsta ? procesoDe(ap) !== procesoEsta : true) return;
        const k = claveCombo(
          idDe(ap?.areasClientes?.[0]),
          idDe(ap?.colores?.[0]),
          idDe(ap?.tallas?.[0])
        );
        enviadoOtras[k] = (enviadoOtras[k] || 0) + Number(ap.cantidadSalida || 0);
      });
      const items = (Array.isArray(data) ? data : []).map((ap) => ({
        id: ap._id,
        clave: claveCombo(
          idDe(ap?.areasClientes?.[0]),
          idDe(ap?.colores?.[0]),
          idDe(ap?.tallas?.[0])
        ),
        nombre: `${ap?.articulos?.[0]?.codigo || ""} ${
          ap?.colores?.[0]?.name || ""
        } ${nombreTalla(ap?.tallas?.[0])}`.trim(),
        area: ap?.areasClientes?.[0]?.name || "",
        cantidadSalida: Number(ap.cantidadSalida || 0),
        cantidadEntrada: Number(ap.cantidadEntrada || 0),
      }));

      // (2026-10) Tallas que están dadas de alta en el corte (mismo artículo
      // de la salida) para poder agregarlas. Al crear la salida, las tallas en
      // 0 no se guardan y después ya no había forma de mandarlas.
      const disponibles = {};
      (Array.isArray(lineasCorte) ? lineasCorte : []).forEach((ac) => {
        if (ac.is_active === "No") return;
        const o = ac.articulosOrdenesCorte?.[0];
        if (!o || idDe(o.articulos?.[0]) !== String(a.idArticulo)) return;
        const area = idDe(o.areasClientes?.[0]);
        const color = idDe(o.colores?.[0]);
        const talla = idDe(o.tallas?.[0]);
        if (!area || !color || !talla) return;
        const clave = claveCombo(area, color, talla);
        if (!disponibles[clave]) {
          disponibles[clave] = {
            clave,
            idArticulo: idDe(o.articulos[0]),
            idColor: color,
            idTalla: talla,
            idArea: area,
            nombre: `${o.articulos?.[0]?.codigo || ""} ${
              o.colores?.[0]?.name || ""
            } ${nombreTalla(o.tallas?.[0])}`.trim(),
            area: o.areasClientes?.[0]?.name || "",
            cortado: 0,
            enviadoOtras: enviadoOtras[clave] || 0,
          };
        }
        disponibles[clave].cortado += Number(ac.total_cantidad || 0);
      });

      setEditSalidaItems(items);
      setEditSalidaDisponibles(Object.values(disponibles));
      toggleEditSalida();
    } catch (e) {
      console.log(e);
      Swal.fire(
        "Error",
        "No se pudieron cargar los artículos de la salida",
        "error"
      );
    }
  }

  const handleChangeEditSalidaCantidad = (id, value) => {
    setEditSalidaItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, cantidadSalida: value } : it))
    );
  };

  // (2026-10) tallas del corte que todavía no están en la salida
  const tallasPorAgregarSalida = editSalidaDisponibles.filter(
    (d) => !editSalidaItems.some((it) => it.clave === d.clave)
  );
  // el área sólo se muestra si el artículo va a más de una
  const salidaVariasAreas =
    new Set(
      [...editSalidaItems, ...editSalidaDisponibles].map((x) => x.area)
    ).size > 1;

  const agregarTallaSalida = () => {
    const d = editSalidaDisponibles.find((x) => x.clave === editSalidaAgregar);
    if (!d) return;
    setEditSalidaItems((prev) => [
      ...prev,
      {
        id: `nuevo-${d.clave}`,
        nuevo: true,
        clave: d.clave,
        nombre: d.nombre,
        area: d.area,
        idArticulo: d.idArticulo,
        idColor: d.idColor,
        idTalla: d.idTalla,
        idArea: d.idArea,
        cantidadSalida: 0,
        cantidadEntrada: 0,
      },
    ]);
    setEditSalidaAgregar("");
  };

  const quitarTallaSalida = (id) => {
    setEditSalidaItems((prev) => prev.filter((it) => it.id !== id));
  };

  // (2026-07) guardar edición: encabezado (proveedor/fecha/precio) + cantidades,
  // reajustando totalPiezas/totalGeneral de la salida y faltantes por artículo
  // (faltantes = cantidadSalida - lo ya recibido en entradas). El "faltante por
  // recibir" del corte se deriva de estos datos, así que queda consistente.
  async function saveEditSalida(event) {
    if (event) event.preventDefault();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    const invalido = editSalidaItems.some(
      (it) => Number(it.cantidadSalida || 0) < Number(it.cantidadEntrada || 0)
    );
    if (invalido) {
      Swal.fire(
        "Error",
        "La cantidad de salida no puede ser menor a lo ya recibido en entradas.",
        "error"
      );
      return;
    }
    const totalPiezas = editSalidaItems.reduce(
      (s, it) => s + Number(it.cantidadSalida || 0),
      0
    );
    const precio = Number(editSalidaPrecio || 0);
    try {
      await Promise.all(
        editSalidaItems
          .filter((it) => !it.nuevo)
          .map((it) =>
            axios.patch(
              `${URL_ARTICULOS_PROCESOS_SALIDA}/${it.id}`,
              {
                cantidadSalida: Number(it.cantidadSalida || 0),
                faltantes:
                  Number(it.cantidadSalida || 0) -
                  Number(it.cantidadEntrada || 0),
              },
              { headers }
            )
          )
      );
      // (2026-10) tallas agregadas desde el corte: se crean igual que al dar
      // la salida (las que se dejaron en 0 no se guardan)
      const nuevas = editSalidaItems.filter(
        (it) => it.nuevo && Number(it.cantidadSalida || 0) > 0
      );
      await Promise.all(
        nuevas.map((it) =>
          axios.post(
            URL_ARTICULOS_PROCESOS_SALIDA,
            {
              procesosSalida: editSalidaId,
              pedidos: editSalidaPedido,
              cortes: editSalidaCorte,
              articulos: it.idArticulo,
              colores: it.idColor,
              tallas: it.idTalla,
              areasClientes: it.idArea,
              cantidadSalida: Number(it.cantidadSalida || 0),
              cantidadEntrada: 0,
              faltantes: Number(it.cantidadSalida || 0),
            },
            { headers }
          )
        )
      );
      // el encabezado (piezas / importe) va al final, ya con las tallas nuevas
      await axios.patch(
        `${URL_PROCESOS_SALIDA}/${editSalidaId}`,
        {
          proveedores: editSalidaProveedor,
          fechaCompromiso: editSalidaFechaComp,
          precio,
          totalPiezas,
          totalGeneral: totalPiezas * precio,
        },
        { headers }
      );
      await axios.post(
        URL_LOGS,
        {
          tipo: "Editar Salida Proceso",
          detalle: `Salida ${editSalidaId}${
            nuevas.length
              ? ` (+ ${nuevas.map((it) => it.nombre).join(", ")})`
              : ""
          }`,
          user: user.id,
        },
        { headers }
      );
      Swal.fire("Listo", "Salida de proceso actualizada", "success");
      toggleEditSalida();
      // (2026-10) sin reload: refresca el detalle de salidas (sigue abierto) y el listado
      if (corteDetallePS) cargarSalidasPS(corteDetallePS);
      cargarCortes();
    } catch (e) {
      console.log(e);
      Swal.fire("Error", "No se pudo actualizar la salida", "error");
    }
  }

  // (2026-07) EDITAR ENTRADA DE PROCESO — ajusta cantidades/precio/proveedor y
  // reconcilia por DELTA: NotaCxP (total_costo/saldo/subtotal/iva/total_cantidad),
  // cargos/saldo del proveedor, y la salida ligada (cantidadEntrada/faltantes/etc).
  async function jalaEditEntrada(a) {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    setEditEntradaId(a.id);
    setEditEntradaProveedor(a.idProveedor || "");
    setEditEntradaProveedorOrig(a.idProveedor || "");
    setEditEntradaFecha(a.fecha || "");
    setEditEntradaPrecio(Number(a.precio || 0));
    try {
      const [artsResp, notaResp] = await Promise.all([
        axios.get(`${URL_ARTICULOS_PROCESOS_ENTRADA}/proceso/${a.id}`, {
          headers,
        }),
        axios.get(`${URL_NOTAS_CXP}Entrada/${a.id}`, { headers }),
      ]);
      const arts = Array.isArray(artsResp.data) ? artsResp.data : [];
      const items = arts.map((ap) => {
        const sal = Array.isArray(ap.articulosProcesosSalida)
          ? ap.articulosProcesosSalida[0]
          : ap.articulosProcesosSalida;
        return {
          id: ap._id,
          articulosProcesosSalida: sal?._id || "",
          nombre: `${sal?.articulos?.[0]?.codigo || ""} ${
            sal?.colores?.[0]?.name || ""
          } ${sal?.tallas?.[0]?.name || ""}`.trim(),
          cantidadEntrada: Number(ap.cantidadEntrada || 0),
          cantidadFaltantes: Number(ap.cantidadFaltantes || 0),
          cantidadSegundas: Number(ap.cantidadSegundas || 0),
          // valores originales para calcular el delta al guardar
          origEntrada: Number(ap.cantidadEntrada || 0),
          origFaltantes: Number(ap.cantidadFaltantes || 0),
          origSegundas: Number(ap.cantidadSegundas || 0),
        };
      });
      setEditEntradaItems(items);
      setEditEntradaNota(notaResp.data || null);
      toggleEditEntrada();
    } catch (e) {
      console.log(e);
      Swal.fire(
        "Error",
        "No se pudieron cargar los datos de la entrada",
        "error"
      );
    }
  }

  const handleChangeEditEntrada = (id, field, value) => {
    setEditEntradaItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, [field]: value } : it))
    );
  };

  async function saveEditEntrada(event) {
    if (event) event.preventDefault();
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    const precio = Number(editEntradaPrecio || 0);
    const impuestos = Number(editEntradaNota?.impuestos || 0);

    const totalPiezas = editEntradaItems.reduce(
      (s, it) => s + Number(it.cantidadEntrada || 0),
      0
    );
    const totalFaltantes = editEntradaItems.reduce(
      (s, it) => s + Number(it.cantidadFaltantes || 0),
      0
    );
    const totalSegundas = editEntradaItems.reduce(
      (s, it) => s + Number(it.cantidadSegundas || 0),
      0
    );

    // facturación = piezas buenas (cantidadEntrada) × precio (igual que al crear)
    // (2026-10) + la huara de la nota (precio huara × piezas, como en Pagos y
    // Saldos) y el IVA sólo sobre lo facturado si la factura del taller es parcial
    const precioHuara = Number(editEntradaNota?.precioHuara || 0);
    const importeHuara = Math.round(precioHuara * (totalPiezas + totalSegundas) * 100) / 100;
    const ST = totalPiezas * precio + importeHuara;
    const baseIva =
      editEntradaNota?.facturaParcial === "Si"
        ? Math.min(Number(editEntradaNota?.importeFacturado || 0), ST)
        : ST;
    const iva = (impuestos * baseIva) / 100;
    const TT = ST + iva;

    const oldTC = Number(editEntradaNota?.total_costo || 0);
    const oldSaldo = Number(editEntradaNota?.saldo || 0);
    const delta = TT - oldTC;

    try {
      // 1) Encabezado de la entrada (ProcesosEntrada)
      await axios.patch(
        `${URL_PROCESOS_ENTRADA}/${editEntradaId}`,
        {
          proveedores: editEntradaProveedor,
          fecha: editEntradaFecha,
          precio,
          totalPiezas,
          totalPiezasFaltantes: totalFaltantes,
          totalPiezasSegundas: totalSegundas,
          totalGeneral: TT,
        },
        { headers }
      );

      // 2) Cada línea (ArticulosProcesosEntrada) + reajuste de la salida ligada por delta
      await Promise.all(
        editEntradaItems.map(async (it) => {
          await axios.patch(
            `${URL_ARTICULOS_PROCESOS_ENTRADA}/${it.id}`,
            {
              cantidadEntrada: Number(it.cantidadEntrada || 0),
              cantidadFaltantes: Number(it.cantidadFaltantes || 0),
              cantidadSegundas: Number(it.cantidadSegundas || 0),
            },
            { headers }
          );

          if (it.articulosProcesosSalida) {
            const oldTotal =
              Number(it.origEntrada) +
              Number(it.origFaltantes) +
              Number(it.origSegundas);
            const newTotal =
              Number(it.cantidadEntrada || 0) +
              Number(it.cantidadFaltantes || 0) +
              Number(it.cantidadSegundas || 0);
            const dTotal = newTotal - oldTotal;
            const dFalt =
              Number(it.cantidadFaltantes || 0) - Number(it.origFaltantes);
            const dSeg =
              Number(it.cantidadSegundas || 0) - Number(it.origSegundas);
            if (dTotal !== 0 || dFalt !== 0 || dSeg !== 0) {
              try {
                const { data: sal } = await axios.get(
                  `${URL_ARTICULOS_PROCESOS_SALIDA}/${it.articulosProcesosSalida}`,
                  { headers }
                );
                await axios.patch(
                  `${URL_ARTICULOS_PROCESOS_SALIDA}/${it.articulosProcesosSalida}`,
                  {
                    cantidadEntrada: Number(sal?.cantidadEntrada || 0) + dTotal,
                    faltantes: Number(sal?.faltantes || 0) - dTotal,
                    faltantesHab: Number(sal?.faltantesHab || 0) + dFalt,
                    segundas: Number(sal?.segundas || 0) + dSeg,
                  },
                  { headers }
                );
              } catch (e) {
                console.log("No se pudo reajustar la salida ligada", e);
              }
            }
          }
        })
      );

      // 3) NotaCxP — ajusta el saldo por el delta (respeta abonos ya aplicados)
      if (editEntradaNota?._id) {
        await axios.patch(
          `${URL_NOTAS_CXP}/${editEntradaNota._id}`,
          {
            proveedores: editEntradaProveedor,
            total_costo: TT,
            saldo: oldSaldo + delta,
            subtotal: ST,
            iva,
            ...(precioHuara > 0 ? { importeHuara } : {}),
            total_cantidad: totalPiezas + totalSegundas,
          },
          { headers }
        );
      }

      // 4) Proveedor — cargos/saldo. Si es el mismo proveedor, ajusta por delta;
      //    si cambió, quita el costo viejo del anterior y súmalo al nuevo.
      if (editEntradaProveedor === editEntradaProveedorOrig) {
        if (delta !== 0 && editEntradaProveedor) {
          const { data: prov } = await axios.get(
            `${URL_PROVEEDORES}/${editEntradaProveedor}`,
            { headers }
          );
          await axios.patch(
            `${URL_PROVEEDORES}/${editEntradaProveedor}`,
            {
              cargos: Number(prov?.cargos || 0) + delta,
              saldo: Number(prov?.saldo || 0) + delta,
            },
            { headers }
          );
        }
      } else {
        if (editEntradaProveedorOrig) {
          const { data: provOld } = await axios.get(
            `${URL_PROVEEDORES}/${editEntradaProveedorOrig}`,
            { headers }
          );
          await axios.patch(
            `${URL_PROVEEDORES}/${editEntradaProveedorOrig}`,
            {
              cargos: Number(provOld?.cargos || 0) - oldTC,
              saldo: Number(provOld?.saldo || 0) - oldTC,
            },
            { headers }
          );
        }
        if (editEntradaProveedor) {
          const { data: provNew } = await axios.get(
            `${URL_PROVEEDORES}/${editEntradaProveedor}`,
            { headers }
          );
          await axios.patch(
            `${URL_PROVEEDORES}/${editEntradaProveedor}`,
            {
              cargos: Number(provNew?.cargos || 0) + TT,
              saldo: Number(provNew?.saldo || 0) + TT,
            },
            { headers }
          );
        }
      }

      await axios.post(
        URL_LOGS,
        {
          tipo: "Editar Entrada Proceso",
          detalle: `Entrada ${editEntradaId}`,
          user: user.id,
        },
        { headers }
      );
      Swal.fire(
        "Listo",
        "Entrada actualizada (NotaCxP y saldos del proveedor ajustados)",
        "success"
      );
      toggleEditEntrada();
      // (2026-10) sin reload: refresca el detalle de entradas (sigue abierto) y el listado
      if (corteDetallePE) cargarEntradasPE(corteDetallePE);
      cargarCortes();
    } catch (e) {
      console.log(e);
      Swal.fire("Error", "No se pudo actualizar la entrada", "error");
    }
  }

  function cancelarSalidaProceso(id, numeroSalida) {
    Swal.fire({
      title: "¿Cancelar Salida de Proceso?",
      text: `Se cancelará la salida #${numeroSalida} y los artículos asociados quedarán en baja. Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Si, cancelar",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      const headers = {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      };

      try {
        const { data: articulos } = await axios.get(
          `${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${id}`,
          { headers }
        );

        await Promise.all(
          (articulos || []).map((ap) =>
            axios.patch(
              `${URL_ARTICULOS_PROCESOS_SALIDA}/${ap._id}`,
              { is_active: "No" },
              { headers }
            )
          )
        );

        await axios.patch(
          `${URL_PROCESOS_SALIDA}/${id}`,
          { status: "Cancelado" },
          { headers }
        );

        await axios.post(
          URL_LOGS,
          {
            tipo: "Cancelar Salida Proceso",
            detalle: `Salida ${numeroSalida}`,
            user: user.id,
          },
          { headers }
        );

        Swal.fire({
          icon: "success",
          title: "Cancelada",
          text: `Salida #${numeroSalida} cancelada`,
          timer: 1500,
          showConfirmButton: false,
        });
        // (2026-10) sin reload: refresca el detalle de salidas (sigue abierto) y el listado
        if (corteDetallePS) cargarSalidasPS(corteDetallePS);
        cargarCortes();
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo cancelar la salida.",
          footer: `${err?.response?.data || ""}`,
        });
      }
    });
  }


// L107 (2026-06) — logoInstitucionDonnatela cuando la empresa del pedido es UNIFORMES INNOVACIÓN
function logoInstSrc(empresa) {
  const t =
    typeof empresa === "string"
      ? empresa
      : empresa?.razonSocial || empresa?.name || "";
  const norm = t
    .normalize("NFD")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toLowerCase();
  const file = norm.includes("uniformes innovacion")
    ? "logoInstitucionDonnatela.png"
    : "logoInstitucion.png";
  return process.env.PUBLIC_URL + "/" + file;
}
// ============================================================================
// FICHA TÉCNICA DE BORDADOS (estilo Word): banda + rejilla de celdas con borde
// (imagen arriba, observación debajo). Autocontenida: hace su propio addPage
// y su propia paginación. Reutilizable en los PDFs que imprimen bordados.
// ============================================================================
async function dibujarFichaBordados(doc, bordadosFinal, opts) {
  const {
    getCloudinaryUrl,
    loadImagePDF,
    pageWidth,
    marginLeft,
    marginTop = 15,
    brandColor,
    lightBg = [245, 247, 250],
    borderColor = [210, 216, 224],
    labelColor = [110, 120, 135],
    s = (v) => (v == null ? "" : String(v)),
  } = opts || {};

  if (!Array.isArray(bordadosFinal) || !bordadosFinal.length) return;

  const pageHeight = doc.internal.pageSize.getHeight();
  const marginBottom = 15;
  const usableW = pageWidth - marginLeft * 2;

  // Carga robusta: fetch → blob → dataURL (evita "tainted canvas" por CORS);
  // fallback al loader que pase el archivo.
  const cargarImagen = async (url) => {
    if (!url) return null;
    try {
      const resp = await fetch(url, { mode: "cors" });
      if (resp.ok) {
        const blob = await resp.blob();
        const dataUrl = await new Promise((res) => {
          const r = new FileReader();
          r.onloadend = () => res(r.result);
          r.onerror = () => res(null);
          r.readAsDataURL(blob);
        });
        if (dataUrl) return dataUrl;
      }
    } catch (e) {
      /* fallback abajo */
    }
    if (typeof loadImagePDF === "function") {
      return await loadImagePDF(url).catch(() => null);
    }
    return null;
  };

  doc.addPage();
  let y = marginTop;

  const room = (needed) => {
    if (y + needed > pageHeight - marginBottom) {
      doc.addPage();
      y = marginTop;
    }
  };

  // Banda "FICHA TÉCNICA DE BORDADOS"
  doc.setFillColor(...brandColor);
  doc.rect(marginLeft, y, usableW, 9, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont(undefined, "bold");
  doc.setFontSize(12.5);
  doc.text("FICHA TÉCNICA DE BORDADOS", pageWidth / 2, y + 6.3, {
    align: "center",
  });
  doc.setTextColor(0);
  doc.setFont(undefined, "normal");
  y += 14;

  const cols = 3;
  const cellGap = 6;
  const cellW = (usableW - cellGap * (cols - 1)) / cols;
  const cellPad = 3;
  const imgAreaH = 46;
  const capFont = 8.5;
  const capLineH = 4;

  for (const item of bordadosFinal) {
    // Encabezado del artículo (banda clara con borde)
    const headH = 8;
    room(headH + imgAreaH + 16);
    doc.setFillColor(...lightBg);
    doc.setDrawColor(...borderColor);
    doc.setLineWidth(0.3);
    doc.rect(marginLeft, y, usableW, headH, "FD");
    doc.setDrawColor(0);
    doc.setFont(undefined, "bold");
    doc.setFontSize(9.5);
    doc.setTextColor(...brandColor);
    doc.text(
      `${s(item.articulo)}   ·   Área: ${s(item.area)}`,
      marginLeft + 3,
      y + headH - 2.5
    );
    doc.setTextColor(0);
    doc.setFont(undefined, "normal");
    y += headH + 3;

    const itemsB = Array.isArray(item.bordados) ? item.bordados : [];
    for (let i = 0; i < itemsB.length; i += cols) {
      const rowItems = itemsB.slice(i, i + cols);

      // preparar: cargar imagen + medir caption para nivelar el alto de la fila
      const prepared = [];
      let maxCapH = 0;
      for (const bordado of rowItems) {
        const imgData = await cargarImagen(getCloudinaryUrl(bordado.public_id));
        const capLines = bordado.observacion
          ? doc.splitTextToSize(String(bordado.observacion), cellW - cellPad * 2)
          : [];
        const capH = capLines.length * capLineH;
        if (capH > maxCapH) maxCapH = capH;
        prepared.push({ imgData, capLines });
      }

      const rowH = imgAreaH + (maxCapH > 0 ? maxCapH + 4 : 2) + cellPad;
      room(rowH + 4);

      let cx = marginLeft;
      for (const cell of prepared) {
        // borde de la celda
        doc.setDrawColor(...borderColor);
        doc.setLineWidth(0.3);
        doc.rect(cx, y, cellW, rowH);
        doc.setDrawColor(0);

        // imagen centrada en el área superior
        if (cell.imgData) {
          const props = doc.getImageProperties(cell.imgData);
          let w = cellW - cellPad * 2;
          let h = (props.height * w) / props.width;
          const maxH = imgAreaH - cellPad * 2;
          if (h > maxH) {
            h = maxH;
            w = (props.width * h) / props.height;
          }
          const ox = cx + (cellW - w) / 2;
          const oy = y + cellPad + (imgAreaH - cellPad * 2 - h) / 2;
          doc.addImage(cell.imgData, "PNG", ox, oy, w, h);
        } else {
          doc.setFontSize(7);
          doc.setTextColor(150);
          doc.text("Sin imagen", cx + cellW / 2, y + imgAreaH / 2, {
            align: "center",
          });
          doc.setTextColor(0);
        }

        // caption (observación) debajo de una línea divisoria
        if (cell.capLines.length) {
          doc.setDrawColor(...borderColor);
          doc.line(cx, y + imgAreaH, cx + cellW, y + imgAreaH);
          doc.setDrawColor(0);
          doc.setFont(undefined, "normal");
          doc.setFontSize(capFont);
          doc.setTextColor(...labelColor);
          doc.text(cell.capLines, cx + cellPad, y + imgAreaH + capLineH + 1);
          doc.setTextColor(0);
        }
        cx += cellW + cellGap;
      }
      y += rowH + cellGap;
    }
    y += 3;
  }
  doc.setLineWidth(0.2);
  return y;
}

async function PDFOCPS(
  id,
  numero,
  proceso,
  maquilero,
  pedido,
  fechaCompromiso,
  totalPiezas,
  precio,
  totalGeneral,
  fecha,
  idArticulo,
  ordenCorteConsecutivo,
  cliente,
  corteObservaciones,
  // L24 (2026-06) — permiso crt_pdfPrecios del usuario en sesión
  puedeVerPrecios = false,
  // L72 (2026-06) — número interno (texto manual) de la OC
  numeroInternoOC = "",
  // L107 (2026-06) — empresa del pedido (para elegir el logo)
  empresa = "",
  // LFISC (2026-07) — objeto empresa completo (datos fiscales) para el encabezado
  empresaObj = null,
  // (2026-08) true = SOLO la hoja de habilitación (botón aparte en el modal)
  soloHabilitacion = false,
  // (2026-10) true = se descarga en vez de abrir pestaña (cuando sale solo al
  // guardar la salida: el navegador bloquea pestañas que no abre un clic)
  descargar = false
) {
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);
  const getArticuloDescripcion = (a) =>
    s(a?.articulos?.[0]?.subDepartamentos?.[0]?.name);
  const getArticuloId = (a) => s(a?.articulos?.[0]?._id);

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size)
      out.push(arr.slice(i, i + size));
    return out;
  };

  const collatorES = new Intl.Collator("es", {
    sensitivity: "base",
    numeric: true,
  });

  const isSinVar = (name) => {
    const t = s(name).trim().toLowerCase();
    return !t || t === "sin variante" || t === "na";
  };

  const getImageAsDataURL = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          reject(e);
        }
      };

      img.onerror = reject;
      img.src = url;
    });

  try {
    // ================= PREGUNTA SI VA CON PRECIOS =================
    // L24 (2026-06) — solo usuarios con crt_pdfPrecios pueden pedir el PDF con precios.
    // Si no tienen el permiso, ni se les muestra el prompt y sale sin precios.
    let mostrarPrecios = false;
    if (puedeVerPrecios) {
      const respPrecios = await Swal.fire({
        title: "¿Mostrar precios en el PDF?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        reverseButtons: true,
      });
      mostrarPrecios = respPrecios.isConfirmed;
    }

    const { data: allArticulosCorte } = await axios.get(
      `${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${id}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const doc = new jsPDF({ orientation: "landscape" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const marginLeft = 15;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 55;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // === L49 (2026-06) — Paleta y helpers ===
    // L114 (2026-06) — morado si la empresa es UNIFORMES INNOVACIÓN (logo Donnatela)
    const brandColor = /Donnatela/i.test(logoInstSrc(empresa))
      ? [205, 184, 245]
      : [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = s(value).trim();
      doc.text(txt || "—", valX, y);
    };

    // (2026-08) El encabezado (logo + folio + datos fiscales + card) se dibuja
    // también en la hoja de habilitación, por eso vive en una función.
    const cardW = pageWidth - marginLeft * 2;
    const dibujarEncabezado = async (titulo) => {
      // ================= LOGO IZQUIERDA + TÍTULO DERECHA =================
      const img2 = new Image();
      img2.src = logoInstSrc(empresa); // L107
      await new Promise((resolve) => {
        img2.onload = () => {
          const maxH = /Donnatela/i.test(img2.src) ? 22 : 16; // L115 logo Donnatela más grande
          const scale = maxH / img2.height;
          doc.addImage(img2, "png", marginLeft, 8, img2.width * scale, maxH);
          resolve();
        };
        img2.onerror = () => resolve();
      });

      doc.setFont(undefined, "bold");
      doc.setFontSize(16);
      doc.setTextColor(...brandColor);
      doc.text(titulo, pageWidth - marginLeft, 18, { align: "right" });
      doc.setTextColor(0);

      // LFISC (2026-07) — Datos fiscales de la empresa propia, debajo del folio
      // (replica ListadoPedidos.jsx L32).
      if (empresaObj) {
        doc.setFont(undefined, "bold");
        doc.setFontSize(9.5);
        doc.setTextColor(60, 60, 60);
        doc.text(
          s(empresaObj.razonSocial) || s(empresaObj.name) || "",
          pageWidth - marginLeft,
          23,
          { align: "right" }
        );
        doc.setFont(undefined, "normal");
        doc.setFontSize(8.5);
        doc.setTextColor(...labelColor);
        const fiscalLine = [
          empresaObj.rfc ? `RFC: ${s(empresaObj.rfc)}` : "",
          empresaObj.regimenFiscal ? `Rég. Fiscal: ${s(empresaObj.regimenFiscal)}` : "",
        ]
          .filter((x) => x)
          .join("   ·   ");
        if (fiscalLine) {
          doc.text(fiscalLine, pageWidth - marginLeft, 27, { align: "right" });
        }
        const direccionStr = [
          s(empresaObj.direccionFiscal),
          empresaObj.cp ? `C.P. ${s(empresaObj.cp)}` : "",
        ]
          .filter((x) => x)
          .join(", ");
        if (direccionStr) {
          const dirAvailW = pageWidth - marginLeft - (marginLeft + 60);
          const dirLines = doc.splitTextToSize(direccionStr, dirAvailW);
          dirLines.forEach((line, i) => {
            doc.text(line, pageWidth - marginLeft, 31 + i * 3.8, { align: "right" });
          });
        }
        doc.setTextColor(0);
      }

      // Línea divisoria — corro abajo si hay empresa para no encimar
      const headerLineY = empresaObj ? 40 : 28;
      doc.setDrawColor(...brandColor);
      doc.setLineWidth(0.6);
      doc.line(marginLeft, headerLineY, pageWidth - marginLeft, headerLineY);
      doc.setLineWidth(0.2);
      doc.setDrawColor(0);

      // ================= CARD 2 COLUMNAS DATOS =================
      const cardY = headerLineY + 3;
      // L72 (2026-06) — bump cardH para fila extra "N° Interno"
      const cardH = 33;
      doc.setDrawColor(...borderColor);
      doc.setFillColor(...lightBg);
      doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
      doc.setDrawColor(0);

      const lblX_L = marginLeft + 3;
      const valX_L = marginLeft + 26;
      const baseY = cardY + 6;
      drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY);
      drawLabel("Cliente:", cliente, lblX_L, valX_L, baseY + 5);
      drawLabel("Proceso:", proceso, lblX_L, valX_L, baseY + 10);
      drawLabel("Taller:", maquilero, lblX_L, valX_L, baseY + 15);

      const colRightX = pageWidth / 2 + 5;
      const lblX_R = colRightX;
      const valX_R = colRightX + 28;
      drawLabel("Pedido:", pedido, lblX_R, valX_R, baseY);
      drawLabel("Articulo:", ordenCorteConsecutivo, lblX_R, valX_R, baseY + 5);
      // L72 (2026-06) — número interno (texto) abajo del autoincrement
      drawLabel("OP:", numeroInternoOC, lblX_R, valX_R, baseY + 10);
      drawLabel("Compromiso:", fechaCompromiso, lblX_R, valX_R, baseY + 15);
      drawLabel("Total Piezas:", sn(totalPiezas, 0), lblX_R, valX_R, baseY + 20);

        return cardY + cardH + 6;
    };

    // (2026-08) Firmas: se dibujan al pie de la hoja de procesos y otra vez
    // al pie de la hoja de habilitación.
    const dibujarFirmas = () => {
      // ================= FIRMAS =================
      // (2026-08) Las firmas se anclan al pie de la MISMA hoja cuando hay lugar,
      // para no provocar una segunda página solo por el espacio de la firma.
      // Solo si de plano ya no caben se abre hoja nueva.
      const bloqueH = 22;              // línea + leyendas
      const yTope = pageHeight - 16;   // arriba del pie de página
      let firmaY;
      if (currentY + bloqueH <= yTope) {
        firmaY = Math.max(currentY + 12, yTope - bloqueH);
      } else {
        doc.addPage();
        currentY = marginTop;
        firmaY = currentY + 12;
      }
      currentY = firmaY + bloqueH;

      const firmaWidth = 80;
      const firmaX = marginLeft;

      doc.setLineWidth(0.3);
      doc.line(firmaX, firmaY, firmaX + firmaWidth, firmaY);

      doc.setFont(undefined, "bold");
      doc.setFontSize(9);
      doc.text("Firma Maquilero", firmaX + firmaWidth / 2, firmaY + 5, {
        align: "center",
      });

      doc.setFont(undefined, "normal");
      doc.setFontSize(8);
      if (s(maquilero)) {
        doc.text(s(maquilero), firmaX + firmaWidth / 2, firmaY + 10, {
          align: "center",
        });
      }
      if (s(fecha)) {
        doc.text(`Fecha: ${s(fecha)}`, firmaX + firmaWidth / 2, firmaY + 15, {
          align: "center",
        });
      }

      // Línea de "Recibí conforme" del lado derecho
      const recibiX = pageWidth - marginLeft - firmaWidth;
      doc.setLineWidth(0.3);
      doc.line(recibiX, firmaY, recibiX + firmaWidth, firmaY);

      doc.setFont(undefined, "bold");
      doc.setFontSize(9);
      doc.text("Firma del encargado", recibiX + firmaWidth / 2, firmaY + 5, {
        align: "center",
      });

    };

    currentY = await dibujarEncabezado(
      soloHabilitacion
        ? `HABILITACIÓN — SALIDA # ${s(numero)}`
        : `PROCESO SALIDA # ${s(numero)}`
    );

    // (2026-08) Botón aparte: solo la hoja de habilitación
    if (soloHabilitacion) {

    // ================= HOJA DE HABILITACIÓN (2026-08) =================
    // Documento propio: mismo encabezado y firmas que la salida de procesos.
    try {
      const { data: habilitaciones } =
        await axios.get(
          `${URL_DETALLE_HABILITACION_CORTES}/proceso/${id}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );

      // L50 (2026-06) — Habilitaciones con banda azul + gap suficiente para evitar overlap
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, 7, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text("HABILITACIONES", marginLeft + 3, currentY + 5);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      // 7mm banda + 4mm gap = baseline del siguiente texto en bandY+11
      currentY += 11;

      // L71 (2026-06) — ocultar habilitaciones con cantidad 0
      const habilitacionesConCant = (habilitaciones || []).filter(
        (a) => Number(a.cantidad) > 0
      );
      if (habilitacionesConCant.length) {
        const tablaHabilitaciones =
          habilitacionesConCant.map((a) => [
            a.habilitacionCortes?.[0]?.fecha || "-",

            `${a.habilitacion?.[0]?.nombre || ""} ${
              a.habilitacion?.[0]?.descripcion || ""
            }`.trim(),

            sn(a.cantidad, 0),
          ]);

        doc.autoTable({
          head: [["Fecha", "Descripción", "Cantidad"]],
          body: tablaHabilitaciones,
          startY: currentY,
          margin: {
            left: marginLeft,
            right: marginLeft,
          },
          // L49 (2026-06) — tabla habilitaciones consistente
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
          columnStyles: {
            0: { cellWidth: 35 },
            1: {
              cellWidth:
                pageWidth -
                marginLeft * 2 -
                55,
            },
            2: { cellWidth: 20 },
          },
        });

        currentY =
          doc.autoTable.previous.finalY + 8;
      } else {
        doc.setFont(undefined, "normal");
        doc.setFontSize(9);

        doc.text(
          "No hay habilitaciones registradas.",
          marginLeft,
          currentY
        );

        currentY += 6;
      }

      dibujarFirmas();
    } catch (err) {
      console.warn(
        "No se pudieron cargar habilitaciones"
      );
    }

      // pie y salida: este PDF no lleva bordados ni resumen de procesos
      try {
        const pageCount = doc.internal.getNumberOfPages();
        for (let p = 1; p <= pageCount; p++) {
          doc.setPage(p);
          doc.setFontSize(8);
          doc.setTextColor(...labelColor);
          doc.text(
            `Habilitación Salida #${s(numero)}  ·  ${s(cliente)}  ·  Página ${p} de ${pageCount}`,
            pageWidth / 2,
            pageHeight - 5,
            { align: "center" }
          );
          doc.setTextColor(0);
        }
      } catch (e) {}

      window.open(doc.output("bloburl"), "_blank");
      return;
    }


    // ================= OBSERVACIONES DEL CORTE — L49 caja con label band =================
    const obsCorte = s(corteObservaciones).trim().replace(/\t/g, "  ").replace(/\r/g, "");
    if (obsCorte) {
      ensureRoom(14);
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, cardW, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.text("OBSERVACIONES", marginLeft + 3, currentY + 4.2);
      doc.setTextColor(0);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      const obsLines = doc.splitTextToSize(obsCorte, cardW - 12);
      const blockH = obsLines.length * 4.2;
      ensureRoom(blockH + 6);
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, currentY, cardW, blockH + 5, "FD");
      doc.setDrawColor(0);
      doc.text(obsLines, marginLeft + 3, currentY + 4);
      currentY += blockH + 8;
    }

    // ================= AGRUPAR POR ÁREA / ARTÍCULO =================
    const gruposMap = {};
    const bordadosMap = {};

    // Los bordados viven en ArticulosPedido.bordados (igual que ListadoPedidos).
    // ArticulosProcesosSalida NO guarda el ref articulosPedido, así que traemos
    // los ArticulosPedido de los pedidos del corte y los mapeamos por área+artículo.
    const normBordado = (b) => ({
      observacion: s(
        b?.observacion || b?.observaciones || b?.name || b?.descripcion || ""
      ),
      public_id: s(b?.public_id || b?.secure_url || b?.url || ""),
      version: s(b?.version || ""),
    });

    // (2026-07) normaliza la observación para el dedup: sin espacios y en
    // mayúsculas, para que un mismo bordado capturado con espaciado distinto en la
    // medida ("3.08CM" vs "3.08 CM") se trate como uno solo, igual que en
    // ListadoOrdenesCorte. NO cambia el texto que se imprime, solo la comparación.
    const obsKey = (o) => String(o || "").replace(/\s+/g, "").toUpperCase();

    // (2026-07) EXACTAMENTE como ListadoOrdenesCorte: los bordados de cada renglón
    // salen del PRIMER ArticuloPedido que coincide por (pedido, artículo, área). NO
    // se agregan los bordados de todos los colores del artículo, porque el mismo
    // logo se re-subió varias veces (distinto public_id/version) y salía duplicado.
    const apsBordados = [];
    const pedidoIdsBordados = [
      ...new Set(
        allArticulosCorte
          .map((a) => s(a?.pedidos?.[0]?._id || a?.pedidos?.[0] || ""))
          .filter(Boolean)
      ),
    ];

    await Promise.all(
      pedidoIdsBordados.map(async (pid) => {
        try {
          const { data } = await axios.get(
            `${URL_ARTICULOS_PEDIDO}/pedidos/${pid}`,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          (Array.isArray(data) ? data : []).forEach((ap) => apsBordados.push(ap));
        } catch (e) {
          console.log("No se pudieron traer bordados del pedido", pid, e);
        }
      })
    );

    const getBordadosArt = (a) => {
      const pedidoId = s(a?.pedidos?.[0]?._id || a?.pedidos?.[0]);
      const articuloId = s(
        getArticuloId(a) || a?.articulos?.[0]?._id || a?.articulos?.[0]
      );
      const areaId = s(a?.areasClientes?.[0]?._id || a?.areasClientes?.[0]);
      const ap = apsBordados.find((x) => {
        const apPedidoId = s(x?.pedidos?.[0]?._id || x?.pedidos?.[0]);
        const apArticuloId = s(x?.articulos?.[0]?._id || x?.articulos?.[0]);
        const apAreaId = s(x?.areasClientes?.[0]?._id || x?.areasClientes?.[0]);
        return (
          apPedidoId === pedidoId &&
          apArticuloId === articuloId &&
          apAreaId === areaId
        );
      });
      const bordados = Array.isArray(ap?.bordados) ? ap.bordados : [];
      return bordados
        .map(normBordado)
        .filter((b) => b.public_id || b.observacion);
    };

    allArticulosCorte.forEach((a) => {
      const areaSan = getFirstName(a.areasClientes) || "Sin Área";

      const articuloSan =
        `${getArticuloCodigo(a)} ${getArticuloDescripcion(a)}`.trim();

      const articulo = articuloSan || "Artículo sin nombre";

      const articuloId = getArticuloId(a) || "sin-id";

      const clave = `${areaSan}||${articulo}||${articuloId}`;

      if (!gruposMap[clave]) gruposMap[clave] = [];

      gruposMap[clave].push(a);

      const bordadosArt = getBordadosArt(a);
      if (bordadosArt.length > 0) {
        const bordadoKey = `${areaSan}||${articulo}`;
        if (!bordadosMap[bordadoKey]) {
          bordadosMap[bordadoKey] = { area: areaSan, articulo, bordados: [] };
        }
        bordadosArt.forEach((b) => {
          const existe = bordadosMap[bordadoKey].bordados.some(
            (x) =>
              x.public_id === b.public_id &&
              x.version === b.version &&
              obsKey(x.observacion) === obsKey(b.observacion)
          );
          if (!existe) bordadosMap[bordadoKey].bordados.push(b);
        });
      }
    });

    const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

    for (const clave in gruposMap) {
      const grupo = gruposMap[clave];

      const [areaNombre, articuloNombre] = clave.split("||");

      // === L49 (2026-06) — Banda azul como header del grupo ===
      ensureRoom(22);
      const bandH = 8;
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, bandH, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10.5);
      doc.text(
        `${s(areaNombre) || "Sin Área"}   ·   Modelo: ${s(articuloNombre) || "Artículo sin nombre"}`,
        marginLeft + 3,
        currentY + bandH - 2.5
      );
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += bandH + 3;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);

      // ===== AGRUPAR =====
      const data = {};
      const totalVariante = {};
      const tallasMap = new Map();

      grupo.forEach((a) => {
        const color = getFirstName(a.colores) || "Sin color";

        const tallaName =
          s(a?.tallas?.[0]?.name?.trim()) || "Sin talla";

        const varianteNameRaw = s(
          a?.tallas?.[0]?.variantesTallas?.[0]?.name?.trim()
        );

        const varianteName = varianteNameRaw
          ? varianteNameRaw
          : "Sin variante";

        const cantidad = sn(a?.cantidadSalida, 0);

        if (!data[color]) data[color] = {};

        if (!data[color][varianteName])
          data[color][varianteName] = {};

        if (!data[color][varianteName][tallaName])
          data[color][varianteName][tallaName] = 0;

        data[color][varianteName][tallaName] += cantidad;

        if (!totalVariante[color]) totalVariante[color] = {};

        if (!totalVariante[color][varianteName])
          totalVariante[color][varianteName] = 0;

        totalVariante[color][varianteName] += cantidad;

        tallasMap.set(tallaName, true);
      });

      const tallasOrdenadas = Array.from(tallasMap.keys()).sort(
        (a, b) => {
          const indexA = ordenTallas.indexOf(a);
          const indexB = ordenTallas.indexOf(b);

          return (
            (indexA === -1 ? Infinity : indexA) -
            (indexB === -1 ? Infinity : indexB)
          );
        }
      );

      let totalPiezasGrupo = 0;

      Object.keys(totalVariante || {}).forEach((color) => {
        Object.keys(totalVariante[color] || {}).forEach((variante) => {
          totalPiezasGrupo += sn(
            totalVariante[color][variante],
            0
          );
        });
      });

      const usableWidth = pageWidth - marginLeft * 2;

      const colorW = 32;
      const totalW = 12;
      const minTallaW = 5.8;

      const maxTallasPerRow = Math.max(
        1,
        Math.floor(
          (usableWidth - colorW - totalW) / minTallaW
        )
      );

      const chunkSize = Math.max(
        1,
        Math.min(maxTallasPerRow, tallasOrdenadas.length)
      );

      const tallasChunks = chunk(
        tallasOrdenadas,
        chunkSize
      );

      const colores = Object.keys(data);

      for (let ci = 0; ci < tallasChunks.length; ci++) {
        const chunkTallas = tallasChunks[ci];

        const nTallas = chunkTallas.length;

        const tallaW =
          (usableWidth - colorW - totalW) /
          Math.max(1, nTallas);

        const colStyles = {
          0: { cellWidth: colorW },
          [1 + nTallas]: { cellWidth: totalW },
        };

        for (let i = 0; i < nTallas; i++) {
          colStyles[1 + i] = { cellWidth: tallaW };
        }

        const headChunk = [["Color", ...chunkTallas, "Total"]];

        const bodyChunk = [];

        for (const color of colores) {
          const variantesRaw = Object.keys(data[color] || {});

          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);

            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;

            return collatorES.compare(a, b);
          });

          let firstVar = true;

          for (const variante of variantes) {
            const totVar = sn(
              totalVariante?.[color]?.[variante],
              0
            );

            if (totVar <= 0) continue;

            const row = new Array(
              1 + nTallas + 1
            ).fill("");

            const tituloVar = isSinVar(variante)
              ? ""
              : s(variante);

            const colorTxt = firstVar ? s(color) : "";

            row[0] = tituloVar
              ? colorTxt
                ? `${colorTxt}\n${tituloVar}`
                : tituloVar
              : colorTxt
              ? colorTxt
              : "";

            chunkTallas.forEach((talla, idx) => {
              const val = sn(
                data?.[color]?.[variante]?.[talla],
                0
              );

              row[1 + idx] =
                val > 0 ? String(val) : "";
            });

            row[row.length - 1] = String(totVar);

            bodyChunk.push(row);

            firstVar = false;
          }
        }

        ensureRoom(22);

        doc.autoTable({
          head: headChunk,
          body: bodyChunk,
          startY: currentY,
          margin: {
            left: marginLeft,
            right: marginLeft,
          },
          tableWidth: usableWidth,
          // L49 (2026-06) — tabla profesional con zebra + brand color
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
          columnStyles: colStyles,
        });

        currentY =
          doc.autoTable.previous.finalY + 4;
      }

      // ===== L49 (2026-06) — Total piezas como chip =====
      ensureRoom(10);
      const chipTextG = `TOTAL PIEZAS: ${totalPiezasGrupo}`;
      doc.setFontSize(9.5);
      doc.setFont(undefined, "bold");
      const chipPad = 3;
      const chipW = doc.getTextWidth(chipTextG) + chipPad * 2;
      const chipH = 6;
      const chipX = pageWidth - marginLeft - chipW;
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...brandColor);
      doc.setLineWidth(0.3);
      doc.roundedRect(chipX, currentY, chipW, chipH, 1.5, 1.5, "FD");
      doc.setLineWidth(0.2);
      doc.setTextColor(...brandColor);
      doc.text(chipTextG, chipX + chipPad, currentY + chipH - 1.7);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      doc.setDrawColor(0);
      currentY += chipH + 4;

      ensureRoom(4);
      doc.setDrawColor(...borderColor);
      doc.line(marginLeft, currentY, pageWidth - marginLeft, currentY);
      doc.setDrawColor(0);
      currentY += 5;
    }

    // =========================================================
    // HOJA DE BORDADOS (estilo ListadoPedidos)
    // =========================================================
    const bordadosFinal = Object.values(bordadosMap);

    // La hoja de bordados se dibuja al FINAL, en hoja aparte después de las firmas.
    const renderHojaBordados = async () => {
      await dibujarFichaBordados(doc, bordadosFinal, {
        getCloudinaryUrl: (pid) => {
          const p = String(pid || "").trim();
          if (!p) return "";
          return p.startsWith("http")
            ? p
            : `https://res.cloudinary.com/lynqro/image/upload/${p}`;
        },
        loadImagePDF: getImageAsDataURL,
        pageWidth,
        marginLeft,
        marginTop,
        brandColor,
        lightBg,
        borderColor,
        labelColor,
        s,
      });
    };

// ================= RESUMEN DE PRECIOS =================
if (mostrarPrecios) {
  const subtotal = sn(totalGeneral, 0);
  const iva = subtotal * 0.16;
  const totalConIVA = subtotal + iva;

  ensureRoom(35);
  doc.setFont(undefined, "bold");
  doc.setFontSize(11);
  doc.text("RESUMEN", 15 + 10, currentY, { align: "center" });

  currentY += 6;

  doc.setFontSize(9.5);
  doc.text(`Piezas: ${sn(totalPiezas, 0)}`, 15, currentY);
  currentY += 5;

  doc.text(
    `Precio: ${new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(sn(precio, 0))}`,
    15,
    currentY
  );
  currentY += 5;

  doc.text(
    `Total: ${new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(subtotal)}`,
    15,
    currentY
  );
  currentY += 5;

  // doc.text(
  //   `IVA: ${new Intl.NumberFormat("en-US", {
  //     style: "currency",
  //     currency: "USD",
  //     maximumFractionDigits: 2,
  //   }).format(iva)}`,
  //   15,
  //   currentY
  // );
  // currentY += 5;

  // doc.text(
  //   `Total: ${new Intl.NumberFormat("en-US", {
  //     style: "currency",
  //     currency: "USD",
  //     maximumFractionDigits: 2,
  //   }).format(totalConIVA)}`,
  //   15,
  //   currentY
  // );

  currentY += 8;
} else {
  // Resumen sin precios — solo total de piezas
  ensureRoom(20);
  doc.setFont(undefined, "bold");
  doc.setFontSize(11);
  doc.text("RESUMEN", 15 + 10, currentY, { align: "center" });

  currentY += 6;

  doc.setFontSize(9.5);
  doc.text(`Piezas: ${sn(totalPiezas, 0)}`, 15, currentY);
  currentY += 5;

  currentY += 8;
}

    dibujarFirmas();

    // Hoja de bordados al final, en página aparte después de las firmas
    await renderHojaBordados();

    // ================= FOOTER L49 — pie con paginación =================
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Proceso Salida #${s(numero)}  ·  ${s(cliente)}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    if (descargar) doc.save(`Salida de proceso ${s(numero)}.pdf`);
    else window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF:", err);

    Swal.fire(
      "Error",
      "No se pudo generar el PDF",
      "error"
    );
  }
}

  function PDFProcesosEntrada(id, numero) {
    setCorteDetallePE(id);
    cargarEntradasPE(id);
    togglePDFPE();
  }

  // (2026-10) renglones del modal Detalle Entrada Procesos; también lo
  // refresca en su lugar al editar una entrada
  function cargarEntradasPE(id) {
    // LFISC (2026-07) — El endpoint ProcesosEntrada/corte NO popula pedidos.empresas,
    // así que resuelvo el objeto empresa (con datos fiscales) desde el listado `cortes`
    // ya cargado (findOneFechas SÍ popula ordenesCorte.pedidos.empresas), matcheando por
    // el id del corte (= parámetro `id` de esta función).
    const corteMatch = (cortes || []).find((c) => String(c?._id) === String(id));
    const empresaObjPE =
      corteMatch?.ordenesCorte?.[0]?.pedidos?.[0]?.empresas?.[0] || null;
    return axios
      .get(`${URL_PROCESOS_ENTRADA}/corte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .sort((a, b) => (a.idProcesosEntrada < b.idProcesosEntrada ? 1 : -1))
          .map((a) => {
            return {
              id: a._id,
              // (2026-07) _id del proveedor para prellenar el editar entrada
              idProveedor: a.proveedores?.[0]?._id || "",
              catalogosProcesosName: a.catalogoProcesos[0].name,
              proveedoresName: a.proveedores[0].nombre_comercial,
              pedido: a.pedidos[0].idPedido,
              totalGeneral: a.totalGeneral,
              totalPiezas: a.totalPiezas,
              totalPiezasFaltantes: a.totalPiezasFaltantes,
              totalPiezasSegundas: a.totalPiezasSegundas,
              precio: a.precio,
              numero: a.idProcesosEntrada,
              fecha: a.fecha,
              articulo:
                a.articulos[0].codigo +
                " / " +
                a.articulos[0].subDepartamentos[0].name,
              // Nuevos campos: #Corte, orden de producción, #Artículo, Línea
              numeroCorte: a.cortes?.[0]?.idCorte || "",
              numeroOrdenProduccion:
                a.cortes?.[0]?.ordenesCorte?.[0]?.numero || "",
              numeroArticulo:
                a.cortes?.[0]?.ordenesCorte?.[0]?.idOrdenesCorte || "",
              linea: a.articulos?.[0]?.departamentos?.[0]?.name || "",
              // LFISC (2026-07) — empresa (logo string + objeto fiscal) del corte
              empresa:
                empresaObjPE?.razonSocial || empresaObjPE?.name || "",
              empresaObj: empresaObjPE,
              // TG3 — observaciones de la entrada de proceso
              observaciones: a.observaciones || "",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setPDFPE(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // TG4 — misma info que PDFOCPE pero en formato ticket térmico (80mm)
  async function PDFOCPE_Ticket(
    id,
    numero,
    proceso,
    maquilero,
    totalPiezas,
    totalPiezasFaltantes,
    totalPiezasSegundas,
    precio,
    fecha,
    totalGeneral,
    mostrarPrecios = true,
    observacionesEntrada = "",
    extra = {}
  ) {
    const {
      numeroCorte = "",
      numeroOrdenProduccion = "",
      numeroArticulo = "",
      linea = "",
    } = extra;
    const s = (v) => {
      if (v === null || v === undefined) return "";
      if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
      return typeof v === "string" ? v : String(v);
    };
    const sn = (v, def = 0) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : def;
    };
    const firstName = (arr) =>
      Array.isArray(arr) && arr[0] ? arr[0].name || arr[0].nombre || "" : "";
    try {
      const { data: items } = await axios.get(
        `${URL_ARTICULOS_PROCESOS_ENTRADA}/proceso/${id}`,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );

      // Agrupar: área -> artículo -> [{ COLOR TALLA[/VAR], cantidad }]
      // El label del artículo incluye la Línea (si existe)
      const grupos = {};
      (items || []).forEach((a) => {
        const area = firstName(a.areasClientes) || "Sin Área";
        const artSalida = a.articulosProcesosSalida?.[0]?.articulos?.[0];
        const lineaArt = firstName(artSalida?.departamentos) || "";
        const artBase =
          (artSalida?.codigo || "") +
          (artSalida?.subDepartamentos?.[0]?.name
            ? " / " + artSalida.subDepartamentos[0].name
            : "");
        const art = lineaArt
          ? `${artBase}   ·   Línea: ${lineaArt}`
          : artBase;
        const color = firstName(a.colores) || "Sin color";
        const talla = s(a?.tallas?.[0]?.name) || "Sin talla";
        const varTalla = s(a?.tallas?.[0]?.variantesTallas?.[0]?.name);
        const cant = sn(a?.cantidadEntrada, 0);
        if (cant <= 0) return;
        const ak = art || "Artículo";
        grupos[area] = grupos[area] || {};
        grupos[area][ak] = grupos[area][ak] || [];
        grupos[area][ak].push({
          label: `${color} ${talla}${varTalla ? " / " + varTalla : ""}`,
          cant,
        });
      });

      let rows = 0;
      Object.keys(grupos).forEach((g) => {
        rows += 1;
        Object.keys(grupos[g]).forEach((art) => {
          rows += 1 + grupos[g][art].length;
        });
      });
      const obsCount = observacionesEntrada
        ? Math.ceil(s(observacionesEntrada).length / 38) + 1
        : 0;
      const alturaTotal =
        90 + rows * 6 + obsCount * 5 + (mostrarPrecios ? 16 : 0);

      const doc = new jsPDF({ orientation: "p", unit: "mm", format: [80, alturaTotal] });
      const W = 80;
      const mX = 4;
      const maxW = W - mX * 2;
      let y = 8;
      const adv = (dy = 4) => {
        y += dy;
      };
      const center = (txt, size = 9, bold = false) => {
        doc.setFont("helvetica", bold ? "bold" : "normal");
        doc.setFontSize(size);
        doc.text(String(txt), W / 2, y, { align: "center" });
      };
      const left = (txt, size = 8, bold = false) => {
        doc.setFont("helvetica", bold ? "bold" : "normal");
        doc.setFontSize(size);
        const ls = doc.splitTextToSize(String(txt), maxW);
        doc.text(ls, mX, y);
        y += (ls.length - 1) * (size * 0.42);
      };
      const sep = () => {
        doc.setLineWidth(0.2);
        doc.line(mX, y, W - mX, y);
      };

      center("ENTRADA DE PROCESO", 11, true);
      adv(5);
      center(`Folio: ${s(numero)}`, 9, true);
      adv(4);
      sep();
      adv(4);
      left(`Fecha: ${s(fecha)}`);
      adv(4);
      left(`Proceso: ${s(proceso)}`);
      adv(4);
      left(`Taller: ${s(maquilero)}`);
      adv(4);
      left(`Total Piezas: ${sn(totalPiezas, 0)}`, 8, true);
      adv(4);
      if (s(numeroCorte)) { left(`# Corte: ${s(numeroCorte)}`); adv(4); }
      if (s(numeroOrdenProduccion)) { left(`Orden Producción: ${s(numeroOrdenProduccion)}`); adv(4); }
      if (s(numeroArticulo)) { left(`# Artículo: ${s(numeroArticulo)}`); adv(4); }
      if (s(linea)) { left(`Línea: ${s(linea)}`); adv(4); }
      adv(1);
      sep();
      adv(4);

      Object.keys(grupos).forEach((g) => {
        left(`ÁREA: ${g}`, 8.5, true);
        adv(4);
        Object.keys(grupos[g]).forEach((art) => {
          left(art, 8, true);
          adv(3.6);
          grupos[g][art].forEach((r) => {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            doc.text(r.label, mX + 2, y);
            doc.text(String(r.cant), W - mX, y, { align: "right" });
            adv(3.8);
          });
          adv(1);
        });
      });

      sep();
      adv(4);
      if (mostrarPrecios) {
        const money = (n) =>
          new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(sn(n, 0));
        left(`Precio: ${money(precio)}`);
        adv(4);
        left(`Total: ${money(totalGeneral)}`, 9, true);
        adv(5);
        sep();
        adv(4);
      }

      if (s(observacionesEntrada)) {
        left("Observaciones:", 8, true);
        adv(4);
        left(s(observacionesEntrada));
        adv(5);
        sep();
        adv(4);
      }

      adv(8);
      doc.setLineWidth(0.2);
      doc.line(mX + 6, y, W - mX - 6, y);
      adv(3.5);
      center("Firma Maquilero", 8);
      if (s(maquilero)) {
        adv(4);
        center(s(maquilero), 8);
      }

      doc.output("dataurlnewwindow");
    } catch (err) {
      console.error("Error PDFOCPE_Ticket:", err);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo generar el ticket." });
    }
  }

async function PDFOCPE(
  id,
  numero,
  proceso,
  maquilero,
  totalPiezas,
  totalPiezasFaltantes,
  totalPiezasSegundas,
  precio,
  fecha,
  totalGeneral,
  // L114 (2026-06) — empresa (su call site no la pasa → "" → azul); solo para que el
  // brandColor condicional compartido no rompa.
  empresa = "",
  // TF2 — permiso "Ver Precios en PDF Salida" (crt_pdfPrecios). Si es false, el
  // PDFOCPE sale SIN precio ni total (encabezado y resumen).
  mostrarPrecios = true,
  // LFISC (2026-07) — objeto empresa completo (datos fiscales) para el encabezado
  empresaObj = null,
  // TG3 — observaciones de la entrada de proceso (procesosEntrada.observaciones)
  observacionesEntrada = "",
  // Nuevos: #Corte, orden de producción, #Artículo, Línea
  extra = {}
) {
  const { numeroCorte = "", numeroOrdenProduccion = "", numeroArticulo = "", linea = "" } = extra;
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName = (arr) => s(arr?.[0]?.name);

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  const collatorES = new Intl.Collator("es", {
    sensitivity: "base",
    numeric: true,
  });

  const isSinVar = (name) => {
    const t = s(name).trim().toLowerCase();
    return !t || t === "sin variante" || t === "na";
  };

  try {
    const { data: allArticulosCorte } = await axios.get(
      `${URL_ARTICULOS_PROCESOS_ENTRADA}/proceso/${id}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const doc = new jsPDF({ orientation: "landscape" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 55;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // === L49 (2026-06) — Paleta y helpers ===
    // L114 (2026-06) — morado si la empresa es UNIFORMES INNOVACIÓN (logo Donnatela)
    const brandColor = /Donnatela/i.test(logoInstSrc(empresa))
      ? [205, 184, 245]
      : [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];

    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      const txt = s(value).trim();
      doc.text(txt || "—", valX, y);
    };

    // ================= LOGO IZQ + TÍTULO DER =================
    const logo = new Image();
    logo.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
    await new Promise((resolve) => {
      logo.onload = () => {
        const maxH = 16;
        const scale = maxH / logo.height;
        doc.addImage(logo, "png", marginLeft, 8, logo.width * scale, maxH);
        resolve();
      };
      logo.onerror = () => resolve();
    });

    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`PROCESO ENTRADA # ${s(numero)}`, pageWidth - marginLeft, 18, { align: "right" });
    doc.setTextColor(0);

    // LFISC (2026-07) — Datos fiscales de la empresa propia, debajo del folio
    // (replica ListadoPedidos.jsx L32). empresaObj se resuelve en PDFProcesosEntrada
    // desde el listado `cortes` (el endpoint ProcesosEntrada/corte no popula empresas).
    if (empresaObj) {
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(60, 60, 60);
      doc.text(
        s(empresaObj.razonSocial) || s(empresaObj.name) || "",
        pageWidth - marginLeft,
        23,
        { align: "right" }
      );
      doc.setFont(undefined, "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...labelColor);
      const fiscalLine = [
        empresaObj.rfc ? `RFC: ${s(empresaObj.rfc)}` : "",
        empresaObj.regimenFiscal ? `Rég. Fiscal: ${s(empresaObj.regimenFiscal)}` : "",
      ]
        .filter((x) => x)
        .join("   ·   ");
      if (fiscalLine) {
        doc.text(fiscalLine, pageWidth - marginLeft, 27, { align: "right" });
      }
      const direccionStr = [
        s(empresaObj.direccionFiscal),
        empresaObj.cp ? `C.P. ${s(empresaObj.cp)}` : "",
      ]
        .filter((x) => x)
        .join(", ");
      if (direccionStr) {
        const dirAvailW = pageWidth - marginLeft - (marginLeft + 60);
        const dirLines = doc.splitTextToSize(direccionStr, dirAvailW);
        dirLines.forEach((line, i) => {
          doc.text(line, pageWidth - marginLeft, 31 + i * 3.8, { align: "right" });
        });
      }
      doc.setTextColor(0);
    }

    // Línea divisoria — corro abajo si hay empresa para no encimar
    const headerLineY = empresaObj ? 40 : 28;
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, headerLineY, pageWidth - marginLeft, headerLineY);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // ================= CARD 2 COLUMNAS DATOS =================
    const cardY = headerLineY + 3;
    const cardW = pageWidth - marginLeft * 2;
    const cardH = 24;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 30;
    const baseY = cardY + 6;
    drawLabel("Fecha:", fecha, lblX_L, valX_L, baseY);
    drawLabel("Proceso:", proceso, lblX_L, valX_L, baseY + 5);
    drawLabel("Taller:", maquilero, lblX_L, valX_L, baseY + 10);
    drawLabel("Total Piezas:", sn(totalPiezas, 0), lblX_L, valX_L, baseY + 15);

    const colRightX = pageWidth / 2 + 5;
    const lblX_R = colRightX;
    const valX_R = colRightX + 32;
    // Nuevos campos: #Corte, Orden Producción, #Artículo, Línea
    drawLabel("# Corte:", numeroCorte, lblX_R, valX_R, baseY);
    drawLabel("Orden Producción:", numeroOrdenProduccion, lblX_R, valX_R, baseY + 5);
    drawLabel("# Artículo:", numeroArticulo, lblX_R, valX_R, baseY + 10);
    drawLabel("Línea:", linea, lblX_R, valX_R, baseY + 15);

    // TF2 — Precio / Total General solo si tiene el permiso crt_pdfPrecios
    // (los pongo debajo de la card en una línea centrada si aplica)
    if (mostrarPrecios) {
      const precioTxt = `Precio: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(sn(precio, 0))}   ·   Total General: ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(sn(totalGeneral, 0))}`;
      doc.setFont(undefined, "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(...brandColor);
      doc.text(precioTxt, pageWidth / 2, cardY + cardH + 5, { align: "center" });
      doc.setTextColor(0);
    }

    currentY = cardY + cardH + (mostrarPrecios ? 12 : 6);

    const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

    const gruposMap = {};

    allArticulosCorte.forEach((a) => {
      const area = getFirstName(a.areasClientes) || "Sin Área";

      const codigo =
        a.articulosProcesosSalida?.[0]?.articulos?.[0]?.codigo || "";

      const descripcion =
        a.articulosProcesosSalida?.[0]?.articulos?.[0]?.subDepartamentos?.[0]
          ?.name || "";

      const articulo = `${codigo} ${descripcion}`.trim() || "Sin artículo";

      const articuloId =
        a.articulosProcesosSalida?.[0]?.articulos?.[0]?._id || "sin-id";

      const lineaArt =
        getFirstName(
          a.articulosProcesosSalida?.[0]?.articulos?.[0]?.departamentos
        ) || "";

      const clave = `${area}||${articulo}||${articuloId}||${lineaArt}`;

      if (!gruposMap[clave]) gruposMap[clave] = [];
      gruposMap[clave].push(a);
    });

    for (const clave in gruposMap) {
      const grupo = gruposMap[clave];
      const [areaNombre, articuloNombre, , lineaNombre] = clave.split("||");

      // === L49 (2026-06) — Banda azul como header del grupo ===
      ensureRoom(22);
      const bandH = 8;
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, currentY, pageWidth - marginLeft * 2, bandH, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10.5);
      const bandaTxt = `${s(areaNombre) || "Sin Área"}   ·   Modelo: ${
        s(articuloNombre) || "Artículo sin nombre"
      }${s(lineaNombre) ? `   ·   Línea: ${s(lineaNombre)}` : ""}`;
      doc.text(
        bandaTxt,
        marginLeft + 3,
        currentY + bandH - 2.5
      );
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      currentY += bandH + 3;

      const data = {};
      const totalVariante = {};
      const tallasMap = new Map();

      grupo.forEach((a) => {
        const color = getFirstName(a.colores) || "Sin color";
        const tallaName = s(a?.tallas?.[0]?.name?.trim()) || "Sin talla";

        const varianteNameRaw = s(
          a?.tallas?.[0]?.variantesTallas?.[0]?.name?.trim()
        );

        const varianteName = varianteNameRaw
          ? varianteNameRaw
          : "Sin variante";

        const cantidad = sn(a?.cantidadEntrada, 0);

        if (!data[color]) data[color] = {};
        if (!data[color][varianteName]) data[color][varianteName] = {};
        if (!data[color][varianteName][tallaName]) {
          data[color][varianteName][tallaName] = 0;
        }

        data[color][varianteName][tallaName] += cantidad;

        if (!totalVariante[color]) totalVariante[color] = {};
        if (!totalVariante[color][varianteName]) {
          totalVariante[color][varianteName] = 0;
        }

        totalVariante[color][varianteName] += cantidad;

        tallasMap.set(tallaName, true);
      });

      Object.keys(data).forEach((color) => {
        Object.keys(data[color] || {}).forEach((variante) => {
          const tot = sn(totalVariante?.[color]?.[variante], 0);

          if (tot <= 0) {
            delete data[color][variante];
            if (totalVariante[color]) delete totalVariante[color][variante];
          }
        });

        if (!Object.keys(data[color] || {}).length) {
          delete data[color];
          delete totalVariante[color];
        }
      });

      const tallasOrdenadas = Array.from(tallasMap.keys()).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);

        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      let totalPiezasGrupo = 0;

      Object.keys(totalVariante || {}).forEach((color) => {
        Object.keys(totalVariante[color] || {}).forEach((variante) => {
          totalPiezasGrupo += sn(totalVariante[color][variante], 0);
        });
      });

      const usableWidth = pageWidth - marginLeft * 2;
      const colorW = 32;
      const totalW = 12;
      const minTallaW = 5.8;

      const maxTallasPerRow = Math.max(
        1,
        Math.floor((usableWidth - colorW - totalW) / minTallaW)
      );

      const chunkSize = Math.max(
        1,
        Math.min(maxTallasPerRow, tallasOrdenadas.length)
      );

      const tallasChunks = chunk(tallasOrdenadas, chunkSize);
      const colores = Object.keys(data);

      for (let ci = 0; ci < tallasChunks.length; ci++) {
        const chunkTallas = tallasChunks[ci];
        const nTallas = chunkTallas.length;

        const tallaW =
          (usableWidth - colorW - totalW) / Math.max(1, nTallas);

        const colStyles = {
          0: { cellWidth: colorW },
          [1 + nTallas]: { cellWidth: totalW },
        };

        for (let i = 0; i < nTallas; i++) {
          colStyles[1 + i] = { cellWidth: tallaW };
        }

        const headChunk = [["Color", ...chunkTallas, "Total"]];
        const bodyChunk = [];

        for (const color of colores) {
          const variantesRaw = Object.keys(data[color] || {});

          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);

            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;

            const cleanA = s(a).trim();
            const cleanB = s(b).trim();

            const baseA = cleanA.split(/[+-]/)[0].trim();
            const baseB = cleanB.split(/[+-]/)[0].trim();

            const baseCompare = collatorES.compare(baseA, baseB);
            if (baseCompare !== 0) return baseCompare;

            const aHasPlus = cleanA.includes("+");
            const bHasPlus = cleanB.includes("+");
            const aHasMinus = cleanA.includes("-");
            const bHasMinus = cleanB.includes("-");

            if (aHasPlus && !bHasPlus) return -1;
            if (!aHasPlus && bHasPlus) return 1;

            if (aHasMinus && !bHasMinus) return -1;
            if (!aHasMinus && bHasMinus) return 1;

            const numA = parseInt(
              cleanA.match(/[+-]\s*(\d+)/)?.[1] || 0,
              10
            );
            const numB = parseInt(
              cleanB.match(/[+-]\s*(\d+)/)?.[1] || 0,
              10
            );

            return numA - numB;
          });

          let firstVar = true;

          for (const variante of variantes) {
            const totVar = sn(totalVariante?.[color]?.[variante], 0);
            if (totVar <= 0) continue;

            const row = new Array(1 + nTallas + 1).fill("");

            const tituloVar = isSinVar(variante) ? "" : s(variante);
            const colorTxt = firstVar ? s(color) : "";

            row[0] = tituloVar
              ? colorTxt
                ? `${colorTxt}\n${tituloVar}`
                : tituloVar
              : colorTxt
              ? colorTxt
              : "";

            chunkTallas.forEach((talla, idx) => {
              const val = sn(data?.[color]?.[variante]?.[talla], 0);
              row[1 + idx] = val > 0 ? String(val) : "";
            });

            row[row.length - 1] = String(totVar);

            const tieneAlgoEnChunk =
              row
                .slice(1, 1 + nTallas)
                .some((x) => String(x || "").trim() !== "") ||
              String(row[0] || "").trim() !== "";

            if (tieneAlgoEnChunk) bodyChunk.push(row);

            firstVar = false;
          }
        }

        ensureRoom(22);

        doc.autoTable({
          head: headChunk,
          body: bodyChunk,
          startY: currentY,
          margin: { left: marginLeft, right: marginLeft },
          tableWidth: usableWidth,
          // L49 (2026-06) — tabla profesional con zebra + brand color
          theme: "grid",
          styles: {
            fontSize: 9,
            cellPadding: 1,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
            lineColor: borderColor,
            lineWidth: 0.15,
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 9.5,
            halign: "center",
          },
          alternateRowStyles: {
            fillColor: stripeBg,
          },
          columnStyles: colStyles,
          didParseCell: (hookData) => {
            if (hookData.section === "body" && hookData.column.index === 0) {
              hookData.cell.styles.halign = "left";

              const raw = hookData.cell.raw;
              const txt = typeof raw === "string" ? raw : raw?.content || "";

              if (txt && String(txt).includes("\n")) {
                hookData.cell.styles.fontStyle = "bold";
              }
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 4;

        if (tallasChunks.length > 1) {
          doc.setFontSize(8);
          doc.setFont(undefined, "italic");
          doc.text(
            `Tallas ${ci + 1}/${tallasChunks.length}`,
            pageWidth - marginLeft,
            currentY,
            { align: "right" }
          );
          doc.setFont(undefined, "normal");
          currentY += 5;
        }
      }

      // L49 (2026-06) — Total piezas como chip
      ensureRoom(10);
      const chipTextPE = `TOTAL PIEZAS: ${totalPiezasGrupo}`;
      doc.setFontSize(9.5);
      doc.setFont(undefined, "bold");
      const chipPadPE = 3;
      const chipWPE = doc.getTextWidth(chipTextPE) + chipPadPE * 2;
      const chipHPE = 6;
      const chipXPE = pageWidth - marginLeft - chipWPE;
      doc.setFillColor(...lightBg);
      doc.setDrawColor(...brandColor);
      doc.setLineWidth(0.3);
      doc.roundedRect(chipXPE, currentY, chipWPE, chipHPE, 1.5, 1.5, "FD");
      doc.setLineWidth(0.2);
      doc.setTextColor(...brandColor);
      doc.text(chipTextPE, chipXPE + chipPadPE, currentY + chipHPE - 1.7);
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
      doc.setDrawColor(0);
      currentY += chipHPE + 4;

      ensureRoom(4);
      doc.setDrawColor(...borderColor);
      doc.line(marginLeft, currentY, pageWidth - marginLeft, currentY);
      doc.setDrawColor(0);
      currentY += 5;
    }

    // ================= RESUMEN — L49 mini-tabla bordada =================
    ensureRoom(45);

    doc.setFont(undefined, "bold");
    doc.setFontSize(11);
    doc.setTextColor(...brandColor);
    doc.text("RESUMEN", pageWidth - marginLeft, currentY, { align: "right" });
    doc.setTextColor(0);
    currentY += 3;

    const fmtMoneyPE = (n) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(sn(n, 0));

    const resumenRowsPE = [
      ["Piezas", `${sn(totalPiezas, 0)}`],
      // TF2 — Precio/Total solo con el permiso crt_pdfPrecios
      ...(mostrarPrecios
        ? [
            ["Precio", fmtMoneyPE(precio)],
            ["Total", fmtMoneyPE(totalGeneral)],
          ]
        : []),
    ];

    const resumenWPE = 90;
    const resumenLabelWPE = 40;
    const resumenXPE = pageWidth - marginLeft - resumenWPE;

    doc.autoTable({
      startY: currentY,
      margin: { left: resumenXPE, right: marginLeft },
      tableWidth: resumenWPE,
      body: resumenRowsPE,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 1.4,
        lineColor: borderColor,
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: resumenLabelWPE, fillColor: lightBg, textColor: labelColor, fontStyle: "bold" },
        1: { cellWidth: resumenWPE - resumenLabelWPE, halign: "right" },
      },
      didParseCell: (h) => {
        if (h.row.index === resumenRowsPE.length - 1) {
          h.cell.styles.fillColor = brandColor;
          h.cell.styles.textColor = [255, 255, 255];
          h.cell.styles.fontStyle = "bold";
          h.cell.styles.fontSize = 11;
        }
      },
    });

    // ================= TG3 — OBSERVACIONES de la entrada de proceso =================
    if (s(observacionesEntrada)) {
      const obsBoxW = pageWidth - marginLeft * 2;
      let obsY = doc.autoTable.previous.finalY + 8;
      const pageHPE = doc.internal.pageSize.getHeight();
      if (obsY > pageHPE - 35) {
        doc.addPage();
        obsY = 20;
      }
      doc.setFillColor(...brandColor);
      doc.rect(marginLeft, obsY, obsBoxW, 6, "F");
      doc.setTextColor(255, 255, 255);
      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text("OBSERVACIONES ENTRADA", marginLeft + 3, obsY + 4.2);
      doc.setTextColor(0);
      obsY += 6;
      doc.setFont(undefined, "normal");
      doc.setFontSize(9);
      const obsLinesPE = doc.splitTextToSize(s(observacionesEntrada), obsBoxW - 6);
      const blockHPE = obsLinesPE.length * 4.2;
      doc.setFillColor(245, 247, 250);
      doc.setDrawColor(...borderColor);
      doc.rect(marginLeft, obsY, obsBoxW, blockHPE + 5, "FD");
      doc.setDrawColor(0);
      doc.text(obsLinesPE, marginLeft + 3, obsY + 4);
    }

    // ================= FOOTER L49 — pie con paginación =================
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Proceso Entrada #${s(numero)}  ·  ${s(maquilero)}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDFOCPE:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

  function statusEdit(
    id,
    statusHabilitacion
  ) {
    setIdEdit(id);
    setStatusHabilitacionEdit(statusHabilitacion);
    toggleStatusEdit();
  }
  function saveStatusEdit(event) {
    event.preventDefault();
    axios
    .patch(
      `${URL_CORTES}/${idEdit}`,
      {
        statusHabilitacion: statusHabilitacionEdit
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then((response) => {
      axios
        .post(
          URL_LOGS,
          {
            tipo: "Editar Status",
            detalle: `Corte ${idEdit}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        )
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Listo",
            showConfirmButton: false,
            timer: 2000,
          });
          // (2026-10) sin reload: cierra el modal y refresca el listado
          setModalStatusEdit(false);
          cargarCortes();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
  }

const sortedInputFields = [...inputFields].sort((a, b) => {
  // 1. Ordenar por área primero (opcional, si lo quieres)
  if ((a.areaCliente || "") > (b.areaCliente || "")) return 1;
  if ((a.areaCliente || "") < (b.areaCliente || "")) return -1;

  // 2. Ordenar por color
  if ((a.colores || "") > (b.colores || "")) return 1;
  if ((a.colores || "") < (b.colores || "")) return -1;

  // 3. Extraer talla base y variante
  const tallaA = (a.tallas || "").trim();
  const tallaB = (b.tallas || "").trim();

  const partesA = tallaA.split(" ");
  const partesB = tallaB.split(" ");

  const tallaBaseA = partesA[0] || "";
  const tallaBaseB = partesB[0] || "";

  const varianteA = partesA.slice(1).join(" ").trim();
  const varianteB = partesB.slice(1).join(" ").trim();

  const sinVarianteA = varianteA === "";
  const sinVarianteB = varianteB === "";

  // 4. Primero las que no tienen variante
  if (sinVarianteA && !sinVarianteB) return -1;
  if (!sinVarianteA && sinVarianteB) return 1;

  // 5. Luego ordenar por talla base
  const indexA = ordenTallas.indexOf(tallaBaseA);
  const indexB = ordenTallas.indexOf(tallaBaseB);

  const ordenBaseA = indexA === -1 ? Infinity : indexA;
  const ordenBaseB = indexB === -1 ? Infinity : indexB;

  if (ordenBaseA !== ordenBaseB) {
    return ordenBaseA - ordenBaseB;
  }

  // 6. Si la talla base es igual, ordenar por variante
  return varianteA.localeCompare(varianteB, "es", { numeric: true });
});


  const sortedArticulosCortesEntrada = [...articulosCortesEntrada].sort((a, b) => {
    // Primero ordenar por color
    if (a.color > b.color) return 1;
    if (a.color < b.color) return -1;
  
    // Si los color son iguales, ordenar por el orden de tallas
    const indexA = ordenTallas.indexOf(a.talla);
    const indexB = ordenTallas.indexOf(b.talla);
  
    // Si ambas tallas están en el orden definido
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
  
    // Si alguna talla no está en el orden definido, ponerla al final
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
  
    return 0;
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.menu_produccion ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/CortesCreate"
                >
                  Nueva Corte
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Corte
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {user.crt_pdf && (
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                )}
                {user.crt_email && (
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                )}
                {user.crt_excel && (
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
          <h3 align="center">Cortes</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                // bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                // bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            {/* TG2 — filtro Liberado */}
            <Col md={2}>
              <Label className="mr-sm-2">Liberado</Label>
              <Input
                type="select"
                value={selectedLiberado}
                onChange={(e) => {
                  setSelectedLiberado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
          </Row>
          <br />
          <div className="table-wrapper">
            <Table size="sm" striped borderless className="table-responsive-xl">
              <TableHeader
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {commentsData.map((a) => {
                  {
                    return (
                      <tr>
                        <td>{a.ordenCorteConsecutivo}</td>
                        <td>{a.numero}</td>
                        <td>{a.numeroInternoOC}</td>
                        <td>{a.fecha}</td>
                        {/* (2026-08) el tooltip muestra las áreas del pedido, que
                            ahora también se pueden buscar en el search */}
                        <td title={areasPorPedido[a.idPedidoMongo] || ""}>
                          {a.cliente}
                        </td>
                        {/* <td>{a.pedidoCliente}</td> */}
                        <td>{a.articulo}</td>
                        {/* <td>{a.marca}</td> */}
                        <td>{a.monarch}</td>
                        {/* <td>{a.statusHabilitacion}
                           {a.status == "Abierto" ? (
                              <Button
                                size="sm"
                                className="btn"
                                color="info"
                                onClick={(e) =>
                                  statusEdit(a._id, a.statusHabilitacion)
                                }
                              >
                                <i class="fas fa-edit"></i>
                              </Button>
                              ) : undefined}
                        </td> */}
                        <td>
                          {a.status === "Abierto" && user.crt_habilitacion ? (
                            <Button
                              size="sm"
                              color="info"
                              // className="p-0"
                              onClick={() =>
                                statusEdit(a._id, a.statusHabilitacion)
                              }
                            >
                              {a.statusHabilitacion}
                            </Button>
                          ) : (
                            a.statusHabilitacion
                          )}
                        </td>
                        <td>{a.fechaCancelacionPedido}</td>
                        <td>{a.total_cantidad}</td>
                        <td>{a.cantidadPedido}</td>
                       
                        <td>
                          {user.crt_pdf && (
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            title="PDF"
                            onClick={async (e) => {
                              // L22 (2026-06) — preguntar si va resumido (junta áreas) o detallado
                              const r = await Swal.fire({
                                title: "¿PDF resumido?",
                                text: "Sí = junta cantidades por talla y color de todas las áreas. No = sale detallado por área.",
                                icon: "question",
                                showCancelButton: true,
                                confirmButtonText: "Sí, resumido",
                                cancelButtonText: "No, detallado",
                                reverseButtons: true,
                              });
                              // si cerraron por ESC / backdrop / close → no generar
                              if (
                                !r.isConfirmed &&
                                r.dismiss !== Swal.DismissReason.cancel
                              ) {
                                return;
                              }
                              const resumido = r.isConfirmed === true;
                              PDFOC(
                                a.numero,
                                a.fecha,
                                a.ordenCorteConsecutivo,
                                a.mesa,
                                a.total_cantidad,
                                a._id,
                                a.lienzos,
                                a.empalmes,
                                a.retaceria,
                                a.largoTrazo,
                                a.tiempoInicio,
                                a.tiempoFin,
                                a.observaciones,
                                a.total_cantidad,
                                a.articulo,
                                a.idOrdenCorte,
                                a.cliente,
                                a.idPedidoMongo,
                                a.idOrdenesCorteAuto,
                                a.numeroInternoOC,
                                resumido,
                                // L108 (2026-06) — empresa del pedido
                                a.empresa,
                                // LFISC (2026-07) — objeto empresa (datos fiscales)
                                a.empresaObj
                              );
                            }}
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button>
                          )}
                          {a.status === "Abierto" && user.crt_editar && (
                            <Button
                              size="sm"
                              color="info"
                              title="Editar Corte"
                              onClick={() => jalaEditCorte(a)}
                              style={{ marginLeft: 4 }}
                            >
                              <i className="fas fa-edit"></i>
                            </Button>
                          )}
                        </td>
                        <>
                          <td>
                            {a.status == "Abierto" && user.crt_salidaProc ? (
                              <Button
                                color="info"
                                id="Telas"
                                size="sm"
                                onClick={(e) =>
                                  procesosSalida(a._id, a.ordenCorteConsecutivo)
                                }
                              >
                                <i class="fas fa-sign-out-alt"></i>
                              </Button>
                            ) : undefined}
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFProcesosSalida(a._id, a.ordenCorteConsecutivo)
                              }
                            >
                              <i class="fas fa-search"></i>
                            </Button>
                          </td>
                          <td>
                            {a.status == "Abierto" && user.crt_entradaProc ? (
                              <Button
                                color="primary"
                                id="Telas"
                                size="sm"
                                onClick={(e) =>
                                  procesosEntrada(a._id, a.ordenCorteConsecutivo)
                                }
                              >
                                <i class="fas fa-sign-in-alt"></i>
                              </Button>
                            ) : undefined}
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFProcesosEntrada(a._id, a.ordenCorteConsecutivo)
                              }
                            >
                              <i class="fas fa-search"></i>
                            </Button>
                          </td>
                           {/* TG2 — Liberado: botón + quién liberó */}
                        <td style={{ minWidth: 150, whiteSpace: "nowrap" }}>
                          <Button
                            color={a.liberado === "Si" ? "success" : "secondary"}
                            size="sm"
                            title={
                              (a.liberados || []).some(
                                (r) => String(r.userId || "") === String(user.id)
                              )
                                ? "Quitar mi liberado"
                                : "Marcar como liberado"
                            }
                            onClick={() => toggleLiberado(a._id, a.liberados)}
                          >
                            {a.liberado === "Si" ? "Liberado" : "Liberar"}
                          </Button>
                          {Array.isArray(a.liberados) && a.liberados.length > 0 ? (
                            <div className="mt-1">
                              {a.liberados.map((r, i) => (
                                <div key={i}>
                                  <span style={{ color: "#000", fontSize: 12, whiteSpace: "nowrap" }}>
                                    {r.nombre || "Usuario"}
                                    {r.fecha ? ` (${r.fecha})` : ""}
                                  </span>
                                  {/* (2026-07) observaciones del liberado */}
                                  {r.observaciones ? (
                                    <div
                                      style={{
                                        color: "#555",
                                        fontSize: 11,
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      Obs: {r.observaciones}
                                    </div>
                                  ) : null}
                                </div>
                              ))}
                            </div>
                          ) : null}
                        </td>
                          {a.status == "Abierto" && user.crt_entradaAlm ? (
                            <td>
                              <Button
                                size="sm"
                                className="btn btn-success"
                                title="Entrada a Almacén"
                                onClick={(e) =>
                                  entradaAlmacen(a._id, a.ordenCorteConsecutivo)
                                }
                              >
                                <i class="fas fa-tshirt"></i>
                              </Button>
                            </td>
                          ) : (
                            <td></td>
                          )}
                        </>
                        {/* // ) : (
                          <>
                            <td></td>
                            <td></td>
                            <td></td>
                          </>
                        )} */}
                        <td>
                          <Status
                            idStatus={a._id}
                            status={a.status}
                            URL_STATUS={process.env.REACT_APP_URL_CORTES}
                            onDone={() => cargarCortes()}
                          />
                        </td>
                        <td>
                          {/* (2026-07) marcar el corte como activo/baja (is_active Sí/No) */}
                          <Baja
                            idStatus={a._id}
                            is_active={a.is_active}
                            URL_BAJA={process.env.REACT_APP_URL_CORTES}
                            onDone={() => cargarCortes()}
                          />
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Listado Cortes</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>

      {/* L7 (2026-06) — Modal Editar Cantidades del Corte */}
      <Modal size="lg" isOpen={modalEditCorte} toggle={toggleEditCorte}>
        <ModalHeader toggle={toggleEditCorte}>
          <h4>Editar Cantidades — Corte #{editNumeroCorte}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={guardarEditCorte}>
            <Table size="sm" striped>
              <thead>
                <tr>
                  <th>Artículo</th>
                  <th>Talla</th>
                  <th>Color</th>
                  <th>Área</th>
                  <th style={{ width: 120 }}>Cantidad</th>
                </tr>
              </thead>
              <tbody>
                {editLineItems.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      Sin líneas para mostrar.
                    </td>
                  </tr>
                ) : (
                  editLineItems.map((r, idx) => (
                    <tr key={r._id}>
                      <td>{r.articulo}</td>
                      <td>{r.talla}</td>
                      <td>{r.color}</td>
                      <td>{r.area}</td>
                      <td>
                        <Input
                          type="number"
                          min="0"
                          step="any"
                          value={r.cantidad}
                          onChange={(e) =>
                            setEditLineCantidad(idx, e.target.value)
                          }
                          style={{
                            background:
                              Number(r.cantidad || 0) !==
                              Number(r.cantidadOriginal || 0)
                                ? "#fff3cd"
                                : "white",
                          }}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              {editLineItems.length > 0 && (
                <tfoot>
                  <tr>
                    <th colSpan="4" className="text-end">
                      Total nuevo:
                    </th>
                    <th>
                      {editLineItems.reduce(
                        (s, r) => s + Number(r.cantidad || 0),
                        0
                      )}
                    </th>
                  </tr>
                </tfoot>
              )}
            </Table>

            {/* L111 — Agregar al corte una combinación que YA existe en la orden
                (ArticulosOrdenesCorte) y que aún no está en el corte */}
            <hr />
            <Label className="mr-sm-2">
              <b>Agregar talla / color (de la orden)</b>
            </Label>
            <Row className="align-items-end">
              <Col md={6}>
                <Label className="mr-sm-2">Combinación disponible</Label>
                <Input
                  type="select"
                  value={aocSeleccionadoCorte}
                  onChange={(e) => setAocSeleccionadoCorte(e.target.value)}
                >
                  <option value="">
                    {aocDisponiblesCorte.length === 0
                      ? "No hay combinaciones nuevas en la orden"
                      : "Selecciona"}
                  </option>
                  {aocDisponiblesCorte.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.articulo} · {a.color} · {a.talla}
                      {a.area ? ` · ${a.area}` : ""}
                    </option>
                  ))}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Cantidad</Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  value={agregarCorteCantidad}
                  onChange={(e) => setAgregarCorteCantidad(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Button
                  type="button"
                  color="primary"
                  onClick={agregarTallaColorCorte}
                  disabled={!aocSeleccionadoCorte}
                >
                  Agregar
                </Button>
              </Col>
            </Row>
            <hr />

            {/* (2026-09) Observaciones del corte (las de CortesCreate) */}
            <Label className="mr-sm-2">
              <b>Observaciones del corte</b>
            </Label>
            <Input
              type="textarea"
              rows="2"
              placeholder="Este corte no tiene observaciones capturadas"
              value={editObsCorte}
              onChange={(e) => setEditObsCorte(e.target.value)}
              style={{
                background:
                  editObsCorte.trim() !== editObsCorteOriginal.trim()
                    ? "#fff3cd"
                    : "white",
              }}
            />
            <hr />

            <div className="text-end" style={{ marginTop: 10 }}>
              <Button type="submit" color="success">
                Guardar cambios
              </Button>{" "}
              <Button color="secondary" onClick={toggleEditCorte}>
                Cancelar
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalProcesosSalida}
        toggle={toggleProcesosSalida}
      >
        <ModalHeader toggle={toggleProcesosSalida}>
          <h4>Procesos Corte {selectedCorteNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Articulo</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={8}>
              <Label className="mr-sm-2">Procesos</Label>
            </Col>
          </Row>
          {articulosUnicos.map((a) => (
            <div key={a.id}>
              <Row>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    name="articulos"
                    type="text"
                    value={a.articuloNombre}
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="articulos"
                    type="text"
                    value={a.total_cantidad}
                    disabled
                  />
                </Col>
                <Col md={8}>
                  {catalogoProcesos.map((p) => (
                    <Button
                      size="sm"
                      className="btn btn-success"
                      onClick={(e) =>
                        funcionProcesosSalida(
                          p._id,
                          p.name,
                          a.idArticulo,
                          a.articuloNombre,
                          a.idPedido,
                          a.numeroPedido,
                          a.fechaCancelacion
                        )
                      }
                    >
                      {p.name}
                    </Button>
                  ))}
                </Col>
              </Row>
            </div>
          ))}
        </ModalBody>
      </Modal>

      <Modal
        size="xl"
        isOpen={modalFuncionProcesosSalida}
        toggle={toggleFuncionProcesosSalida}
      >
        <ModalHeader toggle={toggleFuncionProcesosSalida}>
          <h3>Salida A Taller</h3>
          <h4>
            Proceso Salida: {nombreProcesosSalida} <br />
            Articulo: {nombreArticulo} <br />
            Pedido: {numeroPedido} <br />
            Fecha Cancelacion: {fechaCancelacion}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveSalidaProceso}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaProceso}
                  required
                  onChange={(e) => {
                    setFechaProceso(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="FechaCompromiso"
                  value={fechaCompromisoProceso}
                  required
                  onChange={(e) => {
                    setFechaCompromisoProceso(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Taller</Label>
                <Input
                  type="select"
                  placeholder="Maquilero"
                  value={maquileroProceso}
                  required
                  onChange={(e) => {
                    setMaquileroProceso(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      if (a.tipo == "Maquilero") {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      }
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Precio</Label>
                <Input
                  // bsSize="sm"
                  name="precio"
                  type="number"
                  placeholder="Precio"
                  value={precioProceso}
                  required
                  onChange={(event) => handleChangeInputPrecio(event)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={12}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              {/* <Col md={2}>
                <Label className="mr-sm-2">Sucursal</Label>
              </Col> */}
              <Col md={4}>
                <Label className="mr-sm-2">Area</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

            {sortedInputFields
              //  .sort((a, b) => (a.colores > b.colores ? 1 : -1))
              .map((inputField) => (
                <div key={inputField.id}>
                  <Row>
                    <Col md={4}>
                      <Input
                        bsSize="sm"
                        name="color"
                        type="text"
                        value={inputField.areaCliente}
                        disabled
                      />
                    </Col>
                    {/* <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="color"
                        type="text"
                        value={inputField.sucursal}
                        disabled
                      />
                    </Col> */}
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="color"
                        type="text"
                        value={inputField.colores}
                        disabled
                      />
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="talla"
                        type="text"
                        value={inputField.tallas}
                        disabled
                      />
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="cantidad"
                        type="number"
                        value={inputField.cantidad}
                        onChange={(event) =>
                          handleChangeInputCantidad(inputField.id, event)
                        }
                      />
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="total"
                        type="number"
                        value={inputField.total}
                        disabled
                      />
                    </Col>
                  </Row>
                </div>
              ))}

            {/* L23 (2026-06) — Resumen agrupado por color + talla (suma de todas las áreas) */}
            <br />
            <h5 style={{ fontWeight: "bold" }}>Resumen por Color y Talla</h5>
            <Row>
              <Col md={4}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>
            {(() => {
              const resumenMap = {};
              sortedInputFields.forEach((f) => {
                const color = (f.colores || "").trim() || "Sin color";
                const talla = (f.tallas || "").trim() || "Sin talla";
                const k = `${color}||${talla}`;
                if (!resumenMap[k]) {
                  resumenMap[k] = { color, talla, cantidad: 0 };
                }
                resumenMap[k].cantidad += parseFloat(f.cantidad || 0);
              });
              const resumen = Object.values(resumenMap).sort((a, b) => {
                if (a.color !== b.color) return a.color > b.color ? 1 : -1;
                const ia = ordenTallas.indexOf((a.talla || "").split(" ")[0]);
                const ib = ordenTallas.indexOf((b.talla || "").split(" ")[0]);
                const oa = ia === -1 ? Infinity : ia;
                const ob = ib === -1 ? Infinity : ib;
                if (oa !== ob) return oa - ob;
                return (a.talla || "").localeCompare(b.talla || "", "es", { numeric: true });
              });
              return resumen.map((r) => (
                <Row key={`${r.color}-${r.talla}`}>
                  <Col md={4}>
                    <Input bsSize="sm" type="text" value={r.color} disabled />
                  </Col>
                  <Col md={4}>
                    <Input bsSize="sm" type="text" value={r.talla} disabled />
                  </Col>
                  <Col md={2}>
                    <Input bsSize="sm" type="number" value={r.cantidad} disabled />
                  </Col>
                </Row>
              ));
            })()}

            <br />
            <Row>
              <Col md={6}></Col>
              <Col md={2}>
                <h4>TOTALES</h4>
              </Col>
              <Col md={2}>
                <h4>{totalPiezas}</h4>
              </Col>
              <Col md={2}>
                <h4>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalGeneral)}</h4>
              </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      {/* Procesos Entrada */}
      <Modal
        size="xxl"
        isOpen={modalProcesosEntrada}
        toggle={toggleProcesosEntrada}
      >
        <ModalHeader toggle={toggleProcesosEntrada}>
          <h4>Procesos Corte {selectedCorteNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className="negrita">Articulo</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Proceso</Label>
            </Col>
            {/* (2026-08) Precio solo con permiso crt_pdfPrecios; sin él,
                Taller toma la columna sobrante para mantener el grid en 12 */}
            <Col md={user.crt_pdfPrecios ? 2 : 3}>
              <Label className="negrita">Taller</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Fecha Salida</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Compromiso</Label>
            </Col>
            {user.crt_pdfPrecios ? (
              <Col md={1}>
                <Label className="negrita">Precio</Label>
              </Col>
            ) : null}
            <Col md={1}>
              <Label className="negrita">Salida</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Entrada</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Recibir</Label>
            </Col>
            <Col md={1}>
              <Label className="negrita">Cerrar</Label>
            </Col>
          </Row>
          {articulosUnicosEntrada.map((a) => (
            <div key={a.id}>
              <Row>
                <Col md={2}>
                  {" "}
                  <Label> {a.articuloNombre}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.catalogoProcesos}</Label>
                </Col>
                <Col md={user.crt_pdfPrecios ? 2 : 3}>
                  {" "}
                  <Label>{a.maquilero}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.fecha}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.fechaCompromiso}</Label>
                </Col>
                {/* (2026-08) Precio solo con permiso crt_pdfPrecios */}
                {user.crt_pdfPrecios ? (
                  <Col md={1}>
                    {" "}
                    <Label>$ {a.precio}</Label>
                  </Col>
                ) : null}
                <Col md={1}>
                  {" "}
                  <Label>{a.cantidadSalida}</Label>
                </Col>
                <Col md={1}>
                  {" "}
                  <Label>{a.cantidadEntrada}</Label>
                </Col>
                <Col md={1}>
                  {a.status == "Cerrado" || a.faltantes <= 0 ? undefined : (
                    <Button
                      color="primary"
                      size="sm"
                      className="btn btn-success"
                      onClick={(e) =>
                        funcionProcesosEntrada(
                          a.idCatalogoProcesos,
                          a.catalogoProcesos,
                          a.idArticulo,
                          a.articuloNombre,
                          a.idPedido,
                          a.numeroPedido,
                          a.procesosSalida
                        )
                      }
                    >
                      <i class="fas fa-sign-in-alt"></i>
                    </Button>
                  )}
                </Col>
                <Col md={1}>
                  {a.status == "Cerrado" ? undefined : (
                    <Button
                      color="primary"
                      size="sm"
                      className="btn btn-success"
                      onClick={(e) =>
                        cerrarProcesosEntrada(
                          a.procesosSalida,
                          a.faltantes,
                          a.faltantesHab,
                          a.idMaquilero
                        )
                      }
                    >
                      <i class="fas fa-lock"></i>
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          ))}
        </ModalBody>
      </Modal>

      <Modal
        size="xxl"
        isOpen={modalFuncionProcesosEntrada}
        toggle={toggleFuncionProcesosEntrada}
      >
        <ModalHeader toggle={toggleFuncionProcesosEntrada}>
          <h4>
            Entrada de Taller
            <br />
            Proceso: {nombreProcesosEntrada} <br />
            Articulo: {nombreArticulo} <br />
            Pedido: {numeroPedido}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveEntradaProceso}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaProceso}
                  required
                  onChange={(e) => {
                    setFechaProceso(e.target.value);
                  }}
                />
              </Col>

              <Col md={2}>
                <Label>Taller</Label>
                <Input
                  type="select"
                  placeholder="Maquilero"
                  value={maquileroProceso}
                  required
                  disabled
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      if (a.tipo == "Maquilero") {
                        return (
                          <option value={a._id}>{a.nombre_comercial}</option>
                        );
                      }
                    })}
                </Input>
              </Col>
              {/* <Col md={2}>
                <Label>Precio</Label>
                <Input
                  // bsSize="sm"
                  name="precio"
                  type="number"
                  placeholder="Precio"
                  value={precioProceso}
                  required
                  onChange={(event) => handleChangeInputPrecio(event)}
                />
              </Col>
              <Col md={2}>
                <Label>Impuestos</Label>
                <Input
                  type="select"
                  value={impuestos}
                  required
                  onChange={(e) => {
                    setImpuestos(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value={0}>No</option>
                  <option value={16}>Si</option>
                </Input>
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Factura
                </Label>
                <Input
                  type="text"
                  placeholder="Factura"
                  value={factura}
                  required
                  onChange={(e) => {
                    setFactura(e.target.value);
                  }}
                />
              </Col> */}
               {/* <Col md={2}>
                <Label>Cantidad Composturas</Label>
                <Input
                  type="number"
                  value={composturas}
                  required
                  onChange={(e) => {
                    setComposturas(e.target.value);
                  }}
                />
              </Col> */}
            </Row>
            <br />
            <Row>
              <Col md={12}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              {/* <Col md={2}>
                <Label className="mr-sm-2">Sucursal</Label>
              </Col> */}
              <Col md={2}>
                <Label className="mr-sm-2">Area</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              {/* <Col md={1}>
                <Label className="mr-sm-2">Segundas</Label>
              </Col> */}
              {/* <Col md={2}>
                <Label className="mr-sm-2">Faltante Hab</Label>
              </Col> */}
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>
            {sortedInputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  {/* <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="color"
                      type="text"
                      value={inputField.sucursal}
                      disabled
                    />
                  </Col> */}
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="color"
                      type="text"
                      value={inputField.areaCliente}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="color"
                      type="text"
                      value={inputField.colores}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="talla"
                      type="text"
                      value={inputField.tallas}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    />
                  </Col>
                  {/* <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="segundas"
                      type="number"
                      value={inputField.segundas}
                      onChange={(event) =>
                        handleChangeInputCantidadSegundas(inputField.id, event)
                      }
                    />
                  </Col> */}
                  {/* <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="faltantes"
                      type="number"
                      value={inputField.faltantes}
                      onChange={(event) =>
                        handleChangeInputCantidadFDS(inputField.id, event)
                      }
                    />
                  </Col> */}
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="total"
                      type="number"
                      value={inputField.total}
                      disabled
                    />
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            <Row>
              <Col md={4}></Col>
              <Col md={2}>
                <h4>TOTALES</h4>
              </Col>
              <Col md={1}>
                <h4>{totalPiezas}</h4>
              </Col>
              {/* <Col md={1}>
                <h4>{totalPiezasSegundas}</h4>
              </Col> */}
              {/* <Col md={2}>
                <h4>{totalPiezasFaltantes}</h4>
              </Col> */}
              <Col md={1}>
                <h4>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalGeneral)}
                </h4>
              </Col>
            </Row>
            {/* <Row>
              <Col md={4}></Col>
              <Col md={2}>
                <h4>TOTAL CANTIDAD</h4>
              </Col>
              <Col md={1}>
                <h4>
                  {totalPiezas + totalPiezasFaltantes + totalPiezasSegundas}
                </h4>
              </Col>
            </Row> */}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalFaltante} toggle={toggleFaltante}>
        <ModalHeader toggle={toggleFaltante}></ModalHeader>
        <ModalBody>
          <Form onSubmit={saveFaltantes}>
            <Row>
              <h4>Faltantes Talleres</h4>
            </Row>
            <Row>
              <Col md={4}>
                <Label>Fecha</Label>
                <Input
                  bsSize="sm"
                  name="fecha"
                  type="date"
                  required
                  value={fechaFaltante}
                  onChange={(event) => {
                    setFechaFaltante(event.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={4}>
                <Label>Faltantes</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={cantidadFaltante}
                  onChange={(event) => {
                    setCantidadFaltante(event.target.value);
                    setTotalFaltante(event.target.value * precioFaltante);
                    setTotalTotalFaltante(
                      event.target.value * precioFaltante + totalFaltanteHab
                    );
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Precio</Label>
                <Input
                  bsSize="sm"
                  name="precio"
                  type="number"
                  value={precioFaltante}
                  onChange={(event) => {
                    setPrecioFaltante(event.target.value);
                    setTotalFaltante(event.target.value * cantidadFaltante);
                    setTotalTotalFaltante(
                      event.target.value * cantidadFaltante + totalFaltanteHab
                    );
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Total</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={totalFaltante}
                  disabled
                />
              </Col>
            </Row>
            <br />
            {/* <Row>
              <Col md={4}>
                <Label>Faltantes Habilitacion</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={cantidadFaltanteHab}
                  onChange={(event) => {
                    setCantidadFaltanteHab(event.target.value);
                    setTotalFaltanteHab(event.target.value * precioFaltanteHab);
                    setTotalTotalFaltante(
                      event.target.value * precioFaltanteHab + totalFaltante
                    );
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Precio</Label>
                <Input
                  bsSize="sm"
                  name="precio"
                  type="number"
                  value={precioFaltanteHab}
                  onChange={(event) => {
                    setPrecioFaltanteHab(event.target.value);
                    setTotalFaltanteHab(
                      event.target.value * cantidadFaltanteHab
                    );
                    setTotalTotalFaltante(
                      event.target.value * cantidadFaltanteHab + totalFaltante
                    );
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Total</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={totalFaltanteHab}
                  disabled
                />
              </Col>
            </Row> */}
            <br />
            <Row>
              <Col md={8}></Col>
              <Col md={4}>
                <Label>Total por Aplicar</Label>
                <Input
                  bsSize="sm"
                  name="cantidad"
                  type="number"
                  value={totalTotalFaltante}
                  disabled
                />
              </Col>
            </Row>

            <Button type="submit" className="btn btn-success">
              Guardar
            </Button>
          </Form>
        </ModalBody>
      </Modal>

      {/* Entrada Almacen */}

      <Modal
        size="xxl"
        isOpen={modalEntradaAlmacen}
        toggle={toggleEntradaAlmacen}
      >
        <ModalHeader toggle={toggleEntradaAlmacen}>
          <h3>Entrada Almacen</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveEntradaAlma}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaEntradaAlma}
                  required
                  onChange={(e) => {
                    setFechaEntradaAlma(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Almacen</Label>
                <Input
                  type="select"
                  value={areasEntrada}
                  required
                  onChange={(e) => {
                    setAreasEntrada(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  {areas.map((a) => {
                    if (a.name != "General") {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
                </Input>
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={12}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              {/* <Col md={2}>
                <Label className="mr-sm-2">Sucursal</Label>
              </Col> */}
              <Col md={2}>
                <Label className="mr-sm-2">Area</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              {/* <Col md={1}>
                <Label className="mr-sm-2">Segundas</Label>
              </Col> */}
            </Row>
            {sortedArticulosCortesEntrada.map((a) => (
              <div key={a.id}>
                <Row>
                  {/* <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="sucursal"
                      type="text"
                      value={a.sucursal}
                      disabled
                    />
                  </Col> */}
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="area"
                      type="text"
                      value={a.area}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articuloNombre"
                      type="text"
                      value={a.articuloNombre}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="color"
                      type="text"
                      value={a.color}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="talla"
                      type="text"
                      value={a.talla}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      value={a.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidadEntradaAlma(a.id, event)
                      }
                    />
                  </Col>
                  {/* <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="segundas"
                      type="number"
                      value={a.segundas}
                      onChange={(event) =>
                        handleChangeInputEntradaSegundasAlma(a.id, event)
                      }
                    />
                  </Col> */}
                </Row>
              </div>
            ))}
            <br />
            <Row>
              <Col md={7}></Col>
              <Col md={1}>
                <h4>TOTAL</h4>
              </Col>
              <Col md={1}>
                <h4>{totalPiezasEntradaAlma}</h4>
              </Col>
              {/* <Col md={1}>
                <h4>{totalPiezasEntradaSegundasAlma}</h4>
              </Col> */}
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      {/* (2026-07) Editar Salida de Proceso (encabezado + cantidades) */}
      <Modal size="lg" isOpen={modalEditSalida} toggle={toggleEditSalida}>
        <ModalHeader toggle={toggleEditSalida}>
          <h4>Editar Salida de Proceso</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveEditSalida}>
            <Row>
              <Col md={5}>
                <Label className="mr-sm-2">Maquilero / Proveedor</Label>
                <Input
                  type="select"
                  value={editSalidaProveedor}
                  onChange={(e) => setEditSalidaProveedor(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .slice()
                    .sort((a, b) =>
                      (a.nombre_comercial || "") > (b.nombre_comercial || "")
                        ? 1
                        : -1
                    )
                    .map((p) => (
                      <option key={p._id} value={p._id}>
                        {p.nombre_comercial}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Fecha Compromiso</Label>
                <Input
                  type="date"
                  value={editSalidaFechaComp}
                  onChange={(e) => setEditSalidaFechaComp(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Precio</Label>
                <Input
                  type="number"
                  step="any"
                  value={editSalidaPrecio}
                  onChange={(e) => setEditSalidaPrecio(e.target.value)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={6}>
                <Label>Artículo</Label>
              </Col>
              <Col md={3}>
                <Label>Recibido</Label>
              </Col>
              <Col md={3}>
                <Label>Cantidad salida</Label>
              </Col>
            </Row>
            {editSalidaItems.map((it) => (
              <Row key={it.id} style={{ marginBottom: 4 }}>
                <Col md={6}>
                  <div style={{ display: "flex", gap: 4 }}>
                    <Input
                      bsSize="sm"
                      type="text"
                      value={`${it.nombre}${
                        salidaVariasAreas && it.area ? ` · ${it.area}` : ""
                      }${it.nuevo ? "  (nueva)" : ""}`}
                      disabled
                      style={it.nuevo ? { background: "#e8f7ee" } : undefined}
                    />
                    {it.nuevo ? (
                      <Button
                        size="sm"
                        color="danger"
                        title="Quitar esta talla"
                        onClick={() => quitarTallaSalida(it.id)}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    ) : null}
                  </div>
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={it.cantidadEntrada}
                    disabled
                  />
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={it.cantidadSalida}
                    onChange={(e) =>
                      handleChangeEditSalidaCantidad(it.id, e.target.value)
                    }
                  />
                </Col>
              </Row>
            ))}
            {/* (2026-10) agregar tallas que están en el corte y no en la salida */}
            {tallasPorAgregarSalida.length ? (
              <Row style={{ marginTop: 10 }}>
                <Col md={9}>
                  <Label>Agregar talla del corte</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={editSalidaAgregar}
                    onChange={(e) => setEditSalidaAgregar(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {tallasPorAgregarSalida.map((d) => (
                      <option key={d.clave} value={d.clave}>
                        {`${d.nombre}${
                          salidaVariasAreas && d.area ? ` · ${d.area}` : ""
                        }  (cortado: ${d.cortado}${
                          d.enviadoOtras
                            ? ` · ya mandado en otra salida de este proceso: ${d.enviadoOtras}`
                            : ""
                        })`}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col
                  md={3}
                  style={{ display: "flex", alignItems: "flex-end" }}
                >
                  <Button
                    size="sm"
                    color="info"
                    disabled={!editSalidaAgregar}
                    onClick={agregarTallaSalida}
                  >
                    <i className="fas fa-plus"></i> Agregar
                  </Button>
                </Col>
              </Row>
            ) : (
              <small className="text-muted">
                Todas las tallas del corte ya están en esta salida.
              </small>
            )}
            <br />
            <Button type="submit" className="btn btn-success">
              Guardar
            </Button>
          </Form>
        </ModalBody>
      </Modal>

      {/* (2026-07) Editar Entrada de Proceso (financiero) */}
      <Modal size="lg" isOpen={modalEditEntrada} toggle={toggleEditEntrada}>
        <ModalHeader toggle={toggleEditEntrada}>
          <h4>Editar Entrada de Proceso</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveEditEntrada}>
            <Row>
              <Col md={5}>
                <Label className="mr-sm-2">Maquilero / Proveedor</Label>
                <Input
                  type="select"
                  value={editEntradaProveedor}
                  onChange={(e) => setEditEntradaProveedor(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .slice()
                    .sort((a, b) =>
                      (a.nombre_comercial || "") > (b.nombre_comercial || "")
                        ? 1
                        : -1
                    )
                    .map((p) => (
                      <option key={p._id} value={p._id}>
                        {p.nombre_comercial}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Fecha</Label>
                <Input
                  type="date"
                  value={editEntradaFecha}
                  onChange={(e) => setEditEntradaFecha(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Precio</Label>
                <Input
                  type="number"
                  step="any"
                  value={editEntradaPrecio}
                  onChange={(e) => setEditEntradaPrecio(e.target.value)}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={5}>
                <Label>Artículo</Label>
              </Col>
              <Col md={2}>
                <Label>Buenas</Label>
              </Col>
              <Col md={2}>
                <Label>Faltantes</Label>
              </Col>
              <Col md={3}>
                <Label>Segundas</Label>
              </Col>
            </Row>
            {editEntradaItems.map((it) => (
              <Row key={it.id} style={{ marginBottom: 4 }}>
                <Col md={5}>
                  <Input bsSize="sm" type="text" value={it.nombre} disabled />
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={it.cantidadEntrada}
                    onChange={(e) =>
                      handleChangeEditEntrada(
                        it.id,
                        "cantidadEntrada",
                        e.target.value
                      )
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={it.cantidadFaltantes}
                    onChange={(e) =>
                      handleChangeEditEntrada(
                        it.id,
                        "cantidadFaltantes",
                        e.target.value
                      )
                    }
                  />
                </Col>
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={it.cantidadSegundas}
                    onChange={(e) =>
                      handleChangeEditEntrada(
                        it.id,
                        "cantidadSegundas",
                        e.target.value
                      )
                    }
                  />
                </Col>
              </Row>
            ))}
            <br />
            {user.crt_pdfPrecios ? (
              <p style={{ fontSize: 13, color: "#555" }}>
                Se recalculará la NotaCxP y se ajustarán los cargos/saldo del
                proveedor por la diferencia.
              </p>
            ) : null}
            <Button type="submit" className="btn btn-success">
              Guardar
            </Button>
          </Form>
        </ModalBody>
      </Modal>

      {/* PDFPS */}
      <Modal size="xxl" isOpen={modalPDFPS} toggle={togglePDFPS}>
        <ModalHeader toggle={togglePDFPS}>
          <h3>Detalle Salida Procesos</h3>
        </ModalHeader>
        <ModalBody>
          <Table>
            <tr>
              <th>#</th>
              <th>Proceso</th>
              <th>Proveedor</th>
              <th>Articulo</th>
              <th>Pedido</th>
              <th>Fecha Comp.</th>
              <th>Piezas</th>
              {/* T4 (2026-06) — Precio/Total solo con permiso crt_pdfPrecios */}
              {user.crt_pdfPrecios ? <th>Precio</th> : null}
              {user.crt_pdfPrecios ? <th>Total</th> : null}
              <th>Habilitacion</th>
              <th>PDF</th>
              <th>Cancelar</th>
            </tr>
            {PDFPS.map((a) => {
              return (
                <tr>
                  <td>{a.numero}</td>
                  <td>{a.catalogosProcesosName}</td>
                  <td>{a.proveedoresName}</td>
                  <td>{a.articulo}</td>
                  <td>{a.pedido}</td>
                  <td>{a.fechaCompromiso}</td>
                  <td>{a.totalPiezas}</td>
                  {/* T4 (2026-06) — Precio/Total solo con permiso crt_pdfPrecios */}
                  {user.crt_pdfPrecios ? <td>{a.precio}</td> : null}
                  {user.crt_pdfPrecios ? (
                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.totalGeneral)}
                    </td>
                  ) : null}
                  <td>
                    {a.status == "Abierto" ? (
                      <>
                        <Button
                          size="sm"
                          className="btn"
                          color="success"
                          onClick={(e) =>
                            jalaHabilitacion(
                              a.id,
                              a.idArticulo,
                              a.numero,
                              a.catalogosProcesosName,
                              a.proveedoresName,
                              a.idProveedor,
                              a.pedido,
                              a.idPedido,
                              a.fechaCompromiso,
                              a.totalPiezas,
                              a.precio,
                              a.totalGeneral,
                              a.fecha,
                              a.idCorte,
                              a.numeroCorte
                            )
                          }
                        >
                          <i class="fas fa-tag"></i>
                        </Button>
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => {
                            jalaHabilitacionEdit(a.id);
                          }}
                        >
                          <i class="far fa-edit"></i>
                        </Button>
                        {/* (2026-08) PDF SOLO de la habilitación, para entregarlo
                            aparte en el almacén */}
                        <Button
                          color="danger"
                          size="sm"
                          title="PDF de la habilitación"
                          onClick={(e) =>
                            PDFOCPS(
                              a.id,
                              a.numero,
                              a.catalogosProcesosName,
                              a.proveedoresName,
                              a.pedido,
                              a.fechaCompromiso,
                              a.totalPiezas,
                              a.precio,
                              a.totalGeneral,
                              a.fecha,
                              a.idArticulo,
                              a.ordenCorte,
                              a.cliente,
                              a.corteObservaciones,
                              !!user.crt_pdfPrecios,
                              a.numeroInternoOC,
                              a.empresa,
                              a.empresaObj,
                              // solo la hoja de habilitación
                              true
                            )
                          }
                        >
                          <i class="far fa-file-pdf"></i>
                        </Button>
                      </>
                    ) : null}
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={(e) =>
                        PDFOCPS(
                          a.id,
                          a.numero,
                          a.catalogosProcesosName,
                          a.proveedoresName,
                          a.pedido,
                          a.fechaCompromiso,
                          a.totalPiezas,
                          a.precio,
                          a.totalGeneral,
                          a.fecha,
                          a.idArticulo,
                          // L117 (2026-06) — el row del modal PDFPS guarda el consecutivo
                          // en `ordenCorte` (= idOrdenesCorte), no en `ordenCorteConsecutivo`
                          a.ordenCorte,
                          a.cliente,
                          a.corteObservaciones,
                          // L24 (2026-06)
                          !!user.crt_pdfPrecios,
                          // L72 (2026-06)
                          a.numeroInternoOC,
                          // L107 (2026-06) — empresa del pedido
                          a.empresa,
                          // LFISC (2026-07) — objeto empresa (datos fiscales)
                          a.empresaObj
                        )
                      }
                    >
                      <i class="far fa-file-pdf"></i>
                    </Button>
                  </td>
                  <td>
                    {/* (2026-07) editar salida (encabezado + cantidades) */}
                    {a.status === "Abierto" ? (
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        title="Editar salida"
                        style={{ marginRight: 4 }}
                        onClick={() => jalaEditSalida(a)}
                      >
                        <i className="fas fa-pen"></i>
                      </Button>
                    ) : null}
                    {a.status === "Abierto" && user.crt_cancelarSal ? (
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        title="Cancelar salida"
                        onClick={() => cancelarSalidaProceso(a.id, a.numero)}
                      >
                        <i className="fas fa-ban"></i>
                      </Button>
                    ) : (
                      <span className="text-muted">
                        {a.status || ""}
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </Table>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalPDFPE} toggle={togglePDFPE}>
        <ModalHeader toggle={togglePDFPE}>
          <h3>Detalle Entrada Procesos</h3>
        </ModalHeader>
        <ModalBody>
          <Table>
            <tr>
              <th>#</th>
              <th>Proceso</th>
              <th>Proveedor</th>
              <th>Articulo</th>
              <th>Línea</th>
              <th># Corte</th>
              <th>Orden Prod.</th>
              <th># Artículo</th>
              <th>Pedido</th>
              <th>Fecha</th>
              <th>Piezas</th>
              {/* T4 (2026-06) — Precio/Total solo con permiso crt_pdfPrecios */}
              {user.crt_pdfPrecios ? <th>Precio</th> : null}
              {user.crt_pdfPrecios ? <th>Total</th> : null}
              <th>PDF</th>
            </tr>
            {PDFPE.map((a) => {
              return (
                <tr>
                  <td>{a.numero}</td>
                  <td>{a.catalogosProcesosName}</td>
                  <td>{a.proveedoresName}</td>
                  <td>{a.articulo}</td>
                  <td>{a.linea}</td>
                  <td>{a.numeroCorte}</td>
                  <td>{a.numeroOrdenProduccion}</td>
                  <td>{a.numeroArticulo}</td>
                  <td>{a.pedido}</td>
                  <td>{a.fecha}</td>
                  <td>{a.totalPiezas}</td>
                  {/* T4 (2026-06) — Precio/Total solo con permiso crt_pdfPrecios */}
                  {user.crt_pdfPrecios ? (
                    <td>
                      {" "}
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.precio)}
                    </td>
                  ) : null}
                  {user.crt_pdfPrecios ? (
                    <td>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(a.totalGeneral)}
                    </td>
                  ) : null}
                  <td>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={(e) =>
                        PDFOCPE(
                          a.id,
                          a.numero,
                          a.catalogosProcesosName,
                          a.proveedoresName,
                          a.totalPiezas,
                          a.totalPiezasFaltantes,
                          a.totalPiezasSegundas,
                          a.precio,
                          a.fecha,
                          a.totalGeneral,
                          a.empresa || "",
                          // TF2 — permiso "Ver Precios en PDF Salida"
                          !!user.crt_pdfPrecios,
                          // LFISC (2026-07) — objeto empresa (datos fiscales)
                          a.empresaObj,
                          // TG3 — observaciones de la entrada
                          a.observaciones,
                          // Nuevos: #Corte, OP, #Artículo, Línea
                          {
                            numeroCorte: a.numeroCorte,
                            numeroOrdenProduccion: a.numeroOrdenProduccion,
                            numeroArticulo: a.numeroArticulo,
                            linea: a.linea,
                          }
                        )
                      }
                    >
                      <i class="far fa-file-pdf"></i>
                    </Button>
                    {/* TG4 — misma info en formato ticket */}
                    <Button
                      size="sm"
                      className="btn ml-1"
                      color="dark"
                      title="Ticket"
                      onClick={(e) =>
                        PDFOCPE_Ticket(
                          a.id,
                          a.numero,
                          a.catalogosProcesosName,
                          a.proveedoresName,
                          a.totalPiezas,
                          a.totalPiezasFaltantes,
                          a.totalPiezasSegundas,
                          a.precio,
                          a.fecha,
                          a.totalGeneral,
                          !!user.crt_pdfPrecios,
                          a.observaciones,
                          {
                            numeroCorte: a.numeroCorte,
                            numeroOrdenProduccion: a.numeroOrdenProduccion,
                            numeroArticulo: a.numeroArticulo,
                            linea: a.linea,
                          }
                        )
                      }
                    >
                      <i class="fas fa-receipt"></i>
                    </Button>
                    {/* (2026-07) Editar entrada: ajusta NotaCxP + saldos proveedor */}
                    <Button
                      size="sm"
                      className="btn ml-1"
                      color="info"
                      title="Editar Entrada"
                      onClick={(e) => jalaEditEntrada(a)}
                    >
                      <i class="fas fa-pen"></i>
                    </Button>
                    {/* (2026-10) PDF de la entrada sin desglose de tallas */}
                    <Button
                      size="sm"
                      className="btn ml-1"
                      color="primary"
                      title="PDF sin tallas (artículo, cantidad y precio)"
                      onClick={() => entradaSinTallasPorEntrada(a.id)}
                    >
                      <i className="fas fa-file-alt"></i>
                    </Button>
                  </td>
                </tr>
              );
            })}
          </Table>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalHabilitacion} toggle={toggleHabilitacion}>
        <ModalHeader toggle={toggleHabilitacion}>
          <h3>Entregar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacion}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  // bsSize="sm"
                  type="date"
                  value={fechaHab}
                  onChange={(event) => {
                    setFechaHab(event.target.value);
                  }}
                ></Input>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFieldsHabilitacion.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={8}>
                    {/* (2026-07) buscador autocomplete de habilitación */}
                    <Autocomplete
                      size="small"
                      options={habilitacion
                        .slice()
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))}
                      getOptionLabel={(o) =>
                        `${o?.nombre || ""} ${o?.descripcion || ""}`.trim()
                      }
                      getOptionSelected={(o, v) =>
                        String(o?._id) === String(v?._id)
                      }
                      value={
                        habilitacion.find(
                          (h) =>
                            String(h._id) === String(inputField.idHabilitacion)
                        ) || null
                      }
                      onChange={(event, sel) => {
                        handleChangeInputHabilitacion(inputField.id, {
                          target: {
                            name: "idHabilitacion",
                            value: sel?._id || "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Buscar habilitación..."
                          variant="outlined"
                        />
                      )}
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacion(inputField.id, event);
                      }}
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFieldsHabilitacion.length === 1}
                      onClick={() =>
                        handleRemoveFieldsHabilitaccion(inputField.id)
                      }
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsHabilitacion}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalEditHab} toggle={toggleEditHab}>
        <ModalHeader toggle={toggleEditHab}>
          <h3>Editar Habilitacion</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveHabilitacionEdit}>
            <Row>
              <Col md={8}>
                <Label className="mr-sm-2">Material</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Anterior</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cantidad Nueva</Label>
              </Col>
            </Row>

            {editHab.map((a) => (
              <div key={a.id}>
                <Row>
                  <Col md={8}>
                    <Input
                      bsSize="sm"
                      name="nombre"
                      type="string"
                      value={a.nombre}
                      disabled
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidadAnterior}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={a.cantidad}
                      onChange={(event) => {
                        handleChangeInputHabilitacionEdit(a.id, event);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </div>
            ))}
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalStatusEdit} toggle={toggleStatusEdit}>
        <ModalHeader toggle={toggleStatusEdit}>
          <h3>Editar Status</h3>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveStatusEdit}>
            <Row>
              <Col md={12}>
                <Label>Status</Label>
                <Input
                  type="select"
                  value={statusHabilitacionEdit}
                  required
                  onChange={(e) => {
                    setStatusHabilitacionEdit(e.target.value);
                  }}
                >
                  <option value="Pendiente">Pendiente</option>
                  <option value="Completo">Completo</option>
                  <option value="Incompleto">Incompleto</option>
                </Input>
              </Col>
            </Row>
            <Row></Row>
            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoCortes;
